{
  "% к прошлой неделе": "% 较上周",
  ". STEOS ID и финансовые квитанции сохраняются.": "。STEOS ID 和财务收据将保留。",
  ". Готовые голоса доступны в разделе «Озвучка» → «Мои».": "。完成的声音可在「配音」→「我的」中找到。",
  ". Он не меняет голос озвучки чата.": "。它不会改变聊天配音的声音。",
  ". После подтверждения обновите профиль.": "。确认后请刷新个人资料。",
  ". Проверьте папку «Спам».": "。请检查「垃圾邮件」文件夹。",
  "Circle каждый месяц по подписке": "每月订阅 Circle",
  "Circle по подписке на этот месяц потрачены": "本月订阅 Circle 已用完",
  "STEOS ID · {0}": "STEOS ID · {0}",
  "STEOS ID · Не подключён": "STEOS ID · 未连接",
  "Telegram ID скопирован.": "Telegram ID 已复制。",
  "{0} {1} C сгорят {2}": "{0} {1} C 将于 {2} 过期",
  "{0} из {1}": "{0} / {1}",
  "{0} фото хватит для сходства": "{0} 张照片即可保证相似度",
  "{0}: {1} работ": "{0}：{1} 个作品",
  "{0}: пока недоступно": "{0}：暂不可用",
  "· Вы и варианты": "· 你和版本",
  "· Новое": "· 新",
  "· занято": "· 已占用",
  "· отменена": "· 已取消",
  "». Обучение начнётся после отдельного нажатия «Повторить обработку» в карточке.": "」。在卡片中单独点击「重新处理」后才会开始训练。",
  "Автовоспроизведение примеров": "自动播放示例",
  "Аккаунт": "账号",
  "Аккаунт подключён": "账号已连接",
  "Архив недоступен или срок ссылки истёк. Можно запросить новую выгрузку.": "存档不可用或链接已过期。可以重新申请导出。",
  "Бабушка": "奶奶",
  "Баланс и вывод доступны в STEOS ID.": "余额和提现可在 STEOS ID 中查看。",
  "Баланс и награды": "余额与奖励",
  "Без имени": "未命名",
  "Бесплатный план": "免费套餐",
  "Ближайшие": "即将到来",
  "Близкие": "亲友",
  "Близкий исчезнет из профиля. Его фото больше не будут доступны для новых работ.": "该亲友将从个人资料中移除，其照片将无法再用于新作品。",
  "Близкий удалён.": "亲友已删除。",
  "Близких пока нет.": "暂无亲友。",
  "Брат": "兄弟",
  "В Steos с": "加入 Steos 时间",
  "В избранное": "加入收藏",
  "Валюта": "货币",
  "Вариант будет удалён. Исходные фото и STEOS ID сохранятся.": "该版本将被删除。原始照片和 STEOS ID 将保留。",
  "Вариантов: {0}": "版本：{0}",
  "Варианты": "版本",
  "Ваш собственный голос": "你自己的声音",
  "Введите УДАЛИТЬ": "输入 УДАЛИТЬ",
  "Введите пароль": "输入密码",
  "Введите почту": "输入邮箱",
  "Вернуться ко входу": "返回登录",
  "Версия": "版本",
  "Версия согласия изменилась. Обновите страницу и подтвердите актуальный текст.": "同意书版本已更新。请刷新页面并确认最新内容。",
  "Версия согласия изменилась. Обновите страницу.": "同意书版本已更新。请刷新页面。",
  "Версия:": "版本：",
  "Взрослый": "成人",
  "Включаем микрофон…": "正在开启麦克风…",
  "Включено": "已开启",
  "Возраст": "年龄",
  "Войти": "登录",
  "Восстановить пароль": "找回密码",
  "Все Circle на балансе без срока": "余额中的 Circle 永不过期",
  "Вы": "你",
  "Вы и близкие": "你和亲友",
  "Вы и варианты": "你和你的形象",
  "Выберите голос": "选择声音",
  "Выберите инструмент и заполните его форму. Готовая работа сохранится в истории.": "选择工具并填写表单。完成的作品会保存在历史中。",
  "Выбран": "已选择",
  "Выбрать голос": "选择声音",
  "Выбрать голос по умолчанию": "选择默认声音",
  "Выбрать из работ": "从作品中选择",
  "Выгрузить мои данные": "导出我的数据",
  "Выгрузка:": "导出：",
  "Выключено": "已关闭",
  "Голос": "声音",
  "Голос готов. Он доступен на вкладке «Мои» в озвучке.": "声音已就绪，可在配音的「我的」标签中找到。",
  "Голос и клон": "声音与克隆",
  "Голос изменился. Данные обновлены — проверьте их перед сохранением.": "声音已变更，数据已更新——保存前请检查。",
  "Голос изменился. Проверьте обновлённые данные перед повторной обработкой.": "声音已变更。重新处理前请检查更新后的数据。",
  "Голос исчезнет из вашего списка. Это действие нельзя отменить.": "该声音将从你的列表中移除。此操作无法撤销。",
  "Голос по умолчанию для создания:": "创建时的默认声音：",
  "Голос принят в обработку. Здесь появится его статус.": "声音已提交处理，状态将显示在这里。",
  "Голос уже удалён или недоступен.": "声音已删除或不可用。",
  "Голос:": "声音：",
  "Голоса не найдены. Откройте каталог или измените поиск.": "未找到声音。请打开目录或修改搜索。",
  "Горизонтальное": "横屏",
  "Готов": "已就绪",
  "Готовим образцы": "正在准备样本",
  "Готово": "完成",
  "Готовые работы": "已完成的作品",
  "Далее": "下一步",
  "Данные Telegram обновлены.": "Telegram 数据已更新。",
  "Данные баланса временно недоступны": "余额数据暂时不可用",
  "Данные переносятся в подтверждённый аккаунт. Старые сессии закрыты; квитанция позволяет продолжить проверку после перезагрузки.": "数据正在转移到已确认的账号。旧会话已关闭；凭借收据可在重新加载后继续验证。",
  "Дедушка": "爷爷",
  "До 5 фото: лицо крупно, при хорошем свете": "最多 5 张照片：脸部特写，光线充足",
  "До пяти фото. Они будут использоваться как ваш образ.": "最多五张照片，将用作你的形象。",
  "Добавить близкого": "添加亲友",
  "Добавить фото": "添加照片",
  "Добавьте ещё": "再添加一些",
  "Добавьте от 2 секунд до 1,5 минуты вашей речи. Говорите естественно, без музыки и других голосов.": "添加 2 秒到 1.5 分钟的语音。自然说话，不要有音乐或其他人声。",
  "Дочь": "女儿",
  "Друг": "朋友",
  "Если аккаунт существует, ссылка для нового пароля отправлена на": "如果账号存在，重置密码的链接已发送至",
  "Ещё варианты": "更多版本",
  "Ещё операции": "更多交易",
  "Ещё работы": "更多作品",
  "Жена": "妻子",
  "ЗАМЕНА ОБРАЗЦОВ": "替换样本",
  "Забыли пароль?": "忘记密码？",
  "Загружаем аккаунт…": "正在加载账号…",
  "Загружаем варианты…": "正在加载版本…",
  "Загружаем ваши голоса…": "正在加载你的声音…",
  "Загружаем голоса…": "正在加载声音…",
  "Загружаем настройки…": "正在加载设置…",
  "Загружаем обновления…": "正在加载更新…",
  "Загружаем операции…": "正在加载交易…",
  "Загружаем пример…": "正在加载示例…",
  "Загружаем работы…": "正在加载作品…",
  "Загружаем фото…": "正在加载照片…",
  "Загрузить аудиофайлы": "上传音频文件",
  "Загрузить выбранные фото": "上传所选照片",
  "Загрузка ещё не подтверждена. Нажмите «Продолжить отправку»: сначала проверим прежнюю загрузку.": "上传尚未确认。点击「继续发送」：我们会先检查之前的上传。",
  "Загрузка не подтверждена. Продолжение сначала проверит прежние загрузки.": "上传未确认。继续时会先检查之前的上传。",
  "Загрузка отклонена. Нажмите «Продолжить отправку», чтобы получить новую ссылку и загрузить образец.": "上传被拒绝。点击「继续发送」以获取新链接并上传样本。",
  "Закрыть": "关闭",
  "Закрыть мастер": "关闭向导",
  "Заменить образцы": "替换样本",
  "Записать с микрофона": "用麦克风录制",
  "Запись": "录音",
  "Запись здесь недоступна. Откройте приложение по HTTPS или загрузите аудиофайл.": "此处无法录音。请通过 HTTPS 打开应用或上传音频文件。",
  "Запись прервалась. Попробуйте ещё раз или загрузите файл.": "录音中断。请重试或上传文件。",
  "Запись-{0}.{1}": "录音-{0}.{1}",
  "Запишите образец, дождитесь обучения и озвучивайте текст своим голосом.": "录制样本，等待训练完成，即可用自己的声音配音。",
  "Запишите речь или загрузите аудиофайлы": "录制语音或上传音频文件",
  "Запишите свой голос один раз — используйте его в озвучке.": "录一次你的声音，即可用于配音。",
  "Запрос сохранён. Продолжение проверит прежний запрос и не создаст второй голос.": "请求已保存。继续时会检查之前的请求，不会创建第二个声音。",
  "Запустить обработку": "开始处理",
  "Здесь появятся ваши работы": "你的作品将显示在这里",
  "Из них": "其中",
  "Из них {0} C можно вывести": "其中 {0} C 可提现",
  "Избранное": "收藏",
  "Избранные работы": "收藏的作品",
  "Изменение не подтверждено. Проверьте актуальную карточку перед повтором.": "更改未确认。重试前请检查当前卡片。",
  "Изменить": "修改",
  "Изменить близкого": "修改亲友",
  "Изменить вариант": "修改版本",
  "Изменить голос": "更换声音",
  "Изменить мои фото": "修改我的照片",
  "Имя близкого": "亲友姓名",
  "Имя голоса": "声音名称",
  "Имя пользователя не задано": "未设置用户名",
  "Использовать как себя": "作为自己使用",
  "Используем сохранённые образцы голоса «": "正在使用已保存的声音样本「",
  "Используйте свои фото и фото близких в инструментах студии.": "在工作室工具中使用你和亲友的照片。",
  "История очищена: {0} работ, {1} заказов.": "历史已清空：{0} 个作品，{1} 个订单。",
  "КЛОН ГОЛОСА": "声音克隆",
  "Каждый образец должен содержать хотя бы одну секунду речи.": "每个样本至少要包含一秒语音。",
  "Как в системе": "跟随系统",
  "Как пользоваться": "使用方法",
  "Как снимать": "拍摄方法",
  "Каталог голосов": "声音目录",
  "Квадрат": "方形",
  "Кем приходится": "关系",
  "Ко входу": "返回登录",
  "Количество вариантов пока недоступно": "暂时无法获取版本数量",
  "Конфиденциальность": "隐私",
  "Копирование недоступно. ID показан в карточке аккаунта.": "无法复制。ID 显示在账号卡片中。",
  "Кружок с героем": "角色圆形视频",
  "Лимит {0} голосов выбран": "已达 {0} 个声音的上限",
  "Лимит голосов выбран. Удалите ненужный голос, чтобы добавить новый.": "声音数量已达上限。删除不需要的声音后才能添加新的。",
  "Лимит:": "上限：",
  "Мама": "妈妈",
  "Можно добавить до {0} образцов.": "最多可添加 {0} 个样本。",
  "Можно закрыть приложение. Статус обновится после обработки.": "可以关闭应用，处理完成后状态会更新。",
  "Мои варианты": "我的版本",
  "Мои голоса": "我的声音",
  "Мои данные": "我的数据",
  "Мои фото": "我的照片",
  "Моё": "我的",
  "Моё фото": "我的照片",
  "Муж": "丈夫",
  "НОВЫЙ ГОЛОС": "新声音",
  "Награды": "奖励",
  "Награды и задания": "奖励与任务",
  "Назад": "返回",
  "Название варианта": "版本名称",
  "Назначить голос": "指定声音",
  "Настройки": "设置",
  "Настройки уже изменились. Показана актуальная версия.": "设置已被更改，当前显示的是最新版本。",
  "Начните с 2 секунд речи в тихом месте.": "先在安静的地方录 2 秒语音。",
  "Не больше 5 фото JPEG или PNG, до 10 МБ каждое.": "最多 5 张 JPEG 或 PNG 照片，每张不超过 10 MB。",
  "Не задано": "未设置",
  "Не короче 8 знаков": "至少 8 个字符",
  "Не удалось включить микрофон. Разрешите доступ или загрузите файл.": "无法开启麦克风。请允许访问或上传文件。",
  "Не удалось войти. Откройте приложение из Telegram заново.": "登录失败。请从 Telegram 重新打开应用。",
  "Не удалось воспроизвести пример. Откройте карточку заново и попробуйте ещё раз.": "无法播放示例。请重新打开卡片后再试。",
  "Не удалось загрузить варианты.": "无法加载版本。",
  "Не удалось загрузить голоса. Измените поиск или вкладку, чтобы повторить.": "无法加载声音。修改搜索或切换标签以重试。",
  "Не удалось загрузить настройки. Попробуйте обновить.": "无法加载设置。请尝试刷新。",
  "Не удалось загрузить работы.": "无法加载作品。",
  "Не удалось загрузить следующую страницу.": "无法加载下一页。",
  "Не удалось загрузить следующую страницу. Попробуйте ещё раз.": "无法加载下一页，请重试。",
  "Не удалось обновить данные из Telegram. Попробуйте позже.": "无法从 Telegram 更新数据，请稍后再试。",
  "Не удалось подтвердить изменение избранного. Обновите профиль.": "无法确认收藏更改。请刷新个人资料。",
  "Не удалось подтвердить операцию. Проверьте состояние аккаунта перед повтором.": "无法确认操作。重试前请检查账号状态。",
  "Не удалось подтвердить сохранение. Обновите настройки перед повтором.": "无法确认保存。重试前请刷新设置。",
  "Не удалось подтвердить удаление близкого. Обновите профиль.": "无法确认删除亲友。请刷新个人资料。",
  "Не удалось получить ответ. Попробуйте ещё раз — запрос продолжится с прежним ключом.": "未收到响应。请重试——请求将使用原有密钥继续。",
  "Не удалось проверить выгрузку. Обновите страницу: продолжим прежнюю операцию.": "无法检查导出。请刷新页面，我们将继续之前的操作。",
  "Не удалось прочитать запись.": "无法读取录音。",
  "Не удалось создать голос. Откройте карточку, чтобы проверить статус или повторить обработку.": "无法创建声音。打开卡片查看状态或重新处理。",
  "Не удалось создать голос. Проверьте данные и образцы.": "无法创建声音。请检查数据和样本。",
  "Не удалось сохранить просмотр. Можно закрыть и вернуться позже.": "无法保存浏览记录。可以先关闭，稍后再回来。",
  "Неверная почта или пароль": "邮箱或密码错误",
  "Нет работ": "暂无作品",
  "Новая выгрузка": "新导出",
  "Новости": "新闻",
  "Новый вариант": "新版本",
  "Новый голос": "新声音",
  "Новых публикаций пока нет.": "暂无新发布。",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме.": "语音总长需在 2 秒到 1.5 分钟之间。",
  "О приложении": "关于应用",
  "Обновить": "刷新",
  "Обновить варианты": "刷新版本",
  "Обновить из Telegram": "从 Telegram 更新",
  "Обновить настройки": "刷新设置",
  "Обновить профиль": "刷新个人资料",
  "Обновить работы": "刷新作品",
  "Обновления": "更新",
  "Обновляем вход…": "正在刷新登录…",
  "Обрабатывается": "处理中",
  "Образ готов": "形象已就绪",
  "Образ ещё не собран": "形象尚未生成",
  "Образец {0}": "样本 {0}",
  "Образец голоса": "声音样本",
  "Образец ещё не проверен. Подождите и продолжите отправку.": "样本尚未检查。请稍候再继续发送。",
  "Образец не прошёл проверку. Выберите другую запись.": "样本未通过检查。请选择其他录音。",
  "Образцы готовы к повторной обработке.": "样本已可重新处理。",
  "Образцы для «": "样本「",
  "Образцы обновлены. Нажмите «Повторить обработку», чтобы обучить голос заново.": "样本已更新。点击「重新处理」重新训练声音。",
  "Обучаем голос": "正在训练声音",
  "Общая длительность образцов не должна превышать 1,5 минуты.": "样本总时长不能超过 1.5 分钟。",
  "Объединение STEOS ID": "合并 STEOS ID",
  "Объединяем аккаунты": "正在合并账号",
  "Объём образцов": "样本时长",
  "Один аккаунт для бота и сайта STEOS": "STEOS 机器人和网站共用一个账号",
  "Озвучить текст голосом «": "用声音「",
  "Операции": "交易记录",
  "Операции в токенах STEOS ID": "STEOS ID 代币交易",
  "Операции временно недоступны.": "交易记录暂时不可用。",
  "Операций пока нет.": "暂无交易记录。",
  "Операция не подтверждена. Повтор использует прежний ключ.": "操作未确认。重试将使用原有密钥。",
  "Описание": "描述",
  "Описание и согласие": "描述与同意",
  "Остановить запись ·": "停止录音 ·",
  "Остаток Circle недоступен": "无法获取 Circle 余额",
  "Отклик": "触感反馈",
  "Откройте ссылку из письма и задайте новый пароль на id.steos.io. Потом войдите здесь.": "打开邮件中的链接，在 id.steos.io 设置新密码，然后在这里登录。",
  "Откройте ссылку подтверждения для": "请打开确认链接，邮箱：",
  "Открыть id.steos.io": "打开 id.steos.io",
  "Открыть историю": "打开历史",
  "Отмена": "取消",
  "Отметьте согласие с условиями": "请勾选同意条款",
  "Отправить ссылку": "发送链接",
  "Отправляем…": "正在发送…",
  "Оформить подписку": "开通订阅",
  "Оформление": "外观",
  "Очистить историю": "清空历史",
  "Очистить историю?": "清空历史？",
  "Очистка не подтверждена. Повтор проверит прежнюю операцию.": "清空未确认。重试时会检查之前的操作。",
  "Очищаем…": "正在清空…",
  "Ошибка": "错误",
  "Папа": "爸爸",
  "Пароль": "密码",
  "Переименовать вариант": "重命名版本",
  "Перенос ещё не подтверждён. Квитанция сохранена; проверка продолжится.": "转移尚未确认。收据已保存，验证将继续。",
  "Перенос завершён, обновляем вход…": "转移完成，正在刷新登录…",
  "Переносим данные в существующий STEOS ID. После переноса приложение обновит сессию. Не запускайте повторное объединение.": "正在将数据转移到现有的 STEOS ID。转移完成后应用会刷新会话。请勿再次发起合并。",
  "Письмо отправлено": "邮件已发送",
  "Питомец": "宠物",
  "Повторить загрузку": "重新加载",
  "Повторить обработку": "重新处理",
  "Подготовить ZIP для скачивания": "准备 ZIP 以供下载",
  "Поддержка": "支持",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже или откройте сайт STEOS ID.": "暂时无法连接 STEOS ID。请稍后再试或打开 STEOS ID 网站。",
  "Подключён": "已连接",
  "Подключён:": "已连接：",
  "Подруга": "女性朋友",
  "Подтвердите почту": "请确认邮箱",
  "Подтвердите согласие перед отправкой образцов.": "发送样本前请确认同意。",
  "Подтвердить очистку истории": "确认清空历史",
  "Подтвердить удаление": "确认删除",
  "Подтвердить удаление аккаунта": "确认删除账号",
  "Подтвердить удаление близкого": "确认删除亲友",
  "Подтвердить удаление варианта": "确认删除版本",
  "Поиск голоса": "搜索声音",
  "Поиск по имени": "按名称搜索",
  "Пока нет своих голосов": "还没有自己的声音",
  "Показать ещё": "显示更多",
  "Показать ещё голоса": "显示更多声音",
  "Показать пароль": "显示密码",
  "Пополнить": "充值",
  "Попробовать": "试一试",
  "Портрет": "竖屏",
  "Пост": "帖子",
  "Потрачено Circle:": "已花费 Circle：",
  "Почта": "邮箱",
  "Почта уже занята": "邮箱已被占用",
  "Почта уже занята, войдите с ней": "邮箱已被占用，请用它登录",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Расскажу, как прошёл мой день, что меня порадовало и какие планы у меня на завтра. Продолжайте говорить своими словами не меньше тридцати секунд.": "你好！这是为我的声音录制的样本。我说话平静，语速正常，就像和朋友聊天一样。我会讲讲今天过得怎么样、什么让我开心，以及明天有什么计划。请用自己的话继续说至少三十秒。",
  "Приглашайте друзей": "邀请好友",
  "Пример голоса {0}": "声音示例 {0}",
  "Принимаю": "我同意",
  "Присылать готовые работы в чат": "将完成的作品发送到聊天",
  "Проверен": "已验证",
  "Проверить выгрузку": "检查导出",
  "Проверить подтверждение": "检查确认状态",
  "Проверка голоса не пройдена. Запишите образец без музыки и других людей.": "声音检查未通过。请录制不含音乐和他人声音的样本。",
  "Проверка образцов не пройдена. Попробуйте чистую запись одного голоса.": "样本检查未通过。请尝试只含一个人声的干净录音。",
  "Проверьте адрес": "请检查地址",
  "Проверяем запись": "正在检查录音",
  "Проверяем образец {0} из {1}…": "正在检查样本 {0}/{1}…",
  "Проверяем состояние переноса…": "正在检查转移状态…",
  "Проверяем…": "正在检查…",
  "Проверяйте остаток в профиле и получайте доступные награды.": "在个人资料中查看余额并领取可用奖励。",
  "Продолжим проверку прежнего запроса, без повторного запуска.": "我们将继续检查之前的请求，不会重新发起。",
  "Продолжим сохранённый запрос с теми же данными.": "我们将使用相同数据继续已保存的请求。",
  "Продолжить отправку": "继续发送",
  "Продолжить проверку": "继续验证",
  "Продолжить создание голоса": "继续创建声音",
  "Продолжить сохранение": "继续保存",
  "Прослушать {0}": "试听 {0}",
  "Профиль": "个人资料",
  "Профиль «Вы» пока недоступен.": "「你」的个人资料暂不可用。",
  "Профиль уже изменился. Закройте форму и откройте актуальную версию.": "个人资料已被更改。请关闭表单并打开最新版本。",
  "Работ в этом списке пока нет.": "此列表中暂无作品。",
  "Работа №": "作品编号",
  "Работы и параметры заказов исчезнут из истории. Голоса, варианты «Вы» и близкие останутся. Финансовые квитанции сохраняются. Вернуть историю нельзя.": "作品和订单参数将从历史中移除。声音、「你」的版本和亲友会保留，财务收据也会保留。历史无法恢复。",
  "Работы по неделям": "每周作品",
  "Раздел профиля": "个人资料分区",
  "Разделы профиля": "个人资料分区",
  "Размер каждого образца должен быть от 1 байта до 20 МБ.": "每个样本大小需在 1 字节到 20 MB 之间。",
  "Ребёнок": "孩子",
  "Результат обработки уточняется. Повторный запуск пока недоступен.": "处理结果正在确认中，暂时无法重新处理。",
  "Русский": "Русский",
  "С": "从",
  "Сбросить голос по умолчанию": "重置默认声音",
  "Светлая": "浅色",
  "Свой аватар": "自定义头像",
  "Сгорят {0}, если не потратить": "未使用将于 {0} 过期",
  "Сделать кружок": "制作圆形视频",
  "Серия:": "系列：",
  "Сестра": "姐妹",
  "Скачать ZIP": "下载 ZIP",
  "Скопировать Telegram ID": "复制 Telegram ID",
  "Скорость речи": "语速",
  "Скрыть пароль": "隐藏密码",
  "Слишком много запросов. Подождите немного и попробуйте ещё раз.": "请求过多。请稍等后重试。",
  "Слишком много попыток. Попробуйте позже.": "尝试次数过多，请稍后再试。",
  "Снимайте лицо без фильтров и тёмных очков, при ровном освещении. Добавьте разные ракурсы. В кадре должен быть один человек.": "拍摄脸部时不要用滤镜、不戴墨镜，光线均匀。添加不同角度。画面中只能有一个人。",
  "Снять голос": "录制声音",
  "Снять фото": "拍照",
  "Согласие изменилось до начала обучения. Обновите страницу и подтвердите актуальную версию перед повторной обработкой.": "同意书在训练开始前已更改。重新处理前请刷新页面并确认最新版本。",
  "Создавайте говорящие кружки с выбранным персонажем или своим образом.": "用所选角色或你自己的形象制作会说话的圆形视频。",
  "Создание": "创建",
  "Создание голосов временно недоступно. Образцы сохранены в этом окне.": "暂时无法创建声音。样本已保存在此窗口中。",
  "Создание новых голосов пока недоступно. Уже созданные голоса доступны ниже.": "暂时无法创建新声音。已创建的声音见下方。",
  "Создано:": "创建于：",
  "Создан {0}": "创建于 {0}",
  "Создать аккаунт": "创建账号",
  "Создать голос": "创建声音",
  "Создаём голос…": "正在创建声音…",
  "Сохранение настроек создания сейчас выключено.": "保存创建设置功能目前已关闭。",
  "Сохранение не подтверждено. Закройте форму и проверьте актуальный профиль.": "保存未确认。请关闭表单并检查最新的个人资料。",
  "Сохранение не подтверждено. Повтор создания использует прежний запрос.": "保存未确认。重新创建将使用之前的请求。",
  "Сохранение недоступно.": "无法保存。",
  "Сохранено": "已保存",
  "Сохранить": "保存",
  "Сохранить близкого": "保存亲友",
  "Сохранить вариант": "保存版本",
  "Сохранить голос по умолчанию": "保存默认声音",
  "Сохранить мои фото": "保存我的照片",
  "Сохранить образцы": "保存样本",
  "Сохраняем образцы…": "正在保存样本…",
  "Сохраняем…": "正在保存…",
  "Сохранённые варианты себя доступны в профиле и инструментах создания.": "已保存的个人版本可在个人资料和创建工具中使用。",
  "Сохранённых вариантов пока нет.": "暂无已保存的版本。",
  "Сроки партий Circle временно недоступны": "Circle 批次有效期暂时不可用",
  "Старший": "年长",
  "Статистика": "统计",
  "Статистика по неделям временно недоступна.": "每周统计暂时不可用。",
  "Статус удаления временно недоступен. Квитанция сохранена в этой вкладке.": "删除状态暂时不可用。收据已保存在此标签页中。",
  "Сторис": "快拍",
  "Сын": "儿子",
  "Тариф": "套餐",
  "Текст для чтения": "朗读文本",
  "Тема": "主题",
  "Тема сохраняется на этом устройстве.": "主题保存在此设备上。",
  "Тёмная": "深色",
  "У меня есть право использовать эти фотографии и согласие изображённых людей.": "我有权使用这些照片，并已获得照片中人物的同意。",
  "УДАЛИТЬ": "УДАЛИТЬ",
  "Убираем шум": "正在去除噪音",
  "Убрать": "移除",
  "Убрать {0}": "移除 {0}",
  "Убрать из избранного": "取消收藏",
  "Убрать фоновый шум": "去除背景噪音",
  "Убрать фото": "移除照片",
  "Уведомления": "通知",
  "Уведомления недоступны.": "通知不可用。",
  "Уведомления пока недоступны.": "通知暂不可用。",
  "Удаление аккаунта Mini App": "删除 Mini App 账号",
  "Удаление:": "删除：",
  "Удалить": "删除",
  "Удалить «": "删除「",
  "Удалить «{0}»?": "删除「{0}」？",
  "Удалить аккаунт Mini App": "删除 Mini App 账号",
  "Удалить близкого": "删除亲友",
  "Удалить вариант": "删除版本",
  "Удалить голос": "删除声音",
  "Удаляем…": "正在删除…",
  "Удаляется": "删除中",
  "Українська": "Українська",
  "Условия использования": "使用条款",
  "Файл": "文件",
  "Формат": "格式",
  "Фото Telegram": "Telegram 照片",
  "Фото {0}": "照片 {0}",
  "Фото и имя берутся из вашего профиля в Telegram. Если вы их сменили, обновите данные здесь.": "照片和名字取自你的 Telegram 资料。如果已更改，请在这里更新。",
  "Фото и фотосессия": "照片与写真",
  "Фото перед загрузкой": "上传前的照片",
  "Фото профиля": "个人资料照片",
  "Фото профиля Telegram": "Telegram 个人资料照片",
  "Фото, голоса, близкие и данные Mini App будут удалены во всех сервисах. STEOS ID и финансовые квитанции останутся. Отменить удаление нельзя.": "照片、声音、亲友和 Mini App 数据将在所有服务中删除。STEOS ID 和财务收据会保留。删除无法撤销。",
  "Фото:": "照片：",
  "Часть профиля временно недоступна. Попробуйте обновить.": "部分个人资料暂时不可用，请尝试刷新。",
  "Читаем аудиофайлы…": "正在读取音频文件…",
  "Что нового": "新功能",
  "Что нового пока не опубликовано или временно недоступно.": "新功能尚未发布或暂时不可用。",
  "Что нового пока не опубликовано.": "新功能尚未发布。",
  "Шаблоны": "模板",
  "Шаблоны и рилс": "模板与 Reels",
  "Эта неделя": "本周",
  "Этот голос используется:": "此声音的使用位置：",
  "Этот запуск пока нельзя повторить. Обновите статус голоса.": "此次运行暂时无法重试。请刷新声音状态。",
  "Этот формат не поддерживается. Выберите MP3, WAV, M4A, OGG или WebM.": "不支持此格式。请选择 MP3、WAV、M4A、OGG 或 WebM。",
  "Язык аккаунта": "账号语言",
  "готова": "已完成",
  "готова частично": "部分完成",
  "дата недоступна": "日期不可用",
  "для переозвучки": "用于重新配音",
  "до {0}, потом {1}": "至 {0}，之后 {1}",
  "другой тариф": "其他套餐",
  "закончится {0}": "{0} 到期",
  "и": "和",
  "из": "/",
  "из 1:30 · минимум 0:02": "/ 1:30 · 最少 0:02",
  "лимит уточняется": "上限确认中",
  "не задан": "未设置",
  "не назначен": "未指定",
  "новых": "新",
  "образец": "样本",
  "образца": "样本",
  "образцов": "样本",
  "оплачено до {0}": "已付费至 {0}",
  "подарок до {0}": "赠送至 {0}",
  "пока недоступно": "暂不可用",
  "политику конфиденциальности STEOS": "STEOS 隐私政策",
  "продлится {0}": "{0} 续订",
  "речи.": "语音。",
  "токенов": "代币",
  "условия": "条款",
  "уточняется": "确认中",
  "Қазақша": "Қазақша",
  "← Профиль": "← 个人资料",
  "▶ Прослушать": "▶ 试听",
  "Озвучка": "配音",
  "Клон": "声音克隆",
  "Студия": "工作室",
  "Баланс": "余额",
  "История": "历史",
  "Ещё": "更多",
  "Клонирование голоса": "声音克隆",
  "Партнёрство": "合作伙伴计划",
  "Добавить в чат": "添加到聊天",
  "Разделы": "分区",
  "Главное меню": "主菜单",
  "Выберите": "选择",
  "После объединения сохранены все фото. Оставьте до пяти, чтобы изменить образ.": "合并后所有照片都已保留。保留最多五张即可更改形象。",
  "Абзацы": "段落",
  "Альбом": "相册",
  "Аудио": "音频",
  "Без изменения": "不变",
  "Бесплатно по текущему тестовому dev-тарифу.": "按当前测试 dev 套餐免费。",
  "Бесплатно по тестовому dev-тарифу": "按测试 dev 套餐免费",
  "В избранном пока пусто": "收藏夹暂时为空",
  "В очереди": "排队中",
  "Вариант {0}": "版本 {0}",
  "Введите текст до 1000 символов": "输入不超过 1000 个字符的文本",
  "Вернули": "已退还",
  "Вернуть запись в историю не получится. Файл в чате останется.": "该记录无法恢复到历史中。聊天中的文件会保留。",
  "Видео": "视频",
  "Виды работ": "作品类型",
  "Все": "全部",
  "Вчера": "昨天",
  "Выбранный вариант": "所选版本",
  "Выбранный вариант недоступен. Вернитесь в профиль и обновите список.": "所选版本不可用。请返回个人资料并刷新列表。",
  "Выполняется": "进行中",
  "Высота голоса": "音高",
  "Говорящее видео": "会说话的视频",
  "Голоса": "声音",
  "Дата неизвестна": "日期未知",
  "Длительность": "时长",
  "Для этого действия пока нет доступного опубликованного инструмента.": "此操作暂无可用的已发布工具。",
  "Дополнительное поле": "附加字段",
  "Заголовок": "标题",
  "Загружаем историю…": "正在加载历史…",
  "Загружаем работу…": "正在加载作品…",
  "Загружаем результат…": "正在加载结果…",
  "Загружаем…": "正在加载…",
  "Загружено": "已上传",
  "Загрузка не подтверждена. Продолжите проверку этого файла.": "上传未确认。请继续检查此文件。",
  "Заказ": "订单",
  "Заказ не подтверждён. Продолжение проверит прежний запрос с тем же ключом.": "订单未确认。继续时会用同一密钥检查之前的请求。",
  "Заменить файл": "替换文件",
  "Избранное: {0}": "收藏：{0}",
  "Инструмент обновляется. Обновите форму позже.": "工具正在更新，请稍后刷新表单。",
  "Искать в {0} работах": "在 {0} 个作品中搜索",
  "Искать в истории": "在历史中搜索",
  "Использовать фото выбранного варианта": "使用所选版本的照片",
  "Используется выбранный голос.": "正在使用所选声音。",
  "Исход генерации уточняется. Новая работа автоматически не запускается.": "生成结果正在确认中，不会自动开始新作品。",
  "К инструментам": "前往工具",
  "Кавер": "翻唱",
  "Карусель": "轮播",
  "Ключевые слова": "关键词",
  "Коллаж": "拼贴",
  "Кратко": "简要",
  "Кружки": "圆形视频",
  "Кружок": "圆形视频",
  "Кто в кадре": "画面中的人",
  "Название": "名称",
  "Не получилось": "失败",
  "Не удалось выполнить": "无法完成",
  "Не удалось выполнить действие с этой работой. Обновите её и попробуйте снова.": "无法对该作品执行此操作。请刷新后重试。",
  "Не удалось завершить создание. Попробуйте изменить настройки.": "无法完成创建。请尝试修改设置。",
  "Не удалось загрузить историю. Попробуйте ещё раз.": "无法加载历史，请重试。",
  "Не удалось загрузить студию.": "无法加载工作室。",
  "Не удалось загрузить фото варианта. Обновите профиль.": "无法加载版本照片。请刷新个人资料。",
  "Не удалось обработать запись": "无法处理录音",
  "Не удалось озвучить текст": "无法为文本配音",
  "Не удалось открыть инструмент. Попробуйте обновить.": "无法打开工具，请尝试刷新。",
  "Не удалось открыть результат. Попробуйте снова.": "无法打开结果，请重试。",
  "Не удалось отправить результат. Повторите отправку.": "无法发送结果，请重新发送。",
  "Не удалось связаться с сервисом. Попробуйте ещё раз.": "无法连接服务，请重试。",
  "Не удалось скопировать. Выделите текст вручную.": "无法复制，请手动选择文本。",
  "Не удалось сохранить отправку. Разрешите хранилище вкладки и попробуйте ещё раз.": "无法保存发送记录。请允许此标签页使用存储后重试。",
  "Некоторые файлы повтора больше недоступны. Загрузите их заново.": "部分重做所需的文件已不可用，请重新上传。",
  "Ничего не нашли": "未找到结果",
  "Нужно разных фото": "需要不同的照片",
  "Обрабатываем запись": "正在处理录音",
  "Озвучиваем текст": "正在为文本配音",
  "Озвучить": "配音",
  "Озвучка готова": "配音已完成",
  "Озвучка проекта": "项目配音",
  "Оплата": "付款",
  "Оплачено донатом": "已通过打赏支付",
  "Определить автоматически": "自动识别",
  "Основа": "基础",
  "Открыть результат": "打开结果",
  "Отменено": "已取消",
  "Отправить в чат": "发送到聊天",
  "Отправка не принята. Проверьте сообщение об ошибке.": "发送未被接受。请查看错误信息。",
  "Отправка принята. Бот доставит результат в чат.": "发送已接受，机器人会将结果发到聊天中。",
  "Отправлено": "已发送",
  "Переозвучить запись": "重新配音录音",
  "Переозвучка": "重新配音",
  "Персонаж": "角色",
  "Площадка": "平台",
  "Повтори движения": "模仿动作",
  "Повторить": "重试",
  "Подпись": "说明文字",
  "Подтверждаю право использовать загружаемые материалы": "我确认有权使用上传的素材",
  "Подтверждаю право использовать эти фото и согласие изображённых людей на создание варианта": "我确认有权使用这些照片，并已获得照片中人物同意创建版本",
  "Поиск в истории": "在历史中搜索",
  "Показатели истории": "历史统计",
  "Показатели истории временно недоступны": "历史统计暂时不可用",
  "Показать все работы": "显示全部作品",
  "Показать текст": "显示文本",
  "Порядок": "顺序",
  "Почистить запись": "清理录音",
  "Прежний голос недоступен. Выберите другой голос.": "之前的声音不可用，请选择其他声音。",
  "Преимущества": "优势",
  "Проверьте заполненные поля. Заказ не создан.": "请检查已填写的字段。订单未创建。",
  "Проверяем итог операции": "正在确认操作结果",
  "Проверяем отправку…": "正在检查发送…",
  "Проверяем результат": "正在确认结果",
  "Проверяем списание токенов": "正在检查代币扣除",
  "Продолжить проверку озвучки": "继续检查配音",
  "Работ пока нет": "暂无作品",
  "Работ: {0}": "作品：{0}",
  "Работа": "作品",
  "Работа больше не найдена. Обновите историю.": "作品已找不到，请刷新历史。",
  "Работа из истории": "历史中的作品",
  "Работа не прошла проверку.": "作品未通过检查。",
  "Работа обновилась. Загрузите её ещё раз.": "作品已更新，请重新加载。",
  "Распознавание": "识别",
  "Распознанный текст": "识别的文本",
  "Распознать речь": "识别语音",
  "Расшифровка": "转写",
  "Режим озвучки": "配音模式",
  "Результат": "结果",
  "Результат больше недоступен": "结果已不可用",
  "Результат операции уточняется. Повторный запуск отключён.": "操作结果正在确认中，已禁用重新运行。",
  "Результат отправки пока неизвестен. Повторите проверку.": "发送结果尚未知晓，请再次检查。",
  "Результат отправки пока неизвестен. Повторите с тем же ключом.": "发送结果尚未知晓，请用同一密钥重试。",
  "Результат переозвучки": "重新配音结果",
  "Результат работы": "作品结果",
  "Реплики": "台词",
  "Речевая запись": "语音录音",
  "Рилс": "Reels",
  "Сегодня": "今天",
  "Сейчас создаётся": "正在创建",
  "Сервис сейчас недоступен.": "服务暂时不可用。",
  "Сессия истекла. Откройте приложение заново.": "会话已过期，请重新打开应用。",
  "Синтез": "合成",
  "Скачать": "下载",
  "Скачать все файлы": "下载全部文件",
  "Скачать набор": "下载合集",
  "Скопировано": "已复制",
  "Скопировать": "复制",
  "Слайды": "幻灯片",
  "Слишком много запросов. Подождите немного.": "请求过多，请稍等。",
  "Слушать результат": "收听结果",
  "Смена голоса": "变声",
  "Сначала новые": "最新优先",
  "Сначала старые": "最早优先",
  "Создать": "创建",
  "Создаётся": "创建中",
  "Списано": "已扣除",
  "Статус пока не подтверждён. Проверяем прежний заказ.": "状态尚未确认，正在检查之前的订单。",
  "Статус текущих заказов временно недоступен": "当前订单状态暂时不可用",
  "Стиль": "风格",
  "Стоимость": "费用",
  "Сцена": "场景",
  "Съёмка": "拍摄",
  "Текст": "文本",
  "Текст для озвучки": "配音文本",
  "Текст песни": "歌词",
  "Текст поста": "帖子文本",
  "Товар": "商品",
  "Удалить из истории": "从历史中删除",
  "Удалить из истории?": "从历史中删除？",
  "Уточняем результат": "正在确认结果",
  "Уточняем состояние сохранённого заказа…": "正在确认已保存订单的状态…",
  "Файл в чате останется": "聊天中的文件会保留",
  "Файлов: {0}": "文件：{0}",
  "Форма недоступна.": "表单不可用。",
  "Формат отправки": "发送格式",
  "Фото": "照片",
  "Фотосессии": "写真",
  "Фотосессия": "写真",
  "Фотосессия товара": "商品写真",
  "Части": "部分",
  "Шаблон": "模板",
  "Эта работа недоступна вашему аккаунту.": "你的账号无法访问此作品。",
  "Это вся история": "这是全部历史",
  "Этот инструмент сейчас недоступен. Попробуйте обновить форму.": "此工具暂时不可用，请尝试刷新表单。",
  "Язык записи": "录音语言",
  "MP3 · пауза между репликами 0,6 с": "MP3 · 台词间隔 0.6 秒",
  "{0} / 1 000 знаков": "{0} / 1000 字",
  "{0} / 20 000 знаков · версия {1}": "{0} / 20000 字 · 版本 {1}",
  "{0} реплик": "{0} 句台词",
  "{0} ролей · {1} новых реплик": "{0} 个角色 · {1} 句新台词",
  "Аудио больше недоступно. Обновите статус проекта.": "音频已不可用，请刷新项目状态。",
  "Буфер недоступен. Вставьте текст в поле вручную.": "剪贴板不可用，请手动将文本粘贴到输入框。",
  "В проекте должно быть от 1 до 50 ролей.": "项目须有 1 到 50 个角色。",
  "В проекте может быть не больше 500 реплик.": "项目最多可有 500 句台词。",
  "Вставить из буфера": "从剪贴板粘贴",
  "Вставить сценарий": "粘贴剧本",
  "Выберите голос для каждой непустой роли.": "请为每个非空角色选择声音。",
  "Выше": "上移",
  "Голос {0}": "声音 {0}",
  "Голос роли": "角色声音",
  "Готовим аудио…": "正在准备音频…",
  "Добавить {0} реплик": "添加 {0} 句台词",
  "Добавьте реплику или вставьте сценарий.": "添加台词或粘贴剧本。",
  "Дождитесь загрузки общего файла и попробуйте ещё раз.": "请等待合并文件加载完成后重试。",
  "Дублировать": "复制一份",
  "Загружаем аудио…": "正在加载音频…",
  "Загружаем проекты…": "正在加载项目…",
  "Загрузить версию сервера": "加载服务器版本",
  "Закрыть раздел без сохранения изменений?": "不保存更改就关闭此分区？",
  "Заменить текущие роли и реплики?": "替换当前的角色和台词？",
  "Заменить текущий сценарий": "替换当前剧本",
  "Изменить сценарий": "修改剧本",
  "Имя роли": "角色名称",
  "Кто говорит": "谁在说话",
  "Мои проекты": "我的项目",
  "Нажмите воспроизведение в плеере, чтобы разрешить звук.": "请在播放器中点击播放以允许声音。",
  "Название проекта": "项目名称",
  "Название слишком длинное.": "名称太长。",
  "Не удалось восстановить операции. Не запускайте озвучку повторно; проверьте историю.": "无法恢复操作。请勿再次发起配音，请查看历史。",
  "Не удалось выполнить действие. Изменения остаются на экране.": "操作失败。更改仍保留在屏幕上。",
  "Не удалось загрузить аудио. Проверьте соединение и попробуйте ещё раз.": "无法加载音频。请检查网络后重试。",
  "Не удалось озвучить проект": "无法为项目配音",
  "Не удалось подготовить аудио. Проверьте реплику и выбранный голос.": "无法准备音频。请检查台词和所选声音。",
  "Не удалось проверить владельца проекта. Обновите страницу.": "无法验证项目所有者，请刷新页面。",
  "Не удалось связаться с сервером. Проверьте соединение и повторите попытку.": "无法连接服务器。请检查网络后重试。",
  "Не хватает Circle. Пополните баланс и повторите действие.": "Circle 不足。请充值后重试。",
  "Ниже": "下移",
  "Новый дубль реплики": "台词新录一条",
  "Общий файл · MP3": "合并文件 · MP3",
  "Один из голосов больше недоступен. Выберите другой голос.": "其中一个声音已不可用，请选择其他声音。",
  "Озвучено реплик: {0} из {1}": "已配音台词：{0}/{1}",
  "Озвучиваем проект": "正在为项目配音",
  "Озвучить · {0} Circle": "配音 · {0} Circle",
  "Озвучить проект": "为项目配音",
  "Озвучка проектов": "项目配音",
  "Озвучка уже выполняется. Дождитесь результата.": "配音正在进行中，请等待结果。",
  "Операция уже принята или её исход неизвестен. Проверьте прежний запрос.": "操作已被接受或结果未知。请检查之前的请求。",
  "Отбросить локальные изменения и загрузить версию сервера?": "放弃本地更改并加载服务器版本？",
  "Открыть в истории": "在历史中打开",
  "Отменить изменения": "撤销更改",
  "Отменить несохранённые изменения?": "放弃未保存的更改？",
  "Перед озвучкой дождитесь сохранения изменений.": "配音前请等待更改保存完成。",
  "Переозвучить": "重新配音",
  "Переозвучить реплику": "重新为台词配音",
  "Повторить проверку": "重新检查",
  "Подтвердить и запустить": "确认并开始",
  "Подтверждение озвучки": "确认配音",
  "Проверить прежний запрос": "检查之前的请求",
  "Проверить статус": "检查状态",
  "Проверьте роли, голоса и длину реплик.": "请检查角色、声音和台词长度。",
  "Проект больше недоступен.": "项目已不可用。",
  "Проект длиннее 20 000 знаков.": "项目超过 20000 字。",
  "Проект изменился в другом окне. Сравните свою версию и загрузите свежую.": "项目已在其他窗口中更改。请对比你的版本并加载最新版本。",
  "Проект изменился. Сохраните его и проверьте цену ещё раз.": "项目已更改。请保存后再次检查价格。",
  "Проект или результат больше недоступен.": "项目或结果已不可用。",
  "Проект озвучен": "项目配音完成",
  "Проекты {0}": "项目 {0}",
  "Прослушать": "试听",
  "Прослушать реплику": "试听台词",
  "Прослушать текущую версию": "试听当前版本",
  "Прослушивание в очереди": "试听排队中",
  "Прослушивание реплики": "正在试听台词",
  "Результат изменился. Загрузите его актуальную версию.": "结果已更改，请加载最新版本。",
  "Результат озвучки проекта": "项目配音结果",
  "Результат уточняется. Повторная генерация автоматически не запускается.": "结果正在确认中，不会自动重新生成。",
  "Реплика {0}": "台词 {0}",
  "Реплика длиннее 1 000 знаков.": "台词超过 1000 字。",
  "Реплики · {0}": "台词 · {0}",
  "Реплику {0} выше": "上移台词 {0}",
  "Реплику {0} ниже": "下移台词 {0}",
  "Роли и голоса": "角色与声音",
  "Роль {0}": "角色 {0}",
  "Роль реплики": "台词角色",
  "Скачать MP3": "下载 MP3",
  "Слишком много запросов. Подождите и повторите проверку.": "请求过多。请稍等后重新检查。",
  "Создайте проект, затем вставьте сценарий или добавьте роли и реплики.": "创建项目，然后粘贴剧本或添加角色和台词。",
  "Стоимость подтверждена сервером. Повторная проверка этого же запроса не создаёт нового списания.": "价格已由服务器确认。再次检查同一请求不会重复扣费。",
  "Стоимость: {0} Circle": "费用：{0} Circle",
  "Строки «Имя: реплика» станут ролями и репликами. Таймкоды можно оставить.": "「名字：台词」格式的行会变成角色和台词。时间码可以保留。",
  "Сценарий": "剧本",
  "Сценарий изменился. Эта дорожка относится к предыдущей версии проекта.": "剧本已更改。此音轨属于项目的旧版本。",
  "Сценарий по ролям — каждая роль звучит своим голосом.": "分角色剧本——每个角色用自己的声音。",
  "Текст или голос изменились. Для текущей версии нужно новое прослушивание.": "文本或声音已更改。当前版本需要重新试听。",
  "Текст реплики": "台词文本",
  "Удалить проект": "删除项目",
  "Удалить реплику {0}": "删除台词 {0}",
  "Удалить реплику?": "删除这句台词？",
  "Удалить роль {0}": "删除角色 {0}",
  "Удалить роль «{0}» вместе с её репликами ({1})?": "删除角色「{0}」及其台词（{1}）？",
  "Удалить этот проект?": "删除此项目？",
  "Укажите имя каждой роли.": "请填写每个角色的名称。",
  "Уточняем результат озвучки": "正在确认配音结果",
  "Цена изменилась. Проверьте новую цену перед запуском.": "价格已变化。开始前请查看新价格。",
  "есть несохранённые изменения": "有未保存的更改",
  "сохранено": "已保存",
  "＋ Новый проект": "＋ 新项目",
  "＋ Реплика": "＋ 台词",
  "＋ Роль": "＋ 角色",
  "Circle из пакетов без срока действия.": "来自套餐包的 Circle 永不过期。",
  "Circle каждый месяц": "每月 Circle",
  "Circle приходят каждые {0} дней, первая партия — сразу.": "Circle 每 {0} 天发放一次，第一批立即到账。",
  "Circle этой партии действуют до {0}": "本批 Circle 有效期至 {0}",
  "{0} Circle каждый месяц": "每月 {0} Circle",
  "{0} Circle каждый месяц · до {1} своих голосов": "每月 {0} Circle · 最多 {1} 个自己的声音",
  "{0} мес.": "{0} 个月",
  "Баланс и профиль": "余额与个人资料",
  "В текущем месяце осталось {0} из {1} Circle": "本月剩余 {0}/{1} Circle",
  "Ваш текущий тариф": "你当前的套餐",
  "Включить тестовое продление": "开启测试续订",
  "Выбор тарифа": "选择套餐",
  "Действует до {0}": "有效期至 {0}",
  "Для этой подписки продление пока недоступно.": "此订阅暂不支持续订。",
  "До {0} своих голосов": "最多 {0} 个自己的声音",
  "До {0} сохраняется текущий тариф.": "当前套餐将保留至 {0}。",
  "Докупить Circle": "加购 Circle",
  "Доступные сроки": "可选时长",
  "Загружаем подписку…": "正在加载订阅…",
  "Запланировать переход": "预约切换套餐",
  "Запрос не совпадает с сохранённой операцией. Не повторяйте покупку; обратитесь в поддержку.": "请求与已保存的操作不符。请勿重复购买，请联系支持。",
  "Исход прежнего запроса нужно проверить. Новая покупка пока заблокирована.": "需要检查之前请求的结果，暂时无法进行新的购买。",
  "Начислить {0} тестовых Circle": "发放 {0} 测试 Circle",
  "Не удалось восстановить операцию. Проверьте подписку перед новой покупкой.": "无法恢复操作。新购买前请检查订阅。",
  "Операция подтверждена. Обновите данные; повторять покупку не нужно.": "操作已确认。请刷新数据，无需重复购买。",
  "Оставить текущий тариф": "保留当前套餐",
  "Отмена продления сохраняет тариф и лимиты до конца оплаченного срока.": "取消续订后，套餐和额度将保留到已付费期限结束。",
  "Отменить продление": "取消续订",
  "Оформить dev-подписку": "开通 dev 订阅",
  "Пакет Circle начислен.": "Circle 套餐包已到账。",
  "Пакеты Circle доступны с активной подпиской.": "Circle 套餐包需在订阅有效时购买。",
  "Перейти на выбранный тариф": "切换到所选套餐",
  "Переход начнётся после окончания текущей подписки. Сейчас оплата не требуется.": "切换将在当前订阅结束后生效，现在无需付款。",
  "Подписка": "订阅",
  "Подписка временно недоступна. Попробуйте обновить данные.": "订阅暂时不可用，请尝试刷新数据。",
  "Подписка не продлится": "订阅不会续订",
  "Подписка обновлена.": "订阅已更新。",
  "Подписка уже активна. Обновите данные и выберите доступное действие.": "订阅已生效。请刷新数据并选择可用操作。",
  "Подписка уже закончилась. Обновите данные.": "订阅已到期，请刷新数据。",
  "Подтвердить": "确认",
  "Подтверждение подписки": "确认订阅",
  "Покупка сейчас недоступна. Реальные платежи не включены.": "暂时无法购买，未开启真实支付。",
  "Получить dev-пакет бесплатно": "免费领取 dev 套餐包",
  "Потом: {0}": "之后：{0}",
  "Предыдущая подписка закончилась {0}": "上一个订阅已于 {0} 结束",
  "При продлении оплаченного срока новая партия придёт в следующем периоде.": "续订已付费期限时，新一批将在下个周期到账。",
  "Проверка операции": "正在检查操作",
  "Продление включено": "已开启续订",
  "Продлить подписку": "续订",
  "Свои голоса": "自己的声音",
  "Свои голоса: {0} из {1}": "自己的声音：{0}/{1}",
  "Сравнить тарифы": "比较套餐",
  "Срок": "时长",
  "Срок подписки": "订阅时长",
  "Срок: {0} мес.": "时长：{0} 个月",
  "Тариф останется до конца срока. Следующего продления не будет.": "套餐将保留到期限结束，之后不再续订。",
  "Тарифы пока недоступны. Попробуйте обновить данные позже.": "套餐暂时不可用，请稍后刷新数据。",
  "Текущий тариф": "当前套餐",
  "Тестовый dev-каталог. Реальных платежей нет; начисляются тестовые Circle.": "测试 dev 目录。没有真实支付，发放的是测试 Circle。",
  "Управление подпиской": "管理订阅",
  "Условия тарифа изменились. Обновите данные перед подтверждением.": "套餐条款已变更。确认前请刷新数据。",
  "Что входит": "包含内容",
  "Это бесплатная dev-операция. Деньги и Telegram Stars не списываются.": "这是免费的 dev 操作，不会扣除钱或 Telegram Stars。",
  "Этот переход между тарифами недоступен.": "无法进行此套餐切换。",
  "Этот тариф больше недоступен. Обновите список.": "此套餐已不可用，请刷新列表。",
  "QR-код": "二维码",
  "QR-код приглашения": "邀请二维码",
  "{0} из {1} · {2} Circle": "{0}/{1} · {2} Circle",
  "Виды заданий": "任务类型",
  "Выполнение этого задания пока недоступно.": "此任务暂不可完成。",
  "Готовим материал…": "正在准备素材…",
  "Действие подтверждено. Обновляем задания.": "操作已确认，正在更新任务。",
  "День {0}": "第 {0} 天",
  "День {0} из {1}": "第 {0}/{1} 天",
  "Дней подряд: {0}": "连续天数：{0}",
  "Друзья": "好友",
  "Ежедневная серия": "每日连续签到",
  "Ежедневные": "每日",
  "Есть награды": "有奖励可领",
  "Забрать {0} Circle": "领取 {0} Circle",
  "Загружаем награды…": "正在加载奖励…",
  "Задание ещё не выполнено. Обновите прогресс.": "任务尚未完成，请刷新进度。",
  "Задание засчитывает открытие отправки сторис. Telegram не подтверждает публикацию.": "打开快拍分享即算完成任务。Telegram 不会确认是否发布。",
  "Заданий в этой группе пока нет.": "此分组暂无任务。",
  "Задания дня": "今日任务",
  "Заходите каждый день. Пропуск дня начинает серию заново.": "每天都来。漏掉一天，连续记录会重新开始。",
  "Исход прежнего запроса нужно проверить. Новые начисления пока заблокированы.": "需要检查之前请求的结果，暂时无法发放新奖励。",
  "Копирование недоступно. Выделите текст вручную.": "无法复制，请手动选择文本。",
  "Материал для сторис": "快拍素材",
  "Награда подтверждена. Обновите данные; повторять начисление не нужно.": "奖励已确认。请刷新数据，无需重复领取。",
  "Награда получена": "奖励已领取",
  "Награда получена. Завтра +{0} Circle": "奖励已领取。明天 +{0} Circle",
  "Награда уже получена. Обновите данные.": "奖励已领取过，请刷新数据。",
  "Награды временно недоступны. Попробуйте обновить данные.": "奖励暂时不可用，请尝试刷新数据。",
  "Награды за друзей": "邀请好友奖励",
  "Награды приходят в Circle: ими можно платить в STEOS, выводить нельзя.": "奖励以 Circle 发放：可在 STEOS 内消费，不能提现。",
  "Начисление не подтверждено. Проверьте прежний запрос; новая награда пока заблокирована.": "发放未确认。请检查之前的请求，新奖励暂时无法领取。",
  "Начисления приостановлены.": "发放已暂停。",
  "Начислено {0} Circle": "已发放 {0} Circle",
  "Начислено: {0} Circle": "已发放：{0} Circle",
  "Не удалось восстановить запрос награды. Проверьте баланс и обратитесь в поддержку.": "无法恢复奖励请求。请检查余额并联系支持。",
  "Не удалось загрузить QR-код.": "无法加载二维码。",
  "Не удалось открыть отправку сторис. Награда не начислена.": "无法打开快拍分享，奖励未发放。",
  "Не удалось подготовить сторис. Попробуйте ещё раз.": "无法准备快拍，请重试。",
  "Новый день: {0}": "新的一天：{0}",
  "Обновить награды": "刷新奖励",
  "Обновятся: {0}": "更新时间：{0}",
  "Откройте Mini App в Telegram с поддержкой сторис.": "请在支持快拍的 Telegram 中打开 Mini App。",
  "Открыть STEOS ID в профиле": "在个人资料中打开 STEOS ID",
  "Открыть сторис": "打开快拍",
  "Отправить в сторис": "分享到快拍",
  "Партнёрские данные временно недоступны.": "合作伙伴数据暂时不可用。",
  "Партнёрство · Статистика, материалы и вывод": "合作伙伴计划 · 统计、素材与提现",
  "Первые шаги": "新手任务",
  "Перейти к заданию": "前往任务",
  "Получить ежедневную награду": "领取每日奖励",
  "Приглашено: {0} · Покупателей: {1}": "已邀请：{0} · 购买者：{1}",
  "Прогресс задания": "任务进度",
  "Прогресс задания временно недоступен.": "任务进度暂时不可用。",
  "Промокод": "优惠码",
  "Разовые": "一次性",
  "Скопировать приглашение": "复制邀请",
  "Скопировать промокод": "复制优惠码",
  "Ссылка приглашения": "邀请链接",
  "Сторис в Telegram": "Telegram 快拍",
  "Челленджи недели": "每周挑战",
  "Circle используются внутри STEOS": "Circle 在 STEOS 内使用",
  "Telegram подтвердил отправку сообщения.": "Telegram 已确认消息发送。",
  "Без покупок": "未购买",
  "В этом списке пока нет друзей.": "此列表中暂无好友。",
  "Возможен вывод по условиям программы": "可按计划条款提现",
  "Вопросы": "常见问题",
  "Всё время": "全部时间",
  "Вы здесь": "你在这里",
  "Выберите PDF, JPG или PNG.": "请选择 PDF、JPG 或 PNG。",
  "Выберите плательщика": "选择付款方",
  "Выбрать чат в Telegram": "在 Telegram 中选择聊天",
  "Выбрать чат для отправки": "选择发送的聊天",
  "Вывод": "提现",
  "Вывод недоступен на текущем уровне.": "当前等级无法提现。",
  "Вывод сейчас недоступен.": "暂时无法提现。",
  "Вывод средств": "提现",
  "Выплачен": "已支付",
  "Выставьте счёт на": "开具发票给",
  "Для вывода войдите в STEOS ID.": "请登录 STEOS ID 后提现。",
  "Для расчёта нужны опубликованные уровни и тарифы.": "计算需要已发布的等级和费率。",
  "До уровня «{0}»: ещё {1} покупателей": "距离「{0}」等级：还差 {1} 位购买者",
  "Доступно к выводу": "可提现",
  "Доступных шаблонов пока нет.": "暂无可用模板。",
  "Доход": "收入",
  "Если купят {0} друзей": "如果 {0} 位好友购买",
  "Есть покупки": "已购买",
  "За этот период начислений пока нет.": "此期间暂无收益。",
  "Загружаем QR-код…": "正在加载二维码…",
  "Загружаем друзей…": "正在加载好友…",
  "Загружаем материалы…": "正在加载素材…",
  "Загружаем партнёрские данные…": "正在加载合作伙伴数据…",
  "Загрузите проверенный счёт на оплату.": "请上传已核验的付款发票。",
  "Заказать материал в чат": "将素材发到聊天",
  "Запрос принят. Доставка в чат ещё не подтверждена.": "请求已接受，尚未确认送达聊天。",
  "Заявка принята. Статус выплаты появится в истории.": "申请已接受，付款状态将显示在历史中。",
  "Заявок на вывод пока нет.": "暂无提现申请。",
  "Изменение реквизитов заблокировано до получения результата этой заявки.": "在收到此申请结果之前，无法修改收款信息。",
  "Имя получателя": "收款人姓名",
  "История выводов": "提现历史",
  "Исход запроса нужно проверить. Новый материал пока заблокирован.": "需要检查请求结果，暂时无法获取新素材。",
  "Как определяется уровень?": "等级如何确定？",
  "Как это работает": "运作方式",
  "Калькулятор станет доступен после публикации расчётной политики.": "结算政策发布后即可使用计算器。",
  "Количество друзей": "好友数量",
  "Материалы": "素材",
  "Материалы временно недоступны. Попробуйте обновить список.": "素材暂时不可用，请尝试刷新列表。",
  "Материалы пока недоступны.": "素材暂不可用。",
  "Месяц": "月",
  "Минимальная сумма": "最低金额",
  "На рассмотрении": "审核中",
  "Налоговый номер": "税号",
  "Начисления за период": "本期收益",
  "Начислено Circle": "已发放 Circle",
  "Начислено за период: {0} Circle": "本期已发放：{0} Circle",
  "Не удалось безопасно сохранить заявку или проверить владельца. Отправка не выполнена.": "无法安全保存申请或验证所有者，未发送。",
  "Не удалось восстановить отправку. Обратитесь в поддержку перед новым запросом.": "无法恢复发送。发起新请求前请联系支持。",
  "Не удалось загрузить друзей.": "无法加载好友。",
  "Не удалось загрузить историю выводов.": "无法加载提现历史。",
  "Не удалось загрузить тарифы.": "无法加载费率。",
  "Не удалось открыть отправку в Telegram.": "无法在 Telegram 中打开发送界面。",
  "Не удалось проверить владельца. Обновите страницу.": "无法验证所有者，请刷新页面。",
  "Не удалось прочитать сохранённую заявку. Новый вывод заблокирован.": "无法读取已保存的申请，新提现已被阻止。",
  "Не удалось сохранить состояние отправки.": "无法保存发送状态。",
  "Неделя": "周",
  "Нет данных": "暂无数据",
  "Новая заявка": "新申请",
  "Новая заявка на вывод сейчас недоступна.": "暂时无法提交新的提现申请。",
  "О программе": "关于计划",
  "Обзор": "概览",
  "Обновите страницу или обратитесь в поддержку.": "请刷新页面或联系支持。",
  "Обновить историю выводов": "刷新提现历史",
  "Обновить материалы": "刷新素材",
  "От {0} покупателей": "{0} 位购买者起",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены.": "未收到响应。请检查同一申请：其数据和密钥已保存。",
  "Отклонён": "已拒绝",
  "Откройте Mini App в Telegram с поддержкой отправки материалов.": "请在支持发送素材的 Telegram 中打开 Mini App。",
  "Открыть сторис в Telegram": "在 Telegram 中打开快拍",
  "Отправка не подтверждена. Повтор проверит прежний запрос без новой отправки.": "发送未确认。重试会检查之前的请求，不会重复发送。",
  "Отправка отменена. Можно открыть выбор чата ещё раз.": "已取消发送，可以重新选择聊天。",
  "Оценка дохода": "收入估算",
  "Оценка за {0} месяцев: {1} Circle": "{0} 个月估算：{1} Circle",
  "Оценка за месяц: {0} Circle": "每月估算：{0} Circle",
  "Переходы": "点击",
  "Период обзора": "统计周期",
  "Плательщик": "付款方",
  "Подать заявку на вывод": "提交提现申请",
  "Подготовить QR-код": "生成二维码",
  "Подготовить другой материал": "准备其他素材",
  "Подготовить материал": "准备素材",
  "Поделитесь своей ссылкой или промокодом.": "分享你的链接或优惠码。",
  "Поделиться": "分享",
  "Пока без покупок": "暂无购买",
  "Пока недоступно": "暂不可用",
  "Покупатели": "购买者",
  "Покупки друзей учитывает сервер STEOS ID.": "好友的购买由 STEOS ID 服务器统计。",
  "Полные условия программы": "完整计划条款",
  "Пользователь": "用户",
  "Попробуйте STEOS: {0}\nПромокод: {1}": "试试 STEOS：{0}\n优惠码：{1}",
  "Привязка до: {0}": "绑定至：{0}",
  "Привязка приглашённого друга действует {0} месяцев.": "受邀好友的绑定有效期为 {0} 个月。",
  "Приглашён: {0}": "邀请时间：{0}",
  "Проверить загрузку счёта": "检查发票上传",
  "Проверить ту же заявку": "检查同一申请",
  "Проверьте налоговый номер получателя.": "请检查收款人税号。",
  "Проверьте реквизиты и счёт.": "请检查收款信息和发票。",
  "Проверьте сумму вывода: целое число в доступном диапазоне.": "请检查提现金额：须为可用范围内的整数。",
  "Проверяем владельца…": "正在验证所有者…",
  "Проверяем заявку или счёт…": "正在检查申请或发票…",
  "Процент и доступность вывода определяет опубликованная программа.": "比例和是否可提现由已发布的计划决定。",
  "Проценты, сроки и ограничения показаны по опубликованным данным сервера.": "比例、期限和限制均按服务器已发布的数据显示。",
  "Размер счёта должен быть от 1 байта до 10 МБ.": "发票大小须在 1 字节到 10 MB 之间。",
  "Регистрации": "注册",
  "Результат загрузки счёта неизвестен. Проверьте загрузку без повторной отправки файла.": "发票上传结果未知。请检查上传，无需重新发送文件。",
  "Скачать PNG": "下载 PNG",
  "Сколько действует привязка друга?": "好友绑定有效多久？",
  "Скопировать текст": "复制文本",
  "Сохранена неподтверждённая заявка": "已保存未确认的申请",
  "Срок рассмотрения, дней": "审核期（天）",
  "Ссылка и промокод добавляются сервером. Выберите доступный материал.": "链接和优惠码由服务器添加。请选择可用素材。",
  "Ссылка на полный документ условий пока не опубликована.": "完整条款文档的链接尚未发布。",
  "Сторис открыта в Telegram. Публикацию нужно подтвердить в редакторе.": "快拍已在 Telegram 中打开，需要在编辑器中确认发布。",
  "Сумма в Circle": "金额（Circle）",
  "Сумма меньше минимальной суммы вывода.": "金额低于最低提现金额。",
  "Сумма превышает доступный остаток.": "金额超过可用余额。",
  "Счёт на оплату · PDF, JPG или PNG, до 10 МБ": "付款发票 · PDF、JPG 或 PNG，最大 10 MB",
  "Счёт не прошёл загрузку или проверку. Выберите PDF, JPG или PNG до 10 МБ.": "发票上传或检查失败。请选择不超过 10 MB 的 PDF、JPG 或 PNG。",
  "Счёт пока не подтверждён. Повторите проверку или выберите другой файл.": "发票尚未确认。请重新检查或选择其他文件。",
  "Счёт проверен": "发票已核验",
  "Текст приглашения": "邀请文本",
  "Текст сообщения": "消息文本",
  "Тексты": "文案",
  "Тестовая заявка": "测试申请",
  "Тестовая программа dev. Реальные выплаты выключены.": "dev 测试计划，真实付款已关闭。",
  "Тестовая программа: реальные выплаты отключены.": "测试计划：真实付款已关闭。",
  "Тестовый расчёт dev. Это оценка, начисление не выполняется.": "dev 测试计算。这只是估算，不会发放收益。",
  "Укажите имя получателя: до 200 символов.": "请填写收款人姓名：最多 200 个字符。",
  "Уровень показывает сервер по учтённым покупателям. Смотрите вкладку «Уровни».": "等级由服务器根据统计的购买者显示。请查看「等级」标签。",
  "Уровни": "等级",
  "Условия начислений пока не опубликованы.": "收益条款尚未发布。",
  "Условия программы": "计划条款",
  "Учёт переходов по ссылке пока недоступен.": "链接点击统计暂不可用。",
  "Фильтр друзей": "好友筛选",
  "Что делать, если данные не обновились?": "数据没有更新怎么办？",
  "Шаги": "步骤",
  "Баннер": "横幅",
  "QR-постер": "二维码海报",
  "{0} / 300 знаков": "{0} / 300 字",
  "· до 20 МБ": "· 最大 20 MB",
  "Агент готовит ответ…": "助手正在准备回答…",
  "Аудиозапись": "音频录音",
  "Бесплатно только в dev. До 30 секунд и 10 МБ. Текст можно исправить перед отправкой.": "仅在 dev 中免费。最长 30 秒、10 MB。发送前可以修改文本。",
  "Ваш вопрос": "你的问题",
  "Вопрос или название инструмента": "问题或工具名称",
  "Вопросов: {0}": "问题：{0}",
  "Вопросы · {0}": "问题 · {0}",
  "Восстанавливаем чат…": "正在恢复聊天…",
  "Все сервисы работают": "所有服务运行正常",
  "Выберите MP3, WAV или M4A до 20 МБ.": "请选择不超过 20 MB 的 MP3、WAV 或 M4A。",
  "Выберите инструкцию к нужному инструменту или странице.": "选择所需工具或页面的使用说明。",
  "Диктовать вопрос": "语音输入问题",
  "Диктовка не подтверждена. Повторите проверку прежнего запроса или загрузки.": "语音输入未确认。请重新检查之前的请求或上传。",
  "До": "至",
  "Ещё спрашивают": "其他人还问",
  "Загружаем справку…": "正在加载帮助…",
  "Загружаем статус…": "正在加载状态…",
  "Закрыть чат": "关闭聊天",
  "ИИ-агент поддержки": "AI 支持助手",
  "ИИ-агент сейчас недоступен.": "AI 助手暂时不可用。",
  "Инструкции": "使用说明",
  "Инструкции · {0}": "使用说明 · {0}",
  "Инструкции пока не опубликованы.": "使用说明尚未发布。",
  "Исход запроса пока неизвестен. Новый вопрос не отправляется.": "请求结果尚未知晓，不会发送新问题。",
  "Как пользоваться STEOS": "如何使用 STEOS",
  "Кружки и говорящие видео": "圆形视频与会说话的视频",
  "Медленнее обычного": "比平时慢",
  "Написать агенту": "给助手发消息",
  "Начать": "开始",
  "Начать новую диктовку": "开始新的语音输入",
  "Не помогло": "没帮助",
  "Не удалось восстановить диктовку. Новый запрос заблокирован.": "无法恢复语音输入，新请求已被阻止。",
  "Не удалось восстановить чат. Обратитесь в поддержку.": "无法恢复聊天，请联系支持。",
  "Не удалось загрузить поддержку. Попробуйте ещё раз.": "无法加载支持，请重试。",
  "Не удалось загрузить статус сервисов.": "无法加载服务状态。",
  "Не удалось подтвердить ответ. Можно начать новый чат или написать в поддержку.": "无法确认回答。可以开始新聊天或联系支持。",
  "Не удалось получить ответ. Повторите проверку без нового вопроса.": "未获取到回答。请重新检查，无需提出新问题。",
  "Не удалось проверить владельца чата. Повторите открытие.": "无法验证聊天所有者，请重新打开。",
  "Не удалось сохранить новый чат.": "无法保存新聊天。",
  "Не удалось сохранить оценку. Попробуйте ещё раз.": "无法保存评价，请重试。",
  "Недоступен": "不可用",
  "Некоторые сервисы работают медленнее обычного. Открыть статус": "部分服务运行比平时慢。查看状态",
  "Нет подтверждённых данных": "暂无已确认的数据",
  "Ничего не нашли. Попробуйте другие слова или спросите ИИ-агента.": "未找到结果。请换个说法或询问 AI 助手。",
  "Новый чат": "新聊天",
  "Обзор приложения": "应用概览",
  "Обновить справку": "刷新帮助",
  "Обновить статус": "刷新状态",
  "Опубликованная проверка. Автоматический мониторинг не заявлен.": "已发布的检查结果，未声明自动监控。",
  "Ответ не подтверждён. Проверьте прежний запрос или напишите в поддержку.": "回答未确认。请检查之前的请求或联系支持。",
  "Отвечает по опубликованной справке STEOS": "根据已发布的 STEOS 帮助文档回答",
  "Открыть инструкции": "打开使用说明",
  "Открыть инструкцию": "打开使用说明",
  "Открыть инструмент": "打开工具",
  "Открыть ответ справки": "打开帮助答案",
  "Открыть раздел": "打开分区",
  "Отправить вопрос": "发送问题",
  "Оценка ответа": "评价回答",
  "Очистить поиск": "清除搜索",
  "Поиск по справке": "搜索帮助",
  "Полезно": "有帮助",
  "Помощь": "帮助",
  "Популярные вопросы": "热门问题",
  "Последняя проверка устарела. Текущее состояние неизвестно.": "上次检查已过时，当前状态未知。",
  "Посмотреть короткий обзор": "查看简短概览",
  "Предыдущая": "上一页",
  "Проверено: {0}": "检查时间：{0}",
  "Проверить диктовку": "检查语音输入",
  "Пропустить": "跳过",
  "Работает": "正常运行",
  "Распознать вопрос": "识别问题",
  "Распознаём вопрос…": "正在识别问题…",
  "Результаты поиска": "搜索结果",
  "Следующая": "下一页",
  "Советы": "提示",
  "Справка пока не опубликована.": "帮助文档尚未发布。",
  "Спросите что угодно": "随便问",
  "Спросить ИИ-агента": "询问 AI 助手",
  "Спросить ИИ-агента поддержки": "询问 AI 支持助手",
  "Статус": "状态",
  "Статус сервисов": "服务状态",
  "Статус сервисов пока не публикуется.": "服务状态暂未发布。",
  "Статья недоступна": "文章不可用",
  "Темы": "主题",
  "Темы пока не опубликованы.": "主题尚未发布。",
  "Точного ответа в справке нет.": "帮助文档中没有确切答案。",
  "Чат не отправляет сообщения человеку автоматически.": "聊天不会自动将消息转给人工。",
  "Читаем запись…": "正在读取录音…",
  "Эта статья больше не входит в опубликованную справку.": "这篇文章已不在已发布的帮助文档中。",
  "Выберите MP3, WAV или M4A до {0} МБ.": "请选择不超过 {0} MB 的 MP3、WAV 或 M4A。",
  "До {0} · до {1} МБ": "最长 {0} · 最大 {1} MB",
  "Нужна запись от 1 секунды до {0}.": "录音须在 1 秒到 {0} 之间。",
  "Остановить запись · {0}": "停止录音 · {0}",
  "{0} C/сек": "{0} C/秒",
  "Все инструменты": "全部工具",
  "Все шаблоны": "全部模板",
  "Вся подборка": "完整合集",
  "Выбрать, кто играет": "选择出演者",
  "Голос и музыка": "声音与音乐",
  "Двое": "两人",
  "Дети": "儿童",
  "Дешевле": "更便宜",
  "Для бизнеса": "商用",
  "Для этого действия доступно несколько шаблонов. Выберите подходящий в каталоге.": "此操作有多个模板可用，请在目录中选择合适的。",
  "Загружаем шаблон…": "正在加载模板…",
  "Закрыть поиск": "关闭搜索",
  "Закрыть превью": "关闭预览",
  "Инструменты": "工具",
  "Искать во всех шаблонах": "在全部模板中搜索",
  "Короче": "更短",
  "Кто играет": "出演者",
  "Найти инструмент или шаблон": "查找工具或模板",
  "Не удалось загрузить выбранный вариант.": "无法加载所选版本。",
  "Не удалось загрузить шаблон. Обновите превью.": "无法加载模板，请刷新预览。",
  "Не удалось открыть инструмент.": "无法打开工具。",
  "Несколько": "多人",
  "Новые": "最新",
  "Один": "一人",
  "от {0} C": "{0} C 起",
  "от {0} C/сек": "{0} C/秒 起",
  "От {0} Circle": "{0} Circle 起",
  "От А до Я": "A 到 Z",
  "Очистить": "清除",
  "Питомцы": "宠物",
  "По желанию": "可选",
  "Подборка пока недоступна.": "合集暂不可用。",
  "Подборки": "合集",
  "Поиск": "搜索",
  "Пока нет доступных шаблонов": "暂无可用模板",
  "Популярные": "热门",
  "После": "之后",
  "Превью шаблона": "模板预览",
  "Пример результата пока не опубликован.": "结果示例尚未发布。",
  "Пример сейчас недоступен.": "示例暂不可用。",
  "Рекомендуем": "推荐",
  "Смотреть все": "查看全部",
  "Сначала": "排序",
  "Сравнить до и после": "对比前后效果",
  "Стилей: {0}. Выбор на следующем шаге.": "风格：{0}。下一步中选择。",
  "Удерживайте для просмотра": "长按查看",
  "Цена уточняется в форме создания.": "价格将在创建表单中确认。",
  "Частые вопросы": "常见问题",
  "Что нужно": "所需内容",
  "Что хотите сделать?": "你想做什么？",
  "Шаблоны и подборки": "模板与合集",
  "Это действие пока недоступно.": "此操作暂不可用。",
  "е": "е",
  "за секунду": "每秒",
  "ё": "ё",
  "{0} C в минуту": "每分钟 {0} C",
  "{0} C за 100 знаков": "每 100 字 {0} C",
  "Владелец сессии изменился. Вернитесь в студию после обновления страницы.": "会话所有者已变更。请刷新页面后返回工作室。",
  "Не удалось восстановить сохранённую заявку. Новая генерация заблокирована.": "无法恢复已保存的申请，新生成已被阻止。",
  "Не удалось обновить сохранённую заявку. Новая генерация заблокирована.": "无法更新已保存的请求。新的生成已被阻止。",
  "Не удалось проверить владельца. Новая генерация заблокирована.": "无法验证所有者。新的生成已被阻止。",
  "Не удалось сохранить заявку. Отправка не выполнена.": "无法保存请求。提交未完成。",
  "от {0} C в минуту": "每分钟 {0} C 起",
  "от {0} C за 100 знаков": "每 100 字 {0} C 起",
  "Проверить статус заказа": "查看订单状态",
  "Статус пока не подтверждён. Проверьте этот же заказ позже.": "状态尚未确认。请稍后再查看此订单。",
  "в минуту": "每分钟",
  "за 100 знаков": "每 100 字",
  "Анимация звука": "声音动画",
  "В видео останется исходная речь. Выберите фрагмент до одной минуты.": "视频将保留原始语音。请选择不超过一分钟的片段。",
  "В видео останутся исходные слова. Голос можно изменить. Выберите фрагмент до одной минуты.": "视频将保留原始台词，声音可以更换。请选择不超过一分钟的片段。",
  "Вид персонажа": "角色形象",
  "Видео готово": "视频已完成",
  "Видео не создано": "视频未生成",
  "Волна": "波浪",
  "Выберите, кто говорит": "选择谁在说话",
  "Выбранное фото": "已选照片",
  "Движение": "动作",
  "Добавьте видео": "添加视频",
  "Дополнительная настройка": "附加设置",
  "Другой голос для записи": "为录音换一个声音",
  "Ещё вариант": "再来一个版本",
  "Ещё настройки": "更多设置",
  "Изменить данные": "修改信息",
  "Источник": "来源",
  "Источник лица": "面部来源",
  "Источник речи": "语音来源",
  "Кадр по вертикали": "竖版画面",
  "Кадр по горизонтали": "横版画面",
  "Каких движений избегать": "要避免的动作",
  "Конец фрагмента, секунды": "片段结束（秒）",
  "Кружком": "以圆形视频",
  "Кружок готов": "圆形视频已完成",
  "Кружок не создан": "圆形视频未生成",
  "Люди и персонажи": "人物和角色",
  "Напишите текст или добавьте запись": "输入文字或添加录音",
  "Начало фрагмента, секунды": "片段开始（秒）",
  "Не удалось загрузить виды персонажа.": "无法加载角色形象。",
  "Не удалось загрузить людей и персонажей.": "无法加载人物和角色。",
  "Не удалось подтвердить завершение заказа. Новая генерация не начата.": "无法确认订单已完成。未开始新的生成。",
  "Не удалось проверить доставку. Откройте историю заказа.": "无法确认是否已送达。请打开订单历史。",
  "Оставить голос записи": "保留录音的声音",
  "Открыть в чате": "在聊天中打开",
  "Отправлено в чат": "已发送到聊天",
  "По умолчанию": "默认",
  "Подтвердите право использовать материалы": "请确认你有权使用这些素材",
  "Полосы": "条纹",
  "Портретное": "竖版",
  "Прежний заказ ещё не завершён. Сначала проверьте его результат.": "上一个订单尚未完成。请先查看它的结果。",
  "Приближение": "推近",
  "Проверка отклонила материал. Измените исходные данные.": "素材未通过审核。请修改原始内容。",
  "Продолжить проверку отправки": "继续查看提交状态",
  "Результат недоступен. Проверьте историю заказа.": "结果不可用。请查看订单历史。",
  "Результат отправки пока не подтверждён. Продолжите проверку с тем же ключом.": "提交结果尚未确认。请用同一个密钥继续查看。",
  "Результат пока не подтверждён. Проверьте этот заказ, прежде чем создавать новый.": "结果尚未确认。创建新订单前请先查看此订单。",
  "Своё видео": "自己的视频",
  "Своё фото": "自己的照片",
  "Создание сейчас недоступно": "暂时无法创建",
  "Создать кружок": "创建圆形视频",
  "Создаём видео": "正在创建视频",
  "Списание возвращено": "扣费已退回",
  "Тестовый заказ без списания": "测试订单，不扣费",
  "Файлом": "以文件",
  "Фоновый звук": "背景音",
  "Фото с лицом": "带人脸的照片",
  "Цена или версия инструмента изменилась. Обновите форму и проверьте стоимость.": "价格或工具版本已变更。请刷新表单并核对费用。",
  "Человек или персонаж": "人物或角色",
  "Что скажет?": "要说什么？",
  "Напишите не меньше {0} знаков": "请至少输入 {0} 个字",
  "Текст отклонён проверкой. Измените текст.": "文字未通过审核。请修改文字。",
  "В видео прозвучат новые слова.": "视频中将说出新的台词。",
  "Если речь длиннее видео, ролик повторится.": "如果语音比视频长，视频会循环播放。",
  "Исходная речь": "原始语音",
  "Новая запись": "新录音",
  "Новые слова текстом": "用文字输入新台词",
  "Речь в видео": "视频中的语音",
  "Размер файла не должен превышать {0} МБ.": "文件大小不能超过 {0} MB。",
  "До {0} МБ": "最大 {0} MB",
  "Альбомное": "横版",
  "Альбомом": "横版",
  "Без стиля": "无风格",
  "В новом стиле": "换个新风格",
  "Вариант": "版本",
  "Во весь экран": "全屏",
  "Восстановить фото": "修复照片",
  "Все стили": "全部风格",
  "Все темы": "全部主题",
  "Выберите инструмент в каталоге, затем подтвердите использование фото.": "在目录中选择工具，然后确认照片的使用。",
  "Выберите подходящее фото до {0} МБ.": "请选择不超过 {0} MB 的合适照片。",
  "Выберите стиль или свой референс": "选择风格或自己的参考图",
  "Выбран свой референс": "已选择自己的参考图",
  "Выбрать стиль": "选择风格",
  "Двигайте картинку, чтобы выбрать кадр": "拖动图片来选择画面",
  "Диафрагма": "光圈",
  "Добавить человека": "添加人物",
  "Добавьте описание, от 10 знаков": "添加描述，至少 10 个字",
  "Загрузите фото": "上传照片",
  "Заполните обязательные поля": "请填写必填项",
  "Изменить фото": "更换照片",
  "Использовать выбранное фото результата": "使用选中的结果照片",
  "Кадр": "画面",
  "Кадрирование": "裁剪",
  "Как у фото": "与照片相同",
  "Камера": "相机",
  "Найти настройку съёмки": "查找拍摄设置",
  "Найти стиль": "查找风格",
  "Настройки съёмки недоступны.": "拍摄设置不可用。",
  "Начать новое улучшение": "开始新的优化",
  "Не выбран": "未选择",
  "Не удалось восстановить улучшение. Новая отправка заблокирована.": "无法恢复优化。新的提交已被阻止。",
  "Не удалось загрузить режимы фото.": "无法加载照片模式。",
  "Не удалось загрузить фото.": "无法加载照片。",
  "Не удалось использовать фото результата. Откройте исходный заказ и попробуйте снова.": "无法使用结果照片。请打开原订单后重试。",
  "Не удалось открыть режим. Попробуйте ещё раз.": "无法打开该模式。请重试。",
  "Не удалось передать выбранное фото. Попробуйте снова.": "无法传递所选照片。请重试。",
  "Не удалось проверить владельца.": "无法验证所有者。",
  "Не удалось прочитать фото.": "无法读取照片。",
  "Не удалось улучшить текст. Исходный текст сохранён.": "无法优化文字。原文已保留。",
  "О стиле": "关于风格",
  "Объектив": "镜头",
  "Оживить фото": "让照片动起来",
  "Описание во весь экран": "全屏查看描述",
  "Описание длиннее допустимого": "描述超出长度限制",
  "По вертикали": "竖版",
  "По горизонтали": "横版",
  "По описанию": "按描述",
  "Повторить прежнее улучшение": "重复上次的优化",
  "Подтвердите права на материалы": "请确认素材的使用权",
  "Пример": "示例",
  "Проверить улучшение": "查看优化结果",
  "Проверяем фото…": "正在检查照片…",
  "Ракурс": "角度",
  "Раскрасить чёрно-белое": "黑白照片上色",
  "Режим фото": "照片模式",
  "Референс должен быть не меньше 256 × 256 пикселей.": "参考图至少需要 256 × 256 像素。",
  "Свернуть": "收起",
  "Свет": "光线",
  "Свой референс": "自己的参考图",
  "Свой референс сейчас недоступен": "暂时无法使用自己的参考图",
  "Сделать рилс": "制作 Reels",
  "Сколько фото": "照片数量",
  "Создать фото": "创建照片",
  "Создаём фото": "正在创建照片",
  "Срок проверки улучшения истёк. Исходный текст сохранён.": "优化确认已超时。原文已保留。",
  "Тема стиля": "风格主题",
  "Убрать из кадра": "从画面中移除",
  "Улучшение пока не подтверждено. Исходный текст сохранён.": "优化尚未确认。原文已保留。",
  "Улучшить": "优化",
  "Формат файла": "文件格式",
  "Фото готовы": "照片已完成",
  "Фото на аватарку": "头像照片",
  "Фото не создано": "照片未生成",
  "Цвет": "颜色",
  "Что дальше": "接下来",
  "Что делает в кадре": "在画面中做什么",
  "Выберите разных людей в кадре": "请为画面选择不同的人",
  "Измените описание и попробуйте улучшить его снова.": "修改描述后再试一次优化。",
  "Использовать референс": "使用参考图",
  "Авто": "自动",
  "Без движения": "静止",
  "Видео должно длиться не меньше секунды": "视频时长至少 1 秒",
  "Выберите главное фото": "选择主照片",
  "Выберите один исходный файл": "选择一个源文件",
  "Выберите файл подходящего формата и размера": "请选择格式和大小合适的文件",
  "Выберите фрагмент от 1 до 10 секунд": "选择 1 到 10 秒的片段",
  "Главное фото": "主照片",
  "Длительность исходника: {0} с": "源文件时长：{0} 秒",
  "Добавить речь": "添加语音",
  "Загрузите видео": "上传视频",
  "Загрузите фото или видео": "上传照片或视频",
  "Загрузить": "上传",
  "Загрузить видео": "上传视频",
  "Загрузить фото": "上传照片",
  "Звук исходника не сохраняется: модель создаёт новый звук.": "不保留原始音频：模型会生成新的声音。",
  "Звук от модели": "模型生成的声音",
  "Звук создаёт модель: фон, шумы и музыка. Речь можно добавить после создания.": "声音由模型生成：背景、音效和音乐。语音可以在生成后添加。",
  "Использовать видео результата": "使用结果视频",
  "Исходное видео": "源视频",
  "Исходный файл": "源文件",
  "Как двигаться": "怎么动",
  "Конец фрагмента, мс": "片段结束（毫秒）",
  "Конец, секунды": "结束（秒）",
  "Люди в кадре недоступны для этого режима": "此模式不支持画面中的人",
  "Начало фрагмента, мс": "片段开始（毫秒）",
  "Начало, секунды": "开始（秒）",
  "Не удалось загрузить режимы видео.": "无法加载视频模式。",
  "Не удалось использовать видео результата. Откройте исходный заказ и попробуйте снова.": "无法使用结果视频。请打开原订单后重试。",
  "Не удалось передать видео. Откройте исходный заказ и попробуйте снова.": "无法传递视频。请打开原订单后重试。",
  "Новое": "新",
  "Объёмное фото создаётся без звука": "立体照片生成时没有声音",
  "Первый кадр": "首帧",
  "Продолжить загрузку": "继续上传",
  "Разрешение": "分辨率",
  "Режим видео": "视频模式",
  "Снимем из главного фото. Выберите главное фото для кадрирования.": "将使用主照片拍摄。请选择要裁剪的主照片。",
  "Снять": "拍摄",
  "Снять видео": "录制视频",
  "Создать видео": "创建视频",
  "Темп": "节奏",
  "Формат задаёт инструмент: портрет 3:4, ролик на 5 секунд": "格式由工具决定：竖版 3:4，5 秒视频",
  "Фото товара": "商品照片",
  "Фрагмент от 1 до 10 секунд": "1 到 10 秒的片段",
  "Хит": "热门",
  "Что изменить": "要修改什么",
  "Этот режим видео пока недоступен": "此视频模式暂不可用",
  "Как у исходника": "与源文件相同",
  "Со звуком": "有声",
  "Без звука": "无声",
  "5 секунд": "5 秒",
  "10 секунд": "10 秒",
  "Не удалось прочитать файл.": "无法读取文件。",
  "1. Видео с вами": "1. 有你的视频",
  "1. Видео с движениями": "1. 动作视频",
  "2. Кем стать": "2. 变成谁",
  "2. Кто повторит": "2. 谁来模仿",
  "Видео должно длиться не меньше {0} секунд": "视频时长至少 {0} 秒",
  "Водяной знак — недоступен": "水印 — 不可用",
  "Вы, близкий или персонаж": "你、亲友或角色",
  "Выберите допустимый фрагмент видео": "请选择允许时长内的视频片段",
  "Выберите одного героя": "选择一个人物",
  "Выберите фон": "选择背景",
  "Выберите, кто повторит движения": "选择谁来模仿动作",
  "Голос героя — недоступен": "人物的声音 — 不可用",
  "Другой голос — недоступен": "其他声音 — 不可用",
  "Загрузите видео с движениями": "上传动作视频",
  "Из видео": "来自视频",
  "Изменить людей и свои фото": "管理人物和自己的照片",
  "Источник героя": "人物来源",
  "Исходный звук сохраняется, если он есть в ролике.": "如果视频有声音，会保留原始声音。",
  "Кадр, ракурс и фон берутся с фото героя.": "构图、角度和背景取自人物照片。",
  "Кто повторит движения": "谁来模仿动作",
  "На фото должны быть видны голова, плечи и корпус.": "照片中需要能看到头部、肩膀和躯干。",
  "Нужен один человек в кадре. На фото и видео должны быть видны голова, плечи и корпус.": "画面中只能有一个人。照片和视频中需要能看到头部、肩膀和躯干。",
  "Подтвердите права и согласие человека": "请确认使用权和本人同意",
  "Подтверждаю права на материалы и согласие человека на использование его изображения": "我确认拥有素材的使用权，且本人同意使用其肖像",
  "Преобразование в кружок недоступно: в результате нет подтверждённой звуковой дорожки.": "无法转为圆形视频：结果中没有已确认的音轨。",
  "Режим движения": "动作模式",
  "С героя": "取自人物",
  "Смена голоса пока недоступна": "暂时无法更换声音",
  "Снять выбор": "取消选择",
  "Сохранение исходного звука не подтверждено.": "未确认保留原始声音。",
  "Стать персонажем": "变成角色",
  "Сцена и движения берутся из видео; внешность может отличаться.": "场景和动作取自视频，外貌可能有所不同。",
  "Только свои фото или с согласием человека на фото": "只能使用自己的照片，或经照片中本人同意的照片",
  "Фон": "背景",
  "Фото героя": "人物照片",
  "Фрагмент от {0} до {1} секунд": "{0} 到 {1} 秒的片段",
  "{0} символов": "{0} 个字符",
  "Авито": "Avito",
  "Английский": "英语",
  "Выберите аудио или видео": "选择音频或视频",
  "Выбрать": "选择",
  "Гарантия": "保修",
  "Да": "是",
  "Для чего нужен промпт": "提示词的用途",
  "Для этого инструмента сократите текст до 500 символов.": "此工具需要将文字缩短到 500 个字符以内。",
  "Добавьте текст": "添加文字",
  "Добавьте файл": "添加文件",
  "Дополнительные варианты": "更多版本",
  "Дополнительные варианты пока не подтверждены.": "更多版本尚未确认。",
  "Дружелюбный": "友好",
  "Загрузите запись или запишите голос. Распознавание начнётся после подтверждения.": "上传录音或录制声音。确认后开始识别。",
  "Исходное фото": "原始照片",
  "Как изменить текст": "如何修改文字",
  "Комплект": "套装内容",
  "Короткий": "简短",
  "Материал": "材质",
  "Музыка": "音乐",
  "На весь экран": "全屏",
  "Не удалось открыть инструмент. Проверьте аккаунт и длину текста.": "无法打开工具。请检查账号和文字长度。",
  "Не удалось подтвердить дополнительные варианты. Проверьте тот же запрос.": "无法确认更多版本。请查看同一请求。",
  "Не удалось скачать текст.": "无法下载文字。",
  "Не удалось скопировать текст.": "无法复制文字。",
  "Не удалось сохранить черновик. Создание заблокировано, чтобы не потерять данные.": "无法保存草稿。为避免数据丢失，已阻止创建。",
  "Нейтральный": "中性",
  "Нет": "否",
  "Объём описания": "描述长度",
  "Описание товара": "商品描述",
  "Повторить запрос с тем же ключом": "用同一个密钥重试请求",
  "Подарочный": "礼品",
  "Подробнее": "更详细",
  "Подробный": "详细",
  "Подтверждаю права на материалы": "我确认拥有素材的使用权",
  "Пожелания": "要求",
  "Показать время": "显示时间",
  "Показать всё": "显示全部",
  "Премиальный": "高端",
  "Проверить тот же запрос": "查看同一请求",
  "Продающий": "营销",
  "Промпт из видео пока недоступен.": "暂不支持从视频生成提示词。",
  "Промпт из фото": "从照片生成提示词",
  "Разделить по собеседникам": "按说话人区分",
  "Размеры": "尺寸",
  "Распознавание по ссылке YouTube пока недоступно.": "暂不支持通过 YouTube 链接识别。",
  "Распознать": "识别",
  "Редактировать текст": "编辑文字",
  "Сайт": "网站",
  "Сбросить сохранённый черновик": "重置已保存的草稿",
  "Скачать TXT": "下载 TXT",
  "Скопировать весь текст": "复制全部文字",
  "Собеседник {0}": "说话人 {0}",
  "Создать промпт": "创建提示词",
  "Создать сценарий": "创建脚本",
  "Создаём текст": "正在生成文字",
  "Сократите пожелания": "请缩短要求",
  "Сократите текст": "请缩短文字",
  "Список": "列表",
  "Текст готов": "文字已完成",
  "Текст из аудио и видео": "音视频转文字",
  "Текст не создан": "文字未生成",
  "Тестовый режим без списания": "测试模式，不扣费",
  "Тон описания": "描述语气",
  "Улучшить промпт": "优化提示词",
  "Уход": "保养",
  "Что добавить в описание": "描述中要添加什么",
  "Экспертный": "专业",
  "Язык": "语言",
  "Яндекс Маркет": "Yandex Market",
  "Добавьте фото в открывшемся инструменте.": "请在打开的工具中添加照片。",
  "Не удалось открыть фото.": "无法打开照片。",
  "Текст для видео": "视频文字",
  "Цена этого выбора пока не подтверждена": "此选项的价格尚未确认",
  "C за фото": "C/张照片",
  "C за секунду": "C/秒",
  "Обычный": "普通",
  "Кто повторил": "模仿者",
  "Человек с фото": "照片中的人",
  "Сменить фон": "更换背景",
  "Убрать лишнее": "去除杂物",
  "Добавить очки": "添加眼镜",
  "Причёска": "发型",
  "Улыбка": "微笑",
  "Деловой образ": "商务造型",
  "Летний фон": "夏日背景",
  "Машет рукой": "挥手",
  "Ветер": "风",
  "Плавнее": "更流畅",
  "Ярче": "更明亮",
  "День в ночь": "白天变黑夜",
  "Снег": "雪",
  "Очки": "眼镜",
  "Что должно быть на фото? Например: девушка с зонтом на мокрой улице, вечер, огни витрин": "照片里要有什么？例如：雨后街道上撑伞的女孩，傍晚，橱窗灯光",
  "Что поменять на фото? Например: замени фон на ночной город, добавь очки": "照片要改什么？例如：把背景换成夜晚的城市，加上眼镜",
  "Что добавить или поменять? Например: деловой костюм, лёгкая улыбка": "要添加或修改什么？例如：商务西装，淡淡的微笑",
  "Что происходит в ролике? Например: камера медленно летит над ночным городом, огни и мокрый асфальт": "视频里发生了什么？例如：镜头缓缓飞过夜晚的城市，灯光和湿漉漉的柏油路",
  "Как двигаться? Например: улыбается и машет рукой, ветер в волосах": "怎么动？例如：微笑着挥手，风吹动头发",
  "Что поменять в видео? Например: замени фон на ночной город, добавь снег": "视频要改什么？例如：把背景换成夜晚的城市，加上雪",
  "Что добавить? Например: движения плавнее, ярче": "要添加什么？例如：动作更流畅，更明亮",
  "Сменить голос в записи": "更换录音中的声音",
  "Загрузите запись": "上传录音",
  "Ваша речь зазвучит выбранным голосом": "你的话会用所选声音说出来",
  "Голосовое, интервью или заметку: уберём шум": "语音消息、采访或笔记：我们来去除噪音",
  "Библиотека и ваши клоны": "声音库和你的声音克隆",
  "Без переозвучки, выберите другой": "不支持变声，请选择其他声音",
  "· Мой голос": "· 我的声音",
  "· ещё {0}+ голосов": "· 还有 {0}+ 个声音",
  "Убрать шум": "去除噪音",
  "Перед сменой голоса уберём фон и эхо": "更换声音前会先去除背景音和回声",
  "Оставим только голос, без фона и эха": "只保留人声，去除背景音和回声",
  "Голосовым или файлом: выберете, когда запись будет готова": "以语音消息或文件发送：录音完成后再选择",
  "Сменить голос": "更换声音",
  "Сделать голосовым": "转为语音消息",
  "{0} · от {1} C": "{0} · {1} C 起",
  "Сначала остановите запись": "请先停止录音",
  "Загрузите или запишите аудио": "上传或录制音频",
  "Читаем запись, секунду": "正在读取录音，请稍候",
  "Запись длиннее {0}, загрузите короче": "录音超过 {0}，请上传更短的",
  "Выберите голос, которым зазвучит запись": "选择录音要使用的声音",
  "Этот голос не умеет переозвучку, выберите другой": "此声音不支持变声，请选择其他声音",
  "Пауза": "暂停",
  "Длиннее {0}": "超过 {0}",
  "Звучит запись": "正在播放录音",
  "Прослушать запись": "试听录音",
  "Загрузите запись короче": "请上传更短的录音",
  "Запись с микрофона": "麦克风录音",
  "Без шума": "无噪音",
  "Как в записи": "与录音相同",
  "Слушать": "试听",
  "Отправить голосовым": "以语音消息发送",
  "Отправить файлом": "以文件发送",
  "Голосовое в чате": "聊天中的语音消息",
  "Файл в чате": "聊天中的文件",
  "Голосовое в чате, в отдельной теме": "聊天中的语音消息，在单独的话题中",
  "Файл в чате, в отдельной теме": "聊天中的文件，在单独的话题中",
  "Тут откроется тема чата, куда бот прислал голосовое": "这里会打开机器人发送语音消息的聊天话题",
  "Тут откроется тема чата, куда бот прислал запись": "这里会打开机器人发送录音的聊天话题",
  "Меняем голос": "正在更换声音",
  "Собираем запись": "正在合成录音",
  "Шум убран": "噪音已去除",
  "Запись готова": "录音已完成",
  "Голос изменён": "声音已更换",
  "Можно уйти с экрана: бот напишет, когда запись будет готова.": "可以离开此页面：录音完成后机器人会通知你。",
  "Голос ваш, шума больше нет.": "还是你的声音，噪音没了。",
  "Голос ваш, запись готова стать голосовым.": "还是你的声音，录音可以转为语音消息了。",
  "Слова и интонация ваши, голос новый.": "你的话语和语调，全新的声音。",
  "Пришлём в чат голосовым или файлом, как удобнее.": "我们会以语音消息或文件发送到聊天，随你选择。",
  "Запись ещё собирается": "录音仍在合成中",
  "Заставить говорить": "让它说话",
  "Заменить запись": "替换录音",
  "Загружаем запись": "正在上传录音",
  "Запись загружена": "录音已上传",
  "Запись собрана": "录音已合成",
  "Запись не прошла проверку": "录音未通过审核",
  "запись не собрана": "录音未合成",
  "голос не изменён": "声音未更换",
  "Не получилось убрать шум": "无法去除噪音",
  "Не получилось собрать запись": "无法合成录音",
  "Не получилось сменить голос": "无法更换声音",
  "Обновить форму": "刷新表单",
  "Запись {0}": "录音 {0}",
  "Проверяем доступность": "正在检查可用性",
  "Загрузите запись заново": "请重新上传录音",
  "Не удалось выбрать голос. Попробуйте ещё раз.": "无法选择声音。请重试。",
  "Запись здесь недоступна, загрузите файл": "此处无法录音，请上传文件",
  "Не удалось прочитать запись, попробуйте ещё раз": "无法读取录音，请重试",
  "Ваш голос": "你的声音",
  "в аудио": "音频中",
  "со скидкой, {0} водяной знак": "折扣价，水印 {0}",
  "Запись ещё загружается": "录音仍在加载",
  "Проверяем отправку": "正在检查发送",
  "Этот способ отправки сейчас недоступен": "此发送方式暂不可用",
  "Отправка пока не подтверждена. Нажмите ещё раз — проверим тот же запрос.": "发送尚未确认。再点一次，我们会查看同一请求。",
  "Не удалось передать запись. Откройте работу в «Истории» и попробуйте снова.": "无法传递录音。请在「历史」中打开作品后重试。",
  "Попробовать ещё раз": "再试一次",
  "Проверить ещё раз": "再检查一次",
  "К настройкам": "返回设置",
  "Заказ не создан": "订单未创建",
  "Заказ не подтверждён": "订单未确认",
  "остаток": "余额",
  "Права на материалы": "素材使用权",
  "Только свои файлы или с согласия владельца": "只能使用自己的文件，或经所有者同意的文件",
  "Загружаем файл": "正在上传文件",
  "Создаём": "正在创建",
  "Файл больше {0} МБ, загрузите меньше": "文件超过 {0} MB，请上传更小的",
  "Фото меньше {0} × {1} пикселей, загрузите крупнее": "照片小于 {0} × {1} 像素，请上传更大的",
  "Видео длиннее {0}, загрузите короче": "视频超过 {0}，请上传更短的",
  "Запись короче {0}, загрузите длиннее": "录音短于 {0}，请上传更长的",
  "Видео короче {0}, загрузите длиннее": "视频短于 {0}，请上传更长的",
  "Не удалось открыть фото. Загрузите его заново.": "无法打开照片。请重新上传。",
  "Не удалось открыть видео. Загрузите его заново.": "无法打开视频。请重新上传。",
  "Можно до {0} фото": "最多 {0} 张照片",
  "Этот человек не участвует": "此人不参与",
  "Добавьте фото": "添加照片",
  "Файл не читается, загрузите другой": "无法读取文件，请上传其他文件",
  "Запись слишком короткая": "录音太短",
  "Не удалось открыть запись для прослушивания. Загрузите её заново.": "无法打开录音进行试听。请重新上传。",
  "Файл не прошёл проверку. Выберите другой файл.": "文件未通过检查。请选择其他文件。",
  "Слишком много загрузок подряд. Подождите минуту и выберите файл снова.": "连续上传次数过多。请等一分钟后再选择文件。",
  "Файл не принят. Выберите его снова.": "文件未被接受。请重新选择。",
  "Выбранный персонаж, голос или шаблон стал недоступен. Выберите другой — заказ не создан.": "所选角色、声音或模板已不可用。请选择其他的 — 订单未创建。",
  "Создание сейчас недоступно. Заказ не создан, Circle не списаны.": "暂时无法创建。订单未创建，未扣除 Circle。",
  "Предыдущая работа ещё создаётся. Когда она будет готова, отправьте заказ снова.": "上一个作品仍在生成中。完成后请重新提交订单。",
  "Политику и запрещённые темы не пропускаем.": "不接受政治和违禁话题。",
  "{0} C списаны, {1}.": "已扣除 {0} C，{1}。",
  "{0} C вернулись на баланс.": "{0} C 已退回余额。",
  ", на шаге «{0}»": "，在「{0}」步骤",
  "Сбой на нашей стороне": "我们这边出了问题",
  "{0} или {1}": "{0} 或 {1}",
  "до {0}": "最多 {0}",
  "Записать": "录制",
  "Заменить": "替换",
  "Нужна запись: MP3, WAV или M4A": "需要录音：MP3、WAV 或 M4A",
  "Нужно фото: JPG или PNG": "需要照片：JPG 或 PNG",
  "Нужно видео: MP4 или MOV": "需要视频：MP4 或 MOV",
  "Нужен файл PDF, DOCX или TXT": "需要 PDF、DOCX 或 TXT 文件",
  "Нужно фото или видео": "需要照片或视频",
  "Файл больше {0} МБ": "文件超过 {0} MB",
  "Остановить запись": "停止录音",
  "Запрашиваем микрофон": "正在请求麦克风",
  "Отменить запись": "取消录音",
  "{0} КБ": "{0} KB",
  "{0} МБ": "{0} MB",
  "Не хватает {0} C · Пополнить": "还差 {0} C · 充值",
  "Не хватает Circle": "Circle 不足",
  "Не хватает {0} C": "还差 {0} C",
  "На балансе {0} C, нужно {1} C": "余额 {0} C，需要 {1} C",
  "Создать за {0} вместо {1} C": "以 {0} 代替 {1} C 创建",
  "Создать за {0} C вместо {1} C": "以 {0} C 代替 {1} C 创建",
  "Со скидкой всё равно не хватает {0}": "使用折扣后仍差 {0}",
  "Со скидкой всё равно не хватает {0} C": "使用折扣后仍差 {0} C",
  "Для этой работы скидки нет": "此作品没有折扣",
  "Сделать дешевле на {0}%, с водяным знаком": "便宜 {0}%，带水印",
  "Сделать дешевле на 10%, с водяным знаком": "便宜 10%，带水印",
  "Назад в студию": "返回工作室",
  "Работа ещё создаётся": "作品仍在生成中",
  "Ваше фото": "你的照片",
  "Ваши фото": "你的照片",
  "Ваш текст": "你的文字",
  "Ваша тема": "你的主题",
  "Тема поста": "帖子主题",
  "Готовые кадры": "成片",
  "Готовый кружок": "完成的圆形视频",
  "Готовый ролик": "完成的视频",
  "Готовое фото": "完成的照片",
  "Готовая аватарка": "完成的头像",
  "Готовые слайды": "完成的幻灯片",
  "Готовый сюжет с вами: монтаж и музыка уже в шаблоне": "由你主演的现成故事：剪辑和音乐已包含在模板中",
  "Пост в стиле шаблона, {0} на выбор": "模板风格的帖子，{0} 可选",
  "Аватарка для соцсетей и мессенджеров, {0} на выбор": "用于社交网络和聊天软件的头像，{0} 可选",
  "Фотосессия из {0} кадра в стиле шаблона": "模板风格的 {0} 张写真",
  "Фотосессия из {0} кадров в стиле шаблона": "模板风格的 {0} 张写真",
  "Ваш снимок оживёт в коротком ролике, {0} на выбор": "你的照片会在短视频中动起来，{0} 可选",
  "Персонаж скажет ваш текст в кружке Telegram, {0} на выбор": "角色会在 Telegram 圆形视频中说出你的文字，{0} 可选",
  "Карусель слайдов для поста, {0} на выбор": "帖子用的幻灯片轮播，{0} 可选",
  "{0} стиль": "{0} 种风格",
  "{0} стиля": "{0} 种风格",
  "{0} стилей": "{0} 种风格",
  "{0}, выберете на следующем шаге": "{0}，下一步再选",
  "Что скажет герой, до 250 знаков": "人物要说的话，最多 250 字",
  "1 фото": "1 张照片",
  "Любое, где хорошо видно лицо": "任意能看清脸的照片",
  "Лицо крупно и при хорошем свете": "脸部特写，光线充足",
  "Селфи, лицо крупно": "自拍，脸部特写",
  "Снимок оживёт в ролике": "照片会在视频中动起来",
  "Или фото, из которых сделаем слайды": "或用来制作幻灯片的照片",
  "Стиль кружка": "圆形视频风格",
  "1 человек": "1 人",
  "Вы, близкие или персонаж": "你、亲友或角色",
  "Ваши дети, до {0}": "你的孩子，最多 {0} 个",
  "Ребёнок, одно фото": "孩子，一张照片",
  "Питомец, одно фото": "宠物，一张照片",
  "Вы или близкие, одно фото": "你或亲友，一张照片",
  "По желанию: вы, близкие или персонаж": "可选：你、亲友或角色",
  "По желанию: ваши дети, до {0}": "可选：你的孩子，最多 {0} 个",
  "По желанию: ребёнок, одно фото": "可选：孩子，一张照片",
  "По желанию: питомец, одно фото": "可选：宠物，一张照片",
  "По желанию: вы или близкие, одно фото": "可选：你或亲友，一张照片",
  "Reels": "Reels",
  "Аватар": "头像",
  "{0} кадр": "{0} 张",
  "{0} кадра": "{0} 张",
  "{0} кадров": "{0} 张",
  "Выбрать, кто играет: {0}": "选择谁来出演：{0}",
  "Сравнить: {0} и {1}": "对比：{0} 和 {1}",
  "Поровну": "各占一半",
  "Пример результата пока не опубликован": "结果示例尚未发布",
  "Результат сохранён в «Истории». В чат не отправляем — так выбрано в настройках.": "结果已保存到「历史」。根据你的设置，不会发送到聊天。",
  "Результат сохранён в «Истории».": "结果已保存到「历史」。",
  "Файл результата пока недоступен. Проверьте работу в «Истории».": "结果文件暂不可用。请在「历史」中查看作品。",
  ", голос для: {0}": "，声音用于：{0}",
  ", играет: {0}": "，出演：{0}",
  ": добавьте свои фото": "：添加自己的照片",
  ": добавьте фото": "：添加照片",
  "<b class=\"mono\">{0}</b> из <span class=\"mono\">{1}</span>": "<b class=\"mono\">{0}</b> / <span class=\"mono\">{1}</span>",
  "JPG или PNG, до 10 МБ": "JPG 或 PNG，最大 10 MB",
  "JPG, PNG · до {0} снимков": "JPG、PNG · 最多 {0} 张",
  "MP3, WAV или M4A, до 50 МБ": "MP3、WAV 或 M4A，最大 50 MB",
  "MP4 или MOV, до 200 МБ": "MP4 或 MOV，最大 200 MB",
  "PDF, DOCX или TXT, до 20 МБ": "PDF、DOCX 或 TXT，最大 20 MB",
  "{0} и {1}": "{0} 和 {1}",
  "{0} фото": "{0} 张照片",
  "{0} фото · как в жизни": "{0} 张照片 · 真实还原",
  "{0}, персонаж": "{0}，角色",
  "Анфас, вполоборота, с улыбкой и без": "正脸、侧脸，笑与不笑都要",
  "Без модели": "不用模特",
  "Без сильных теней и фильтров": "没有强烈阴影和滤镜",
  "Было": "之前",
  "В близких": "已存入亲友",
  "В кадре {0}": "画面中有 {0}",
  "В кадре уже {0} из {1}: снимите отметку с кого-нибудь": "画面中已有 {0}/{1} 人：请取消选择某人",
  "В кадре: {0}": "画面中：{0}",
  "В роли «{0}» не больше {1}": "「{0}」角色最多 {1} 个",
  "В роль «{0}» персонажи не входят": "角色不能出演「{0}」",
  "В роль «{0}» подходят {1}": "「{0}」适合 {1}",
  "Варианты делаются из ваших фото в разделе «Свой аватар». Выбранный встаёт в «Кто в кадре» на всех экранах.": "版本由「我的头像」中你的照片生成。选中的版本会出现在所有页面的「画面中的人」里。",
  "Ваш питомец из близких": "亲友中的宠物",
  "Ваш ребёнок из близких": "亲友中的孩子",
  "Ваши фото: один раз для всех инструментов": "你的照片：一次上传，所有工具通用",
  "Вкл": "开",
  "Впишите имя": "输入名字",
  "Все <span class=\"mono\">{0}</span>": "全部 <span class=\"mono\">{0}</span>",
  "Все варианты на виду": "所有选项一目了然",
  "Все персонажи": "全部角色",
  "Вы и персонажи": "你和角色",
  "Вы или персонаж": "你或角色",
  "Вы, близкие и персонажи": "你、亲友和角色",
  "Вы, свои фото": "你，自己的照片",
  "Вы: добавьте свои фото": "你：添加自己的照片",
  "Выберите вариант": "选择版本",
  "Выберите вариант для поля «{0}»": "为「{0}」选择一项",
  "Выберите ниже": "在下方选择",
  "Выберите одного": "选择一个",
  "Выберите, кто играет: {0}": "选择谁来出演：{0}",
  "Выберите, кто это для вас": "选择此人与你的关系",
  "Выбирать во всех инструментах без загрузки": "在所有工具中直接选择，无需再上传",
  "Выбор встанет во все инструменты": "所选内容将用于所有工具",
  "Выбрать «{0}»": "选择「{0}」",
  "Выбрать вариант": "选择版本",
  "Выбрать: {0}": "选择：{0}",
  "Выкл": "关",
  "Выключится, когда выберете вариант": "选择一项后自动关闭",
  "Группы": "分组",
  "Добавить": "添加",
  "Добавить в кадр": "加入画面",
  "Добавьте свои фото": "添加自己的照片",
  "Добавьте свои фото или вариант": "添加自己的照片或版本",
  "Добавьте фото: {0}": "添加照片：{0}",
  "Другой голос": "其他声音",
  "Ещё {0}: {1}": "还有 {0}：{1}",
  "Заготовки": "预设",
  "Загрузите файл": "上传文件",
  "Загрузить ещё": "继续上传",
  "Закрыть камеру": "关闭相机",
  "Запись недоступна. Загрузите видео.": "无法录制。请上传视频。",
  "Здесь подходят {0}": "这里适合 {0}",
  "Здесь только персонажи своей подборки": "这里只能选本合集的角色",
  "Играет: {0}": "出演：{0}",
  "Из ваших фото": "来自你的照片",
  "Из каталога": "来自目录",
  "Изменить ваши фото": "修改你的照片",
  "Изменить свои фото": "修改自己的照片",
  "Изменить: {0}": "修改：{0}",
  "Иллюстрация": "插画",
  "Имя": "名字",
  "Имя и фото · роли выбираются в ряду": "名字和照片 · 在行中选择角色",
  "Искать стиль": "搜索风格",
  "Каким вы будете": "你会是什么样子",
  "Камера · лицо в кадр": "相机 · 脸部入镜",
  "Камера · селфи в кадр": "相机 · 自拍入镜",
  "Камера недоступна · имитация": "相机不可用 · 模拟",
  "Камера недоступна. Загрузите файл.": "相机不可用。请上传文件。",
  "Каталог 2 400+ голосов, подборки": "2400+ 个声音的目录，合集",
  "Ко всем стилям": "返回全部风格",
  "Кто будет моделью на фото": "谁来当照片模特",
  "Кто играет: <b>{0}</b>": "出演：<b>{0}</b>",
  "Кто играет: {0}": "出演：{0}",
  "Кто это для вас": "此人与你的关系",
  "Лицо в круг, смотрите в камеру": "脸放进圆圈，看向镜头",
  "Люди": "人物",
  "Можно близких или персонажа": "可以是亲友或角色",
  "Можно ваших близких": "可以是你的亲友",
  "Можно до {0} видео": "最多 {0} 个视频",
  "Можно до {0} записей": "最多 {0} 段录音",
  "Можно до {0} записи": "最多 {0} 段录音",
  "Можно до {0} запись": "最多 {0} 段录音",
  "Можно до {0} файл": "最多 {0} 个文件",
  "Можно до {0} файла": "最多 {0} 个文件",
  "Можно до {0} файлов": "最多 {0} 个文件",
  "Можно и так, но 3 или больше снимков дадут сходство точнее": "这样也可以，但 3 张或更多照片会更像",
  "Можно и так, но 3 или больше фото дадут сходство точнее": "这样也可以，但 3 张或更多照片会更像",
  "Можно себя или близких": "可以是你自己或亲友",
  "Можно себя, близких или персонажа": "可以是你自己、亲友或角色",
  "На этом экране вы в кадре всегда": "在此页面中你始终在画面里",
  "Навсегда, вместе с фото": "永久删除，连同照片",
  "Нажмите, чтобы выбрать": "点按选择",
  "Найти": "查找",
  "Напишите пару слов, и мы предложим варианты": "写几个词，我们会给出建议",
  "Например: Барсик": "例如：小咪",
  "Например: Лёша": "例如：小李",
  "Нашли": "已找到",
  "Не получилось подготовить файл": "无法准备文件",
  "Не получилось улучшить. Попробуйте дописать пару слов": "无法优化。试着多写几个词",
  "Не помещается<span class=\"nfx\">: до {0} знаков</span>": "放不下<span class=\"nfx\">：最多 {0} 字</span>",
  "Необязательно: всё уже настроено": "可选：一切都已设置好",
  "Ничего не нашлось": "未找到任何内容",
  "Нужно выбрать": "需要选择",
  "Объём": "立体感",
  "Один раз для всех инструментов": "一次设置，所有工具通用",
  "Отменить свой вариант": "取消自定义选项",
  "Отметьте, кто будет в кадре · {0}": "勾选画面中的人 · {0}",
  "Персонажи": "角色",
  "Подберём сами": "我们来帮你选",
  "Подбираем варианты": "正在挑选选项",
  "Пожилой": "老年",
  "Поиск стилей": "搜索风格",
  "Пока нечего сохранять": "暂无可保存的内容",
  "Попробуйте другое слово": "试试其他词",
  "Порядок здесь один": "这里只有一种排序",
  "Примеры": "示例",
  "Пропадёт {0} вместе с фото. Вернуть не получится.": "将从{0}中移除，连同照片。此操作无法撤销。",
  "Пропадёт из близких вместе с фото. Вернуть не получится.": "将从亲友中移除，连同照片。此操作无法撤销。",
  "Пропадёт из близких и {0} вместе с фото. Вернуть не получится.": "将从亲友和{0}中移除，连同照片。此操作无法撤销。",
  "Профиль близкого": "亲友资料",
  "Разные ракурсы и выражения": "不同角度和表情",
  "Реалистичный": "写实",
  "Реалистичный, иллюстрация или 3D": "写实、插画或 3D",
  "Роли": "角色",
  "Роль «{0}»": "「{0}」角色",
  "Роль «{0}» для женского персонажа": "「{0}」需要女性角色",
  "Роль «{0}» для мужского персонажа": "「{0}」需要男性角色",
  "Роль «{0}» для персонажей своей подборки": "「{0}」只能由本合集的角色出演",
  "Свой вариант": "自定义",
  "Скачать здесь не получится": "此处无法下载",
  "Создайте новый вариант": "创建新版本",
  "Сортировка": "排序",
  "Сохранится в близких": "将保存到亲友",
  "Сохранить в близких": "保存到亲友",
  "Стало": "之后",
  "Только для этой фотосессии": "仅用于本次写真",
  "Удаление": "删除",
  "Удалить «{0}» {1}?": "要{1}删除「{0}」吗？",
  "Удалить «{0}» из близких?": "要从亲友中删除「{0}」吗？",
  "Удалить из близких": "从亲友中删除",
  "Удалить из фотосессии": "从写真中移除",
  "Удерживайте, чтобы посмотреть примеры": "长按查看示例",
  "Управление": "管理",
  "Файл готов. Нажмите ещё раз": "文件已准备好。再点一次",
  "Фото до 10 МБ, видео до 200 МБ": "照片最大 10 MB，视频最大 200 MB",
  "Фрагмент": "片段",
  "Что делает? Например: поправляет шарф": "在做什么？例如：整理围巾",
  "Что делают в кадре": "在画面中做什么",
  "Эта настройка здесь закреплена": "此设置在这里是固定的",
  "Этот голос не умеет переозвучку записи": "此声音不支持录音变声",
  "вариант «{0}»": "版本「{0}」",
  "взрослая": "成年",
  "взрослый": "成年",
  "всё видео умещается": "整段视频都能放下",
  "выберите": "请选择",
  "до <span class=\"mono\">{0}</span>": "最多 <span class=\"mono\">{0}</span>",
  "до {0} человек": "最多 {0} 人",
  "до {0} человека": "最多 {0} 人",
  "ещё {0} из {1}": "还剩 {0}/{1}",
  "женская роль": "女性角色",
  "из фотосессии": "从写真中",
  "из этой фотосессии": "从本次写真中",
  "камера": "相机",
  "максимум {0} секунд": "最长 {0} 秒",
  "максимум {0} секунда": "最长 {0} 秒",
  "максимум {0} секунды": "最长 {0} 秒",
  "можно до <span class=\"mono\">{0}</span>": "最多 <span class=\"mono\">{0}</span>",
  "мужская роль": "男性角色",
  "не из подборки этой роли": "不属于该角色的合集",
  "не подходит по возрасту": "年龄不符",
  "не участвует в этой фотосессии": "未参与本次写真",
  "необязательно": "可选",
  "нет фото": "无照片",
  "нужно выбрать": "需要选择",
  "нужно: Вы": "需要：你",
  "персонажи в эту роль не входят": "角色不能出演此角色",
  "питомец": "宠物",
  "по желанию": "可选",
  "пожилая": "老年",
  "пожилой": "老年",
  "ребёнок": "孩子",
  "роль для взрослого": "成人角色",
  "роль для женщины": "女性角色",
  "роль для мужчины": "男性角色",
  "роль для питомца": "宠物角色",
  "роль для ребёнка": "儿童角色",
  "роль для человека": "人物角色",
  "Попробуйте другое слово или сбросьте тему": "试试其他词或清除主题",
  "Искать среди {n}+ голосов": "在 {n}+ 个声音中搜索",
  "Голосов: {n}": "声音：{n}",
  "Персонажей: {n}": "角色：{n}",
  "Голосов: {0}": "声音：{0}",
  "Прослушать {n}": "试听 {n}",
  "Загружаем ещё {n}": "正在加载另外 {n} 个",
  "{a} из {b}": "{a}/{b}",
  "Подборка": "合集",
  "Закрыть подборку": "关闭合集",
  "По имени": "按名字",
  "Загружаем подборки…": "正在加载合集…",
  "Не удалось загрузить голоса": "无法加载声音",
  "Не удалось воспроизвести пример. Попробуйте ещё раз.": "无法播放示例。请重试。",
  "Мой голос": "我的",
  "Мои": "我的",
  "Своих голосов пока нет": "还没有自己的声音",
  "Клонируйте свой голос, и он появится на этой вкладке.": "克隆你的声音，它就会出现在这个标签页中。",
  "Клонировать голос": "克隆声音",
  "Открыть персонажа {0}": "打开角色 {0}",
  "От": "起",
  "Тренды недели": "本周热门",
  "Голоса, которые быстрее всего набирают заказы": "订单增长最快的声音",
  "Мужские": "男声",
  "Все мужские голоса библиотеки": "声音库中的全部男声",
  "Женские": "女声",
  "Все женские голоса библиотеки": "声音库中的全部女声",
  "Детские": "童声",
  "Детские и мультяшные голоса": "童声和卡通声音",
  "меню: Озвучка": "配音",
  "Системная": "跟随系统",
  "Для аватарки и ленты": "用于头像和动态",
  "Как снимок с телефона": "像手机拍的照片",
  "Для ленты": "用于动态",
  "На весь экран телефона": "手机全屏",
  "Для обложки и экрана": "用于封面和屏幕",
  "Станет голосом по умолчанию для озвучки.": "将成为配音的默认声音。",
  "Когда генерация закончится": "生成完成时",
  "Награды и серия": "奖励和连续签到",
  "Напомним о награде за день": "提醒领取每日奖励",
  "Новые шаблоны и стили": "新模板和新风格",
  "Не чаще раза в неделю": "每周最多一次",
  "Новости STEOS": "STEOS 新闻",
  "Только крупные обновления": "仅重大更新",
  "Тут откроется документ в браузере": "将在浏览器中打开文档",
  "Язык и валюта": "语言和货币",
  "Интерфейс и цены картой": "界面语言和银行卡价格",
  "новое|новых|новых": "新",
  "работа|работы|работ": "作品",
  "заказ|заказа|заказов": "订单",
  "Счётчики недоступны": "计数不可用",
  "История пуста": "历史为空",
  "Не задан": "未设置",
  "Недоступны": "不可用",
  "Срок истёк": "已过期",
  "Не удалась": "失败",
  "Готовится": "准备中",
  "Запрошено": "已申请",
  "Запрошено {0}": "已申请 {0}",
  "Недоступно": "不可用",
  "Пусто": "空",
  "Данные Mini App удалены": "Mini App 数据已删除",
  "Удаление данных не удалось": "数据删除失败",
  "Данные удалены частично": "数据已部分删除",
  "Удаление требует проверки": "删除需要核查",
  "Запрос удаления принят": "删除请求已受理",
  "Удаляем данные Mini App": "正在删除 Mini App 数据",
  "Удаление данных в очереди": "数据删除已排队",
  "STEOS ID сохранён": "STEOS ID 已保留",
  "Финансовые квитанции сохранены": "财务收据已保留",
  "Статус удаления не подтверждён": "删除状态未确认",
  "Удаление аккаунта": "删除账号",
  "Удалить данные Mini App?": "删除 Mini App 数据？",
  "Удалить аккаунт?": "删除账号？",
  "Работы, голоса и варианты «Вы» в Mini App удалятся. STEOS ID и финансовые квитанции сохранятся.": "Mini App 中的作品、声音和「你」的形象将被删除。STEOS ID 和财务收据会保留。",
  "Работы, голоса, варианты «Вы» и Circle удалятся. Вернуть их не получится.": "作品、声音、「你」的形象和 Circle 将被删除，且无法恢复。",
  "Удалить данные Mini App": "删除 Mini App 数据",
  "Удалить аккаунт": "删除账号",
  "Данные Mini App. STEOS ID сохранится": "仅 Mini App 数据，保留 STEOS ID",
  "Все данные удалятся навсегда": "所有数据将被永久删除",
  "В прототипе аккаунт не удаляется": "原型中不会删除账号",
  "Автовоспроизведение": "自动播放",
  "Пример при выборе голоса": "选择声音时播放示例",
  "Присылать в чат": "发送到聊天",
  "Готовые работы от бота": "机器人发送完成的作品",
  "Уведомления и отклик": "通知和触感反馈",
  "Данные": "数据",
  "Выгрузить данные": "导出数据",
  "Настройки создания сейчас только для чтения": "创建设置目前为只读",
  "Формат по умолчанию": "默认格式",
  "Для новых фото и видео": "用于新的照片和视频",
  "На экране создания их можно поменять для одной работы.": "可以在创建页面为单个作品更改。",
  "Сообщения приходят в чат с ботом": "消息会发送到与机器人的聊天中",
  "Бот напишет только в ответ на действия": "机器人只会回复你的操作",
  "Уведомления пока недоступны": "通知暂不可用",
  "Вибрация": "振动",
  "Лёгкий отклик на нажатия": "点按时轻微反馈",
  "Выгрузка данных": "数据导出",
  "Выгрузка запрошена": "已申请导出",
  "Пришлём архив в чат в течение суток": "我们会在 24 小时内把压缩包发送到聊天",
  "Настройки и доступные текстовые данные аккаунта": "设置和账号中可导出的文字数据",
  "Ссылка на архив придёт в чат с ботом": "压缩包链接会发送到与机器人的聊天中",
  "Готовые работы и заказы": "完成的作品和订单",
  "Клоны и записи образцов": "声音克隆和样本录音",
  "Ваши фото и варианты себя": "你的照片和「你」的形象",
  "Люди и питомцы из фотосессий": "写真中的人物和宠物",
  "Запросить выгрузку": "申请导出",
  "Готовим архив": "正在准备压缩包",
  "Это займёт несколько минут. Лист можно закрыть, выгрузка продолжится": "需要几分钟。可以关闭此页面，导出会继续进行",
  "Срок хранения архива истёк": "压缩包已过期",
  "Запросите новую выгрузку данных": "请重新申请数据导出",
  "Архив не собрался": "压缩包生成失败",
  "Запросите выгрузку ещё раз": "请重新申请导出",
  "Не вошли: {0}": "未包含：{0}",
  "Вошли частично: {0}": "部分包含：{0}",
  "Не входят в выгрузку: {0}": "不在导出范围内：{0}",
  "Часть данных недоступна. Точный состав указан в manifest.json внутри архива": "部分数据不可用。具体内容见压缩包内的 manifest.json",
  "Архив готов, но не полностью": "压缩包已就绪，但不完整",
  "Архив готов": "压缩包已就绪",
  "Скачать можно до {0}": "可下载至 {0}",
  "Архив в формате ZIP": "ZIP 格式压缩包",
  "Скачать архив": "下载压缩包",
  "Счётчики истории не загрузились": "历史计数加载失败",
  "Загружаем историю": "正在加载历史",
  "Проверьте связь и повторите загрузку": "请检查网络后重新加载",
  "История очищена": "历史已清空",
  "Голоса, варианты «Вы», близкие и Circle на месте": "声音、「你」的形象、亲友和 Circle 都还在",
  "Здесь появятся работы, когда вы что-то создадите": "创作内容后，作品会显示在这里",
  "Раздел «История»": "「历史」栏目",
  "Работы": "作品",
  "Фото, видео, кружки и озвучки": "照片、视频、圆形视频和配音",
  "Заказы": "订单",
  "Параметры и статусы генераций": "生成参数和状态",
  "Голоса, варианты «Вы», близкие и Circle останутся.": "声音、「你」的形象、亲友和 Circle 会保留。",
  "Удалить работы и заказы": "删除作品和订单",
  "Без возможности восстановления": "无法恢复",
  "Подтверждение удаления": "确认删除",
  "Попробовать: {0}": "试试：{0}",
  "Обновление": "更新",
  "Загружаем «Что нового»": "正在加载「新功能」",
  "Новых обновлений пока нет": "暂无新的更新",
  "Уведомления сейчас не сохранить": "暂时无法保存通知设置",
  "Настройки сейчас только для чтения": "设置目前为只读",
  "Выгрузка не запросилась. Попробуйте ещё раз": "导出申请失败。请重试",
  "Удалить всю историю?": "删除全部历史？",
  "{0}. Вернуть не получится.": "{0}。此操作无法撤销。",
  "История не очистилась. Попробуйте ещё раз": "历史未清空。请重试",
  "Удаление не началось. Попробуйте ещё раз": "删除未开始。请重试",
  "Не удалось загрузить настройки": "无法加载设置",
  "«Что нового» не загрузилось": "「新功能」加载失败",
  "Сохранение настроек сейчас недоступно": "暂时无法保存设置",
  "Настройки уже изменились, показываем актуальные": "设置已变更，显示最新设置",
  "Не удалось сохранить. Попробуйте ещё раз": "无法保存。请重试",
  "Настройки, ресурсы и история": "设置、素材和历史",
  "Данные Mini App": "Mini App 数据",
  "Учётная запись и финансовые данные STEOS ID": "STEOS ID 账号和财务数据",
  "Переписка с ботом": "与机器人的聊天记录",
  "Фото, аудио, видео и модели": "照片、音频、视频和模型",
  "Данные других продуктов STEOS": "其他 STEOS 产品的数据",
  "Рубли": "卢布",
  "Драмы": "德拉姆",
  "Евро": "欧元",
  "Доллары": "美元",
  "Другие языки": "其他语言",
  "Интерфейс и сообщения бота": "界面和机器人消息",
  "Цены картой покажем в этой валюте. Звёзды Telegram везде одинаковые.": "银行卡价格将以此货币显示。Telegram 星星在任何地区都一样。",
  "сегодня, {0}": "今天 {0}",
  "вчера, {0}": "昨天 {0}",
  "Старт": "Start",
  "Плюс": "Plus",
  "Про": "Pro",
  "Картой или СБП": "银行卡或 SBP",
  "СБП только для РФ": "SBP 仅限俄罗斯",
  "1 месяц": "1 个月",
  "3 месяца": "3 个月",
  "6 месяцев": "6 个月",
  "Год": "1 年",
  "год": "每年",
  "С днём рождения": "生日快乐",
  "С днём рождения. Пусть всё задуманное получается с первого раза": "生日快乐。愿你的每个计划都一次成功",
  "Просто так": "没什么理由",
  "Просто так. Пусть у тебя будет больше кружков и смешных голосов": "没什么理由，就是想让你多拍些圆形视频、多玩些有趣的声音",
  "Спасибо": "谢谢",
  "Спасибо, что ты рядом. Это маленький подарок от меня": "谢谢你一直在。这是我送你的小礼物",
  "С праздником": "节日快乐",
  "С праздником. Твори, снимай и удивляй": "节日快乐。尽情创作、拍摄，惊艳众人",
  "Для блога": "送给博主",
  "Для твоего блога: пусть ролики выходят чаще и легче": "送给你的博客：愿视频更新得更勤、更轻松",
  "Удачи": "祝你好运",
  "Удачи в новом проекте. Пусть голос и картинка будут такими, как задумано": "祝新项目顺利。愿声音和画面都如你所愿",
  "картой": "银行卡支付",
  "оплата картой каждый месяц": "每月银行卡扣费",
  "оплата картой за {0}": "银行卡支付 {0}",
  "{0} в месяц": "每月 {0}",
  "{0} за {1}": "{0} / {1}",
  "кружок|кружка|кружков": "圆形视频",
  "рилс|рилса|рилсов": "Reels",
  "свой голос|своих голоса|своих голосов": "自己的声音",
  "своего голоса|своих голосов|своих голосов": "自己的声音",
  "день|дня|дней": "天",
  "звезда|звезды|звёзд": "星星",
  "Подписаться на {0}": "订阅，{0}",
  "Продлевается каждый месяц, отмена в любой момент": "每月自动续费，可随时取消",
  "Без автопродления, Circle приходят каждый месяц": "不自动续费，Circle 每月到账",
  "Перейти на {0}": "切换到 {0}",
  "Сразу придут {0} C, а {1} больше не продлится": "立即到账 {0} C，{1} 将不再续费",
  "Сразу придут {0} C": "立即到账 {0} C",
  "Перейти на {0} с {1}": "{1} 起切换到 {0}",
  "До {0} остаётся {1}, потом {2}": "{1} 有效至 {0}，之后为 {2}",
  "Продлить на {0}": "续期 {0}",
  "Ещё {0} после {1}, без автопродления": "{1} 之后再续 {0}，不自动续费",
  "Следующее списание {0}, {1}": "下次扣费 {0}，{1}",
  "Способ оплаты": "支付方式",
  "Звёздами": "用星星",
  "Тестовая оплата": "测试支付",
  "Звёзды и деньги не списываются": "不扣除星星和钱",
  "Оплата картой скоро": "银行卡支付即将上线",
  "Ваш тариф": "你的套餐",
  "выгоднее на {0}%": "省 {0}%",
  "{0} C в месяц": "每月 {0} C",
  "или": "或",
  "Что сотворим в этом месяце?": "这个月要创作什么？",
  "Готовы творить без пауз?": "准备好不停创作了吗？",
  "Ваш тариф {0}": "你的套餐：{0}",
  "{0} C каждый месяц": "每月 {0} C",
  "До {0} {1}": "最多 {0} {1}",
  "Пакеты Circle, если не хватит": "不够用时可买 Circle 包",
  "{0} включает": "{0} 包含",
  "Сравнить": "对比",
  "Помесячно": "按月",
  "Выгода {0}": "省 {0}",
  "Одним платежом": "一次性付款",
  "{0} с {1}": "{1} 起 {0}",
  "Оставить {0}": "保留 {0}",
  "Продлить {0}": "续订 {0}",
  "Продлить": "续订",
  "Включить продление": "开启续费",
  "Возобновить {0}": "恢复 {0}",
  "Возобновить": "恢复",
  "Оплата пока не подключена": "尚未接入支付",
  "Сейчас недоступно": "暂不可用",
  "Переход на {0} на {1}": "切换到 {0}，{1}",
  "Переход на {0}": "切换到 {0}",
  "Продление {0} на {1}": "续期 {0}，{1}",
  "Подписка {0} на {1}": "订阅 {0}，{1}",
  "Как удобнее оплатить": "选择支付方式",
  "Подарок друга": "好友的礼物",
  "{0} на первый пакет {1} после подписки": "订阅后首个 {1} 包享 {0}",
  "Не загрузилось": "加载失败",
  "Прошлую операцию не проверить": "无法查看上一笔操作",
  "разрешите хранение данных и откройте раздел снова": "请允许数据存储后重新打开此栏目",
  "Оплата требует проверки": "支付需要核查",
  "Исход подтверждения оплаты ещё неизвестен": "支付确认结果尚不明确",
  "Исход отмены счёта неизвестен": "账单取消结果不明确",
  "Ждём подтверждения оплаты": "等待支付确认",
  "Исход прошлой операции неизвестен": "上一笔操作结果不明确",
  "проверьте его перед новой покупкой": "请在再次购买前先查看",
  "Проверить": "查看",
  "Открыть оплату": "打开支付",
  "Отменить счёт": "取消账单",
  "Продление отменено": "续费已取消",
  "Сообщение со старым счётом может прийти. Оно не подтверждает новую подписку": "旧账单的消息仍可能送达，它不代表新的订阅",
  "Продление требует проверки": "续费需要核查",
  "Счёт не подтверждён. Обновите данные или обратитесь в поддержку": "账单未确认。请刷新数据或联系支持",
  "Не удалось подготовить счёт": "无法生成账单",
  "Сервер повторит проверку. Текущие права не меняются": "服务器会再次核查。当前权益不变",
  "Счёт отправлен": "账单已发送",
  "Бот прислал счёт. Подписка начнётся после подтверждённой оплаты": "机器人已发送账单。支付确认后订阅即生效",
  "Счёт подготовлен": "账单已生成",
  "Передан боту. Доставка и оплата ещё не подтверждены": "已交给机器人。送达和支付尚未确认",
  "Срок счёта истёк": "账单已过期",
  "Продление не оплачено. Выберите тариф ещё раз": "续费未支付。请重新选择套餐",
  "Запланированное продление отменено": "已取消预定的续费",
  "Текущий тариф не меняется. Для новой подписки потребуется отдельная оплата": "当前套餐不变。新的订阅需要另行支付",
  "Продление запланировано": "已预定续费",
  "Счёт на свою подписку придёт в конце подарочного месяца": "你自己订阅的账单会在礼品月结束时发送",
  "Подарок ещё действует": "礼物仍有效",
  "Месячная подписка будет доступна после его окончания. Сейчас можно продлить на 3 или 12 месяцев": "礼物到期后才能按月订阅。目前可以续期 3 或 12 个月",
  "выберите другой тариф или срок": "请选择其他套餐或期限",
  "−{0}% на первый пакет · ещё {1}": "首个包享 −{0}% · 还剩 {1}",
  "Circle из пакетов не сгорают": "Circle 包中的 Circle 永不过期",
  "Подарить другу": "送给好友",
  "С открыткой, без продления": "附贺卡，不续费",
  "Промокод {0}": "优惠码 {0}",
  "{0} C, сгорят {1}": "{0} C，{1} 过期",
  "Промокод применён": "优惠码已使用",
  "{0} C и {1} на первый пакет": "{0} C，首个包享 {1}",
  "после подписки": "订阅后",
  "Вы пришли по ссылке партнёра": "你通过合作伙伴链接而来",
  "привязка уже действует": "绑定已生效",
  "Есть промокод?": "有优惠码？",
  "Загружаем тарифы": "正在加载套餐",
  "Счёт придёт {0}": "账单将于 {0} 发送",
  "Счёт придёт в конце текущего срока": "账单将在当前期限结束时发送",
  "Новый тариф начнётся после оплаты. Сейчас ничего не списывается.": "新套餐在支付后开始。现在不扣费。",
  "Оплата подтверждена": "支付已确认",
  "Оплаченный период уже закончился. Circle за прошедший период не начисляются.": "已付费期限已结束，过去期间的 Circle 不再发放。",
  "Баланс пополнен": "余额已充值",
  "Теперь на балансе {0} C. Circle из пакетов не сгорают": "当前余额 {0} C。Circle 包中的 Circle 永不过期",
  "следующие {0} C придут {1}": "下一批 {0} C 将于 {1} 到账",
  "До этой даты действует {0}": "在此日期前 {0} 有效",
  "{0} продлён до {1}": "{0} 已续期至 {1}",
  "Circle приходят каждый месяц, {0}": "Circle 每月到账，{0}",
  "Тариф {0} подключён": "{0} 套餐已开通",
  "Подписка {0} оформлена": "{0} 订阅已开通",
  "Оплачено до {0}. Circle приходят каждый месяц, {1}": "已付费至 {0}。Circle 每月到账，{1}",
  "Тестовая подписка действует до {0}. Звёзды и деньги не списываются": "测试订阅有效期至 {0}。不扣除星星和钱",
  "Circle действуют до {0}, тогда же следующее списание {1}": "Circle 有效期至 {0}，届时下次扣费 {1}",
  "Circle действуют до {0}, продление выключено": "Circle 有效期至 {0}，已关闭续费",
  "В месяц": "每月",
  "Кружки или фото": "圆形视频或照片",
  "Видео говорит": "视频说话",
  "Рилсы": "Reels",
  "Сравнение тарифов": "套餐对比",
  "В любом тарифе {0} {1} вместо {2}, все инструменты студии и пакеты Circle": "所有套餐均享 {0} {1}（原价 {2}）、全部工作室工具和 Circle 包",
  "Следующее списание": "下次扣费",
  "Сумма": "金额",
  "Тестовая, без списаний": "测试，不扣费",
  "Картой": "银行卡",
  "Оплачено до": "已付费至",
  "Действует до": "有效期至",
  "Потом": "之后",
  "Продление": "续费",
  "Счёт на {0} запланирован": "{0} 的账单已预定",
  "подписку": "订阅",
  "Придёт {0}. Новый тариф начнётся после оплаты": "将于 {0} 发送。新套餐在支付后开始",
  "Отменить": "取消",
  "Отменить подписку": "取消订阅",
  "Тариф останется до {0}": "套餐保留至 {0}",
  "Потом тариф {0}": "之后为 {0} 套餐",
  "Подарок на месяц": "一个月礼物",
  "Оплачено вперёд": "已预付",
  "Подписка {0}": "{0} 订阅",
  "Условия тарифа уточняются": "套餐条件待确认",
  "Сменить тариф": "更换套餐",
  "Отмена подписки": "取消订阅",
  "Этот переход сейчас недоступен": "暂时无法切换到此套餐",
  "Переход уже назначен": "已预定切换",
  "Выберите другой тариф": "请选择其他套餐",
  "С {0} начнётся этот тариф": "此套餐将于 {0} 开始",
  "Это ваш тариф": "这是你当前的套餐",
  "К подписке": "返回订阅",
  "Сейчас {0}, {1}": "当前 {0}，{1}",
  "Латиница, цифры и «_»": "拉丁字母、数字和「_」",
  "Ник начинается с буквы": "用户名需以字母开头",
  "Не короче 5 знаков": "至少 5 个字符",
  "Не длиннее 32 знаков": "最多 32 个字符",
  "Ник не кончается на _": "用户名不能以 _ 结尾",
  "Это ваш ник": "这是你自己的用户名",
  "Сначала проверьте прежнюю операцию": "请先查看上一笔操作",
  "Подарок сейчас недоступен": "暂时无法赠送",
  "Укажите ник друга в Telegram": "填写好友的 Telegram 用户名",
  "Проверьте ник": "请检查用户名",
  "Друг увидит: {0}": "好友会看到：{0}",
  "Подарок придёт без имени": "礼物将匿名送出",
  "{0} дарит вам": "{0} 送你",
  "вам подарили": "你收到了",
  "Вам подарили": "你收到了",
  "{0} подписку STEOS {1} на месяц.": "{0}一个月的 STEOS {1} 订阅。",
  "Забрать подарок": "领取礼物",
  "От друга": "来自好友",
  "{0} C и {1} {2}": "{0} C 和 {1} {2}",
  "Подарить {0}": "赠送 {0}",
  "Тестовый подарок: звёзды и деньги не списываются": "测试礼物：不扣除星星和钱",
  "На месяц, без продления": "一个月，不续费",
  "Тариф подарка": "礼物套餐",
  "Кому": "送给",
  "ник друга в Telegram": "好友的 Telegram 用户名",
  "Ник друга в Telegram": "好友的 Telegram 用户名",
  "Пожелание": "祝福语",
  "Пара тёплых слов, по желанию": "写几句暖心的话（可选）",
  "Подписать от меня": "以我的名义署名",
  "Так увидит друг": "好友看到的样子",
  "Подарок оформлен для {0}": "已为 {0} 准备好礼物",
  "Подарок отправлен {0}": "礼物已发送给 {0}",
  "Бот прислал открытку со ссылкой «Забрать подарок» в подписи.": "机器人已发送贺卡，说明中附有「领取礼物」链接。",
  "Месяц {0} начнётся, когда друг заберёт подарок": "好友领取礼物后，{0} 的一个月开始计算",
  "Друг ещё не запускал STEOS? Перешлите открытку сами": "好友还没打开过 STEOS？请自己转发贺卡",
  "Переслать": "转发",
  "Загружаем подарок": "正在加载礼物",
  "Вам подарок": "给你的礼物",
  "Подписка STEOS на месяц": "一个月的 STEOS 订阅",
  "Этот подарок предназначен {0}. Перешлите получателю открытку со ссылкой.": "此礼物是送给 {0} 的。请把附有链接的贺卡转发给收礼人。",
  "Подарок уже получен": "礼物已被领取",
  "Подарок добавлен": "礼物已添加",
  "Подписка {0} подключена": "{0} 订阅已开通",
  "Circle подарка сгорят {0}": "礼物中的 Circle 将于 {0} 过期",
  "Месяц без продления, Circle действуют до {0}": "一个月，不续费，Circle 有效期至 {0}",
  "У вас уже есть {0}: подарок добавит {1} C, они сгорят через месяц": "你已有 {0}：礼物会增加 {1} C，一个月后过期",
  "Придут {0} C и {1} {2}. Подписка не продлится сама": "你将获得 {0} C 和 {1} {2}。订阅不会自动续费",
  "За последние 7 дней": "最近 7 天",
  "Потрачено": "已消费",
  "Начислено": "已入账",
  "Пакеты пока недоступны": "Circle 包暂不可用",
  "Пакет": "Circle 包",
  "Оплата пакетов пока не подключена": "Circle 包支付尚未接入",
  "Введите промокод": "输入优惠码",
  "Применить": "使用",
  "Промокод партнёра работает до первой покупки, промокод STEOS можно применить один раз": "合作伙伴优惠码在首次购买前有效，STEOS 优惠码只能使用一次",
  "От партнёра или от STEOS": "来自合作伙伴或 STEOS",
  "Например, ANNA24": "例如：ANNA24",
  "Не удалось загрузить операции": "无法加载交易记录",
  "Начисление": "入账",
  "Списание": "扣费",
  "Загружаем операции": "正在加载交易记录",
  "Журнал STEOS ID": "STEOS ID 记录",
  "Операций пока нет": "暂无交易记录",
  "Применение не подтверждено. Проверьте прежний запрос": "使用尚未确认。请查看之前的请求",
  "Отменить подписку?": "取消订阅？",
  "Тариф {0} останется до {1}, потом не продлится.": "{0} 套餐保留至 {1}，之后不再续费。",
  "Оставить": "保留",
  "Не удалось подготовить открытку": "无法准备贺卡",
  "Откройте Mini App в Telegram, чтобы переслать открытку": "请在 Telegram 中打开 Mini App 来转发贺卡",
  "Отправка отменена": "已取消发送",
  "Ссылка на подарок скопирована": "礼物链接已复制",
  "Не получилось. Попробуйте ещё раз": "没有成功。请重试",
  "Счёт отменён": "账单已取消",
  "Оплата не завершена": "支付未完成",
  "Подтверждение оплаты": "支付确认",
  "Проверяем подтверждение оплаты": "正在核查支付确认",
  "Проверяем отмену счёта": "正在核查账单取消",
  "Telegram начал подтверждение счёта. Его исход ещё неизвестен. Не оплачивайте повторно: проверяйте этот счёт или обратитесь в поддержку.": "Telegram 已开始确认账单，结果尚不明确。请勿重复支付：请查看此账单或联系支持。",
  "Подарок будет оформлен после подтверждения сервера. Месяц подписки начнётся, когда друг заберёт подарок. Возврат из окна оплаты ещё не означает, что платёж завершён.": "服务器确认后礼物才会生效。好友领取礼物后，一个月的订阅开始计算。从支付窗口返回并不代表支付已完成。",
  "Circle поступят на баланс после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "服务器确认后 Circle 将到账余额。从支付窗口返回并不代表支付已完成。",
  "Circle и подписка появятся после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "服务器确认后 Circle 和订阅才会生效。从支付窗口返回并不代表支付已完成。",
  "Не удалось открыть оплату. Проверьте прежний запрос": "无法打开支付。请查看之前的请求",
  "Откройте Mini App в Telegram, чтобы оплатить звёздами": "请在 Telegram 中打开 Mini App 来用星星支付",
  "Оплата ещё не подтверждена сервером": "服务器尚未确认支付",
  "Открытка готова. Откройте Mini App в Telegram, чтобы переслать её": "贺卡已准备好。请在 Telegram 中打开 Mini App 来转发",
  "Отменить счёт?": "取消账单？",
  "Отменится только этот неоплаченный счёт. Текущая подписка останется. Если оплата уже подтверждается, сервер не разрешит отмену.": "只会取消这张未支付的账单，当前订阅保留。如果支付已在确认中，服务器将不允许取消。",
  "Вернуться к оплате": "返回支付",
  "{0} на первый пакет после подписки": "订阅后首个包享 {0}",
  "{0} на первый пакет, ещё {1}": "首个包享 {0}，还剩 {1}",
  "{0} на первый пакет": "首个包享 {0}",
  "Промокод {0} применён": "优惠码 {0} 已使用",
  "Circle сгорят {0}": "Circle 将于 {0} 过期",
  "Circle начислены": "Circle 已入账",
  "Привязка к партнёру подтверждена": "合作伙伴绑定已确认",
  "Скидка {0}. Бонусные Circle сгорят {1}": "折扣 {0}。赠送的 Circle 将于 {1} 过期",
  "Привязка к партнёру действует": "合作伙伴绑定有效",
  "{0} C и {1}": "{0} C 和 {1}",
  "Открытка передана боту для доставки.": "贺卡已交给机器人发送。",
  "Бот готовит доставку открытки. Можно переслать её самостоятельно.": "机器人正在准备发送贺卡。你也可以自己转发。",
  "Доставка открытки не подтверждена. Можно переслать её самостоятельно.": "贺卡发送未确认。你可以自己转发。",
  "Сначала тратятся Circle со сроком: бонусные и по подписке, потом все остальные, а те, что можно вывести, в последнюю очередь.": "优先消耗有期限的 Circle（赠送和订阅的），然后是其余的，可提现的 Circle 最后消耗。",
  "Получатель не найден среди пользователей STEOS. Проверьте ник или попросите друга запустить бота.": "在 STEOS 用户中找不到收礼人。请检查用户名，或请好友先启动机器人。",
  "Условия оплаты изменились. Обновите данные.": "支付条件已变更。请刷新数据。",
  "Эту открытку может переслать только отправитель подарка.": "只有礼物的赠送者可以转发这张贺卡。",
  "Откройте чат с ботом и попробуйте ещё раз.": "请打开与机器人的聊天后重试。",
  "Доставка получателю не подтверждена. Перешлите открытку самостоятельно.": "未确认送达收礼人。请自己转发贺卡。",
  "Предложение не найдено. Обновите данные.": "未找到该优惠。请刷新数据。",
  "Такого промокода нет": "没有这个优惠码",
  "Срок действия промокода закончился": "优惠码已过期",
  "Этот промокод пока не действует": "此优惠码尚未生效",
  "Вы уже активировали этот промокод": "你已使用过此优惠码",
  "Промокод больше не действует": "此优惠码已失效",
  "Это ваш промокод": "这是你自己的优惠码",
  "Партнёрские промокоды работают только до первой покупки": "合作伙伴优惠码仅在首次购买前有效",
  "Промокод партнёра временно недоступен": "此合作伙伴优惠码暂时不可用",
  "Вы уже привязаны к партнёру": "你已绑定合作伙伴",
  "Получатель изменился. Отмените прежний неоплаченный счёт и проверьте ник перед новой покупкой.": "收礼人已变更。请取消之前未支付的账单，并在再次购买前检查用户名。",
  "Пожелание должно быть не длиннее 200 знаков, без управляющих символов.": "祝福语最多 200 个字符，且不能包含控制字符。",
  "Проверьте ник: получатель должен запускать STEOS, нельзя дарить себе": "请检查用户名：收礼人需启动过 STEOS，且不能送给自己",
  "Получатель сейчас занят. Повторите позже": "收礼人当前忙碌。请稍后重试",
  "Подарок не найден": "未找到礼物",
  "Этот подарок предназначен другому пользователю": "此礼物是送给其他用户的",
  "Не удалось подтвердить условия продления. Обновите тарифы.": "无法确认续费条件。请刷新套餐。",
  "Подписка изменилась. Обновите данные перед новым продлением.": "订阅已变更。请先刷新数据再续费。",
  "Продление уже запланировано. Его можно отменить в управлении подпиской.": "已预定续费。可以在订阅管理中取消。",
  "Запланированное продление отменено. Обновите данные.": "已取消预定的续费。请刷新数据。",
  "Счёт будет доступен в конце текущего срока.": "账单将在当前期限结束时可用。",
  "Месячная подписка будет доступна после окончания подарка. Сейчас можно продлить на 3 или 12 месяцев.": "礼物到期后才能按月订阅。目前可以续期 3 或 12 个月。",
  "Предыдущее изменение подписки ещё проверяется. Повторите его проверку.": "上一次订阅变更仍在核查中。请再次核查。",
  "Изменение подписки ещё не подтверждено Telegram.": "Telegram 尚未确认订阅变更。",
  "Подписка изменилась. Обновите данные и повторите проверку.": "订阅已变更。请刷新数据后再次核查。",
  "Скидка уже закреплена за предыдущим счётом. Проверьте его оплату.": "折扣已绑定到上一张账单。请查看其支付情况。",
  "Счёт уже подтверждается или недоступен для отмены. Проверьте результат оплаты.": "账单已在确认中或无法取消。请查看支付结果。",
  "Оплата требует проверки. Сервер сохранил платёж; права пока не подтверждены. Не оплачивайте повторно — проверьте результат позже или обратитесь в поддержку.": "支付需要核查。服务器已保存付款，但权益尚未确认。请勿重复支付 — 请稍后查看结果或联系支持。",
  "Счёт отменён. Подписка и Circle по нему не начислены. Можно выбрать новую оплату.": "账单已取消，未发放订阅和 Circle。可以重新发起支付。",
  "Оплата не завершена. Деньги и Circle не подтверждены; можно начать новую оплату.": "支付未完成，款项和 Circle 均未确认；可以重新发起支付。",
  "Открытка готовится. Нажмите «Проверить», чтобы получить результат прежнего запроса.": "贺卡正在准备中。点按「查看」获取之前请求的结果。",
  "Подарить подписку": "赠送订阅",
  "Оплата подписки": "订阅支付",
  "Итог оплаты": "支付结果",
  "Подарок": "礼物",
  "Пакет Circle": "Circle 包",
  "лента: Хит": "热门",
  "настройки: Очистить историю": "清空历史",
  "Разделы, которых нет в меню": "不在菜单中的栏目",
  "Базовый": "基础",
  "Продвинутый": "进阶",
  "Амбассадор": "大使",
  "задание ждёт|задания ждут|заданий ждут": "个任务待完成",
  ", до +{0} C": "，最多 +{0} C",
  "Серия {0}, задания на сегодня": "连续 {0}，今日任务",
  "Задания на каждый день": "每日任务",
  "Всё созданное в одном месте": "所有创作集中在一处",
  "Пока пусто: всё созданное будет здесь": "暂时为空：你的创作会显示在这里",
  "{0}, последняя {1}": "{0}，最近一次 {1}",
  "тариф {0}": "{0} 套餐",
  "без подписки": "未订阅",
  "{0}, {1}% с покупок": "{0}，购买额的 {1}%",
  "{0} уровень, {1}% с покупок": "{0} 级，购买额的 {1}%",
  "До {0}% с покупок друзей": "好友购买额最高 {0}%",
  "ИИ-агент ответит сразу": "AI 助手即时回复",
  "Черновики ролей и реплик": "角色和台词草稿",
  "Тема, язык и валюта": "主题、语言和货币",
  "{0} ждут": "{0} 个等待中",
  "Тут Telegram откроет выбор чата: бот добавится в группу и будет работать там": "Telegram 会在这里打开聊天选择：机器人将加入群组并在群里工作",
  "голос {0}": "声音 {0}",
  "Искать в {0} {1}": "在 {0} {1} 中搜索",
  "работе|работах|работах": "作品",
  "Не прошло модерацию": "未通过审核",
  "Бесплатно": "免费",
  "Цена недоступна": "价格不可用",
  "Не удалось загрузить историю": "历史加载失败",
  "Проверьте написание или поищите по номеру заказа": "请检查拼写，或按订单号搜索",
  "Проверьте написание или поищите по названию, голосу или персонажу": "请检查拼写，或按标题、声音或角色搜索",
  "Сбросить поиск": "清除搜索",
  "В этой вкладке пока пусто": "这里还没有内容",
  "Отмечайте работы сердцем в карточке, чтобы быстро находить их здесь": "在作品卡片上点亮爱心，就能在这里快速找到",
  "Новые работы этого вида появятся здесь сами": "这类新作品会自动出现在这里",
  "Показать все": "显示全部",
  "Поиск по истории": "搜索历史",
  "Что показать": "显示内容",
  "Кружки, фото, видео, озвучки и тексты, которые вы создадите": "你创建的圆形视频、照片、视频、配音和文本",
  "Открыть студию": "打开工作室",
  "{0}: шаг {1} из {2}. Открыть": "{0}：第 {1} 步，共 {2} 步。打开",
  "Шаг {0} из {1}": "第 {0} 步，共 {1} 步",
  "{0}: {1}. Открыть": "{0}：{1}。打开",
  "Раскладка": "布局",
  "Широкий": "宽屏",
  "Инструмент": "工具",
  "голос|голоса|голосов": "个声音",
  "Как в оригинале": "与原版一致",
  "фото|фото|фото": "张照片",
  "слайд|слайда|слайдов": "张幻灯片",
  "снимок|снимка|снимков": "张照片",
  "кадр|кадра|кадров": "个镜头",
  "Длительность записи": "录音时长",
  "Цена": "价格",
  "Списание не подтверждено": "扣费未确认",
  "Кадры": "镜头",
  "знак|знака|знаков": "个字符",
  "пункт|пункта|пунктов": "项",
  "фраза|фразы|фраз": "句",
  "человек|человека|человек": "人",
  "Смотреть видео": "观看视频",
  "символ|символа|символов": "个字符",
  "Дорожка": "音轨",
  "фрагмент 1:00": "1:00 片段",
  "вся песня": "整首歌",
  "образец|образца|образцов": "个样本",
  "Свой голос": "自己的声音",
  "{0} C списаны": "已扣除 {0} C",
  "Работа ещё создаётся. Результат появится здесь и придёт в чат": "作品仍在创建中。结果会显示在这里，并发送到聊天",
  "Проверяем результат. Обычно это занимает пару минут": "正在检查结果，通常需要几分钟",
  "Не прошло модерацию. Политику и запрещённые темы не пропускаем, {0}": "未通过审核。我们不接受政治及违禁话题，{0}",
  "Не прошло модерацию. {0}": "未通过审核。{0}",
  "Не получилось. {0}": "出错了。{0}",
  "Не получилось. {0} C вернулись на баланс": "出错了。{0} C 已退回余额",
  "Удалится только запись о заказе": "只会删除订单记录",
  "Удаление из истории": "从历史中删除",
  "Смотреть: {0}": "观看：{0}",
  "В этой работе нет файлов для просмотра": "此作品没有可查看的文件",
  "Вернуть запись в историю не получится.": "记录删除后无法恢复。",
  "Файл в чате останется. Вернуть работу в историю не получится.": "聊天中的文件会保留。作品删除后无法恢复。",
  "Отправка пока не подтвердилась. Нажмите ещё раз": "发送尚未确认，请再点一次",
  "Принято": "已接受",
  "Бот пришлёт результат в чат": "机器人会把结果发到聊天",
  "Возврат обрабатывается": "退款处理中",
  "Не списано": "未扣费",
  "Circle не списаны": "未扣除 Circle",
  "Circle вернулись на баланс": "Circle 已退回余额",
  "Списание пока не подтверждено": "扣费尚未确认",
  "Возврат не подтверждён": "退款未确认",
  "Ожидаем подтверждения оплаты": "等待付款确认",
  "история: Повторить": "再做一次",
  "история: Кружки": "圆形视频",
  "Фотосессия из селфи": "自拍写真",
  "Рилс с вами": "有你的 Reels",
  "Фото говорит": "照片说话",
  "Слайды с преимуществами": "卖点幻灯片",
  "Карусель для поста": "帖子轮播图",
  "Коллаж из фото": "照片拼贴",
  "Карточка для маркетплейса": "电商平台商品卡片",
  "шаг|шага|шагов": "步",
  "вопрос|вопроса|вопросов": "个问题",
  "Открыть": "打开",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку: {0}.": "这个问题的回答未能确认。如果它很重要，请联系支持：{0}。",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку.": "这个问题的回答未能确认。如果它很重要，请联系支持。",
  "Ответ ещё не пришёл. Проверим этот же вопрос, второй раз он не задастся.": "回答还没到。我们会检查同一个问题，不会重复提问。",
  "Открыть профиль": "打开个人资料",
  "Войти через STEOS ID": "通过 STEOS ID 登录",
  "Тут Telegram откроет выбор чата": "Telegram 会在这里打开聊天选择",
  "Разделы поддержки": "支持分区",
  "Ответит сразу": "即时回复",
  "Отвечает сразу": "即时回复",
  "Поддержка в Telegram, {0}": "Telegram 支持，{0}",
  "Поддержка в Telegram": "Telegram 支持",
  "Видео медленнее обычного": "视频比平时慢",
  "Видео работает медленнее обычного": "视频处理比平时慢",
  "Спросить ИИ‑агента поддержки": "询问 AI 支持助手",
  "Отвечает сразу и знает всё о STEOS": "即时回复，熟悉 STEOS 的一切",
  "Поиск по вопросам и инструкциям": "搜索问题和说明",
  "Шесть коротких сторис о главном": "六个简短故事，讲清要点",
  "Попробуйте другие слова или спросите ИИ-агента": "换个关键词试试，或询问 AI 助手",
  "Проверено в {0}": "检查于 {0}",
  "Заказы не теряются: результат придёт в чат, а если что-то сорвётся, Circle вернутся на баланс.": "订单不会丢失：结果会发送到聊天，如果出现问题，Circle 会退回余额。",
  "Сервисы": "服务",
  "Загружаем статус сервисов": "正在加载服务状态",
  "Загружаем справку": "正在加载帮助",
  "Статус не загрузился": "状态加载失败",
  "Статус сервисов пока не отслеживается": "暂未监控服务状态",
  "Если что-то не работает, напишите в поддержку": "如果有功能无法使用，请联系支持",
  "Часть сервисов работает с перебоями": "部分服务运行不稳定",
  "Статусы ваших работ и подтверждённые возвраты смотрите в «Истории».": "作品状态和已确认的退款请在「历史」中查看。",
  "Справка не загрузилась": "帮助加载失败",
  "Справка пока не опубликована": "帮助尚未发布",
  "Вопрос можно задать поддержке в Telegram": "可以在 Telegram 上向支持提问",
  "Инструкции появятся после публикации справки": "帮助发布后会显示说明",
  "Назад к ИИ-агенту": "返回 AI 助手",
  "Инструкция · {0}": "说明 · {0}",
  "Вопрос · {0}": "问题 · {0}",
  "Справка": "帮助",
  "Вопрос из Справки": "来自帮助的问题",
  "Подробнее из Справки": "在帮助中了解更多",
  "Назад по таблице": "表格向后",
  "Вперёд по таблице": "表格向前",
  "Здравствуйте, {0}.": "你好，{0}。",
  "Здравствуйте.": "你好。",
  "Я ИИ-агент поддержки STEOS: подскажу про тарифы и Circle, инструменты и шаблоны, промокоды, STEOS ID и партнёрство. Спросите своими словами или выберите вопрос.": "我是 STEOS 的 AI 支持助手：可以解答套餐和 Circle、工具和模板、优惠码、STEOS ID 及合作伙伴计划等问题。用你自己的话提问，或选择一个问题。",
  "ИИ-агент печатает": "AI 助手正在输入",
  "ИИ-агент ещё отвечает": "AI 助手仍在回复",
  "Напишите вопрос": "输入问题",
  "Диалог с ИИ-агентом": "与 AI 助手的对话",
  "Распознаём…": "正在识别…",
  "Слушаю": "正在聆听",
  "Спросите о STEOS": "询问 STEOS 相关问题",
  "Вопрос ИИ-агенту": "向 AI 助手提问",
  "Остановить диктовку": "停止听写",
  "Сказать голосом": "语音输入",
  "Отправить": "发送",
  "Не удалось начать новый чат": "无法开始新聊天",
  "Спасибо, учтём": "谢谢，已记下",
  "Спасибо, передадим команде": "谢谢，我们会转告团队",
  "Оценка не сохранилась": "评分未保存",
  "Чат ещё загружается": "聊天仍在加载",
  "В чате уже {0} вопросов. Начните новый": "此聊天已有 {0} 个问题，请开始新聊天",
  "Вопрос не сохранился. Попробуйте ещё раз": "问题未保存，请重试",
  "Некоторые сервисы работают медленнее обычного": "部分服务比平时慢",
  "{0} не работают": "{0} 无法使用",
  "{0} не работает": "{0} 无法使用",
  "{0} медленнее обычного": "{0} 比平时慢",
  "{0} работают медленнее обычного": "{0} 比平时慢",
  "{0} работает медленнее обычного": "{0} 比平时慢",
  "Микрофон здесь недоступен": "此处无法使用麦克风",
  "Нет доступа к микрофону": "没有麦克风权限",
  "Нужна запись от 1 до 30 секунд": "录音需要 1 到 30 秒",
  "Не удалось разобрать запись": "无法识别录音",
  "Диктовка не распозналась. Нажмите микрофон, чтобы проверить ещё раз": "听写未识别。点击麦克风再试一次",
  "Вопрос не подошёл. Сформулируйте иначе": "这个问题不合适，请换个说法",
  "Ответ не подтвердился. Напишите в поддержку": "回答未能确认，请联系支持",
  "Ответ не пришёл. Проверьте ещё раз": "回答未到达，请再检查一次",
  "Говорящий кружок, видео и фото говорят, повтори движения, свой аватар": "会说话的圆形视频、视频说话、照片说话、模仿动作、自定义头像",
  "Оживить фото, видео по описанию, рилсы и сцены": "照片动起来、按描述生成视频、Reels 和场景",
  "Фото, фотосессии, товары, карусели": "照片、写真、商品、轮播图",
  "Голоса, клон, озвучка проектов, кавер": "声音、声音克隆、项目配音、翻唱",
  "Звёзды Telegram и карты": "Telegram Stars 和银行卡",
  "Не работает": "无法使用",
  "Как сделать по шагам": "分步操作",
  "Полезный ответ": "有帮助",
  "Ответ не помог": "没有帮助",
  "Проверьте связь и попробуйте ещё раз": "请检查网络后重试",
  "Не удалось проверить владельца чата": "无法验证聊天所有者",
  "Не удалось восстановить чат. Начните новый": "无法恢复聊天，请开始新聊天",
  "Клоны для озвучки": "用于配音的克隆声音",
  "Создайте первый голос": "创建你的第一个声音",
  "Люди и питомцы для фото": "用于照片的人物和宠物",
  "Добавьте близких для фото": "添加亲友用于照片",
  "Сохранённые работы": "已保存的作品",
  "Отмечайте работы сердцем": "点亮爱心收藏作品",
  "Ежедневная серия и бонусы": "每日连续签到和奖励",
  "Частые вопросы и связь с нами": "常见问题和联系我们",
  "Обучается": "训练中",
  "Аккаунт недоступен": "账号不可用",
  "Эта неделя · {0}": "本周 · {0}",
  "Неделя с {0} · {1}": "{0} 起的一周 · {1}",
  "ID скопирован": "ID 已复制",
  "Скопировать ID": "复制 ID",
  "Баланс временно недоступен": "余额暂时不可用",
  "Разбивка остатка временно недоступна": "余额明细暂时不可用",
  "Из них {0} C сгорит {1}|Из них {0} C сгорят {1}|Из них {0} C сгорят {1}": "其中 {0} C 将于 {1} 过期",
  "Ближайшие {0} C сгорят {1}": "最近的 {0} C 将于 {1} 过期",
  "Circle каждый месяц от {0}": "每月 {0} 起获得 Circle",
  "Circle каждый месяц с подпиской": "订阅后每月获得 Circle",
  "Тариф временно недоступен": "套餐暂时不可用",
  "Аккаунт, подписка и баланс": "账号、订阅和余额",
  "Статистика и моё": "统计和我的",
  "{0} к прошлой неделе": "较上周 {0}",
  "Работы по неделям: на этой неделе {0}": "每周作品：本周 {0}",
  "Работы по неделям: на этой неделе {0}, на прошлой {1}": "每周作品：本周 {0}，上周 {1}",
  "Статистика пока недоступна": "统计暂不可用",
  "Дата регистрации недоступна": "注册日期不可用",
  "С {0}": "自 {0} 起",
  "Создано": "已创建",
  "Серия": "连续",
  "день подряд|дня подряд|дней подряд": "天连续",
  "Общий аккаунт STEOS": "STEOS 通用账号",
  "Для вывода Circle": "用于提取 Circle",
  "До {0}% с их покупок": "最高可得其消费的 {0}%",
  "Обновлено {0}": "更新于 {0}",
  "Действия": "操作",
  "Сохранить имя": "保存名称",
  "Новое имя": "新名称",
  "Больше голосов с подпиской": "订阅可获得更多声音",
  "Создание голосов пока недоступно": "暂时无法创建声音",
  "Свободных мест нет": "没有空位",
  "с подпиской до {0}": "订阅后最多 {0} 个",
  "Пауза «{0}»": "暂停「{0}」",
  "Прослушать «{0}»": "试听「{0}」",
  "Переименовать": "重命名",
  "Запишите от 2 секунд речи или загрузите файлы, и голос будет звучать как вы": "录制 2 秒语音或上传文件，声音就会和你的一样",
  "Свободных мест нет. Удалите голос, чтобы записать новый": "没有空位。删除一个声音后才能录制新声音",
  "Выбрать за «Вы»": "设为「你」",
  "голос по умолчанию": "默认声音",
  "Сделать кружок с вариантом «{0}»": "用形象「{0}」制作圆形视频",
  "Выбраны": "已选择",
  "{0} фото|{0} фото|{0} фото": "{0} 张照片",
  "{0} фото · для всех инструментов|{0} фото · для всех инструментов|{0} фото · для всех инструментов": "{0} 张照片 · 适用于所有工具",
  "{0} вариант · кружки, фото и видео|{0} варианта · кружки, фото и видео|{0} вариантов · кружки, фото и видео": "{0} 个形象 · 圆形视频、照片和视频",
  "{0} вариант|{0} варианта|{0} вариантов": "{0} 个形象",
  "Голос {0} удалён, у варианта {1} теперь голос по умолчанию.": "声音 {0} 已删除，形象 {1} 现在使用默认声音。",
  "Голоса удалены, у вариантов {0} теперь голос по умолчанию.": "声音已删除，形象 {0} 现在使用默认声音。",
  "Другой голос можно выбрать у каждого кружка": "每个圆形视频都可以单独选择声音",
  "Вариантов пока нет": "还没有形象",
  "Загрузите свои фото, и вариант себя будет говорить вашим голосом в кружках, фото и видео": "上传你的照片，你的形象就能在圆形视频、照片和视频中用你的声音说话",
  "Вы: свои фото и варианты": "你：自己的照片和形象",
  "добавьте фото": "添加照片",
  "Изменить «{0}»": "修改「{0}」",
  "{0} близкий · для фото и видео|{0} близких · для фото и видео|{0} близких · для фото и видео": "{0} 位亲友 · 用于照片和视频",
  "Люди и питомцы для фото и видео": "用于照片和视频的人物和宠物",
  "Близких пока нет": "还没有亲友",
  "Добавьте людей и питомцев с фото, и они появятся в кадре рядом с вами": "添加人物和宠物的照片，他们就会出现在你身旁的画面中",
  "Открыть в «Истории»": "在「历史」中打开",
  "Вернуть в избранное": "重新加入收藏",
  "{0} работа с сердцем|{0} работы с сердцем|{0} работ с сердцем": "{0} 个已点爱心的作品",
  "Отмеченные сердцем работы": "已点爱心的作品",
  "Открыть «Историю»": "打开「历史」",
  "Не удалось загрузить избранное": "收藏加载失败",
  "Закройте лист и откройте его ещё раз": "关闭此页面后重新打开",
  "Отмечайте работы сердцем в «Истории», и они соберутся здесь": "在「历史」中为作品点亮爱心，它们就会汇集到这里",
  "Не удалось обновить. Попробуйте позже": "更新失败，请稍后再试",
  "Удалить голос «{0}»?": "删除声音「{0}」？",
  "Голос пропадёт из списка. Вернуть его не получится.": "该声音将从列表中消失，且无法恢复。",
  "Удалить вариант «{0}»?": "删除形象「{0}」？",
  "За «Вы» снова встанут ваши фото.": "「你」将重新使用你的照片。",
  "Готовые кружки и фото с ним останутся в «Истории». Вернуть вариант не получится.": "用它制作的圆形视频和照片会保留在「历史」中。形象删除后无法恢复。",
  "Не удалось удалить голос": "删除声音失败",
  "Не удалось удалить вариант. Попробуйте ещё раз": "删除形象失败，请重试",
  "«{0}»": "「{0}」",
  "подписка: до {0}": "有效期至 {0}",
  "варианты «Вы»: Новый вариант": "新形象",
  "в очереди": "排队中",
  "идёт": "进行中",
  "завершено": "已完成",
  "не удалось": "失败",
  "слово подтверждения: УДАЛИТЬ": "删除",
  "Выгрузка: {0}": "导出：{0}",
  "Удаление: {0}. STEOS ID и финансовые квитанции сохраняются.": "删除：{0}。STEOS ID 和财务收据会保留。",
  "Введите {0}": "输入 {0}",
  "Перенос ещё не подтверждён. Проверка продолжится, откройте лист позже": "转移尚未确认。我们会继续检查，请稍后再打开此页面",
  "Этот STEOS ID уже связан с другим Telegram": "此 STEOS ID 已绑定其他 Telegram 账号",
  "На обоих аккаунтах есть подписка. Для объединения напишите в поддержку": "两个账号都有订阅。如需合并，请联系支持",
  "Слишком много попыток. Попробуйте позже": "尝试次数过多，请稍后再试",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже": "暂时无法连接 STEOS ID，请稍后再试",
  "Не удалось создать аккаунт. Попробуйте позже": "创建账号失败，请稍后再试",
  "Не удалось отправить письмо": "邮件发送失败",
  "Фото не подошло. Выберите другое": "这张照片不合适，请换一张",
  "Загрузите фото заново": "请重新上传照片",
  "Данные изменились. Откройте заново": "数据已变化，请重新打开",
  "подряд": "连续",
  "Начните {0}": "开始{0}",
  "серию": "连续签到",
  "Завтра +{0} C": "明天 +{0} C",
  "Заходите каждый день: награда растёт, на седьмой день {0} C. Пропуск дня начинает серию заново.": "每天来签到：奖励逐日增加，第七天可得 {0} C。中断一天将重新开始计算。",
  "Забрать {0} C": "领取 {0} C",
  "Прогресс": "进度",
  "Заданий здесь пока нет": "这里还没有任务",
  "Время обновления недоступно": "刷新时间不可用",
  "Новые через {0}": "{0} 后刷新",
  "Выполнено {0} из {1}": "已完成 {0}/{1}",
  "друг|друга|друзей": "位好友",
  "{0} с вами": "{0} 已加入",
  "Прогресс друзей недоступен": "好友进度不可用",
  "Пригласить": "邀请",
  "Засчитываются друзья, которые пришли по вашей ссылке или промокоду и создали первую работу": "通过你的链接或优惠码加入并创建首个作品的好友才会计入",
  "Ещё {0} {1} до награды {2}": "再邀请 {0} {1} 即可获得 {2}",
  "Все ступени пройдены": "所有阶段已完成",
  "Получено {0} из {1}": "已领取 {0}/{1}",
  "Задания": "任务",
  "покупатель|покупателя|покупателей": "位买家",
  "Партнёрская программа": "合作伙伴计划",
  "Партнёрам": "合作伙伴",
  "До {0}% {1}": "最高 {0}% {1}",
  "с покупок друзей": "来自好友消费",
  "Заработано {0} с покупок {1} {2}": "已从 {1} {2} 的消费中赚取 {0}",
  "друга|друзей|друзей": "位好友",
  "Сами выбирайте: больше возможностей в STEOS или доход с рекомендаций.": "由你选择：在 STEOS 中获得更多功能，或从推荐中获得收入。",
  "Ещё {0} до уровня {1}": "距离{1}还差 {0}",
  "Максимальный уровень: вывод через STEOS ID": "最高等级：通过 STEOS ID 提现",
  "Статистика, материалы и вывод": "统计、素材和提现",
  "Исход прежнего запроса награды нужно проверить. Новые начисления пока заблокированы": "上一次奖励请求的结果需要核实，新奖励暂时冻结",
  "Загружаем награды": "正在加载奖励",
  "Награды не загрузились": "奖励加载失败",
  "Создайте 3 работы": "创建 3 个作品",
  "Сделайте кружок": "制作圆形视频",
  "Персонаж или вы сами": "角色或你自己",
  "Озвучьте текст": "为文本配音",
  "Голосом героя или клона": "用角色或克隆的声音",
  "Улучшите описание": "优化描述",
  "Бот допишет детали": "机器人会补充细节",
  "Отправьте работу": "分享作品",
  "Из «Истории» в любой чат": "从「历史」发送到任意聊天",
  "Неделя кружков": "圆形视频周",
  "Создайте 10 кружков за неделю": "一周内创建 10 个圆形视频",
  "Исследователь": "探索者",
  "Попробуйте 5 разных инструментов студии": "试用 5 种不同的工作室工具",
  "Первый кружок": "第一个圆形视频",
  "Видеокружок для Telegram": "Telegram 圆形视频",
  "Клон голоса": "声音克隆",
  "Всего 2 секунды речи": "只需 2 秒语音",
  "Первое фото": "第一张照片",
  "Портрет в любом стиле": "任意风格的肖像",
  "Первый рилс с вами": "第一个有你的 Reels",
  "Шаблон одной кнопкой": "一键模板",
  "Первый кавер": "第一首翻唱",
  "Песня другим голосом": "用另一个声音唱歌",
  "Кружки и видео с вами": "有你的圆形视频和视频",
  "С вашей ссылкой": "使用你的链接",
  "Бот в чате": "聊天中的机器人",
  "Добавьте бота в группу": "将机器人添加到群组",
  "Вход в STEOS ID": "登录 STEOS ID",
  "Один аккаунт с сайтом": "与网站共用一个账号",
  "Первый друг": "第一位好友",
  "3 друга": "3 位好友",
  "10 друзей": "10 位好友",
  "25 друзей": "25 位好友",
  "Первый покупатель": "第一位买家",
  "Первая оплата друга": "好友首次付款",
  "{0} мин": "{0} 分钟",
  "{0} ч": "{0} 小时",
  "Последний день": "最后一天",
  "Ещё {0} {1}": "还剩 {0} {1}",
  "Это задание выполняется вне мини-приложения": "此任务需在小程序外完成",
  "Задание пока недоступно": "任务暂不可用",
  "Прогресс временно недоступен": "进度暂时不可用",
  "Не удалось восстановить прежний запрос награды. Проверьте баланс и напишите в поддержку": "无法恢复上一次奖励请求。请检查余额并联系支持",
  "Награды временно недоступны. Попробуйте обновить данные": "奖励暂时不可用，请尝试刷新数据",
  "Награда подтверждена. Обновите данные: повторять начисление не нужно": "奖励已确认。请刷新数据，无需再次领取",
  "Задание ещё не выполнено. Обновите прогресс": "任务尚未完成，请刷新进度",
  "Награда уже получена. Обновите данные": "奖励已领取，请刷新数据",
  "Начисление не подтверждено. Проверьте прежний запрос: новая награда пока заблокирована": "发放未确认。请检查上一次请求：新奖励暂时冻结",
  "Сначала обновите данные наград": "请先刷新奖励数据",
  "Сначала проверьте прежний запрос награды": "请先检查上一次奖励请求",
  "Рассказчик": "旁白",
  "Встреча на тракте": "路上的相遇",
  "Геральт": "杰洛特",
  "Цири": "希里",
  "Дождь шёл третий день, и дорога к крепости почти исчезла под грязью.": "雨已经下了三天，通往要塞的路几乎被泥泞淹没。",
  "Ты опять ушла вперёд без меня. Я же просил ждать у моста.": "你又丢下我先走了。我不是让你在桥边等吗？",
  "Я ждала. Целый час. Потом решила, что ты заблудился.": "我等了，整整一个小时。后来我以为你迷路了。",
  "Ведьмаки не блуждают. Мы иногда выбираем длинную дорогу.": "猎魔人不会迷路。我们只是有时会选择绕远路。",
  "Тогда в следующий раз выбирай её быстрее. Я замёрзла.": "那下次选快一点，我都冻僵了。",
  "Он молча снял плащ и накинул ей на плечи. Впереди уже виднелись огни крепости.": "他默默脱下斗篷，披在她的肩上。前方已经能看到要塞的灯火。",
  "Пойдём. Весемир наверняка уже поставил суп на огонь.": "走吧。维瑟米尔肯定已经把汤放到火上了。",
  "Опять ты?": "又是你？",
  "Мне нужна помощь": "我需要帮助",
  "Вставьте сценарий или начните с нуля": "粘贴剧本或从零开始",
  "Напишите хотя бы одну реплику": "至少写一句台词",
  "Сократите реплику: до {0} знаков": "请缩短台词：最多 {0} 个字符",
  "Сократите проект: до {0} знаков": "请缩短项目：最多 {0} 个字符",
  "Озвучка проектов временно недоступна": "项目配音暂时不可用",
  "Выберите голос для каждой роли": "为每个角色选择声音",
  "Озвучить · {0} C": "配音 · {0} C",
  "Без названия": "未命名",
  "Роль": "角色",
  "вчера": "昨天",
  "Проекты": "项目",
  "роль|роли|ролей": "个角色",
  "реплика|реплики|реплик": "句台词",
  "Нет реплик": "没有台词",
  "{0} знаков": "{0} 个字符",
  "Строки «Имя: реплика» сами станут ролями и голосами": "「名字：台词」格式的行会自动变成角色和声音",
  "Начать с нуля": "从零开始",
  "Роли и реплики добавите сами": "自己添加角色和台词",
  "Открыть пример": "打开示例",
  "Проекты сохраняются сами: вернуться к ним можно в любой момент": "项目会自动保存，随时可以回来继续",
  "Роль с именем персонажа сама получит его голос: Геральт, Цири, Йеннифэр": "以角色名命名的角色会自动获得该角色的声音：杰洛特、希里、叶奈法",
  "Переименовать проект": "重命名项目",
  "Загрузить свежую": "加载最新版本",
  "{0}: голос {1}. Сменить голос": "{0}：声音 {1}。更换声音",
  "Действия с ролью": "角色操作",
  "Озвучиваем": "配音中",
  "Действия с репликой": "台词操作",
  "Реплика: {0}": "台词：{0}",
  "Реплик пока нет": "还没有台词",
  "Нажмите «Реплика» внизу или вставьте готовый сценарий": "点击下方「台词」或粘贴现成剧本",
  "Реплика": "台词",
  "за проект": "每个项目",
  "Цена — по числу знаков": "价格按字符数计算",
  "Добавить реплику": "添加台词",
  "проект|проекта|проектов": "个项目",
  "{0} {1} · сохраняются сами": "{0} {1} · 自动保存",
  "Пока ни одного": "还没有",
  "Новый проект": "新项目",
  "Вставить сценарий или начать с нуля": "粘贴剧本或从零开始",
  "Удаление проекта": "删除项目",
  "Новая роль": "新角色",
  "Это первая реплика": "这是第一句台词",
  "Это последняя реплика": "这是最后一句台词",
  "Удалить роль": "删除角色",
  "Вместе с её репликами": "连同其台词一起",
  "В проекте нужна хотя бы одна роль": "项目中至少需要一个角色",
  "Удалить роль «{0}»?": "删除角色「{0}」？",
  "Вместе с ней уйдут {0} {1}.": "{0} {1}也将一并删除。",
  "Удалить проект?": "删除项目？",
  "{0}. Роли и реплики удалятся, вернуть проект не получится.": "{0}。角色和台词将被删除，项目无法恢复。",
  "Выбор голоса откроется в приложении": "声音选择将在应用中打开",
  "Не удалось удалить проект: {0}": "删除项目失败：{0}",
  "Не получилось открыть аудио": "无法打开音频",
  "Не получилось включить звук": "无法播放声音",
  "Сначала напишите текст реплики": "请先输入台词内容",
  "Аудио реплики пока недоступно": "台词音频暂不可用",
  "Готовим роли": "正在准备角色",
  "Роли готовы": "角色已就绪",
  "Озвучиваем реплики": "正在为台词配音",
  "Реплики озвучены": "台词配音完成",
  "Собираем дорожку": "正在合成音轨",
  "Дорожка собрана": "音轨已合成",
  "дубль {0}": "第 {0} 版",
  "Время реплики пока недоступно": "台词时间暂不可用",
  "Общий файл · {0}": "合并文件 · {0}",
  "Аудио пока недоступно": "音频暂不可用",
  "Слушать дорожку": "播放音轨",
  "реплика {0} из {1}": "第 {0} 句，共 {1} 句",
  "Проект не озвучен": "项目未配音",
  "Можно уйти с экрана: озвучка продолжится, дорожка появится здесь и в «Истории».": "可以离开此页面：配音会继续进行，音轨将出现在这里和「历史」中。",
  "Можно уйти с экрана: бот напишет, когда дорожка будет готова.": "可以离开此页面：音轨完成后机器人会通知你。",
  "Отправьте общий файл в чат или скачайте его. Любую реплику можно переозвучить отдельно.": "将合并文件发送到聊天或下载。任意台词都可以单独重新配音。",
  "Бот уже прислал общий файл в чат, в отдельную тему. Любую реплику можно переозвучить отдельно.": "机器人已将合并文件发送到聊天中的单独话题。任意台词都可以单独重新配音。",
  "Сценарий не прошёл проверку": "剧本未通过审核",
  "проект не озвучен": "项目未配音",
  "Не получилось собрать дорожку": "音轨合成失败",
  "К сценарию": "返回剧本",
  "Звук дорожки не загрузился: скачайте файл": "音轨音频加载失败：请下载文件",
  "Каждая реплика с новой строки: имя, двоеточие, текст. Строка без имени достаётся предыдущей роли": "每句台词另起一行：名字、冒号、内容。没有名字的行归入上一个角色",
  "голос персонажа": "角色声音",
  "Заменить сценарий": "替换剧本",
  "Сейчас {0} {1}, они уйдут": "当前有 {0} {1}，将被删除",
  "реплику|реплики|реплик": "句台词",
  "Заменить на {0} {1}": "替换为 {0} {1}",
  "Добавить {0} {1}": "添加 {0} {1}",
  "Заменить реплики": "替换台词",
  "Добавить реплики": "添加台词",
  "Не нашли реплик: имя, двоеточие, текст": "未找到台词：名字、冒号、内容",
  "Вставьте сценарий в поле": "将剧本粘贴到输入框",
  "Роли и голоса появятся сами": "角色和声音会自动生成",
  "Геральт: Опять ты. Что на этот раз? Цири: Мне нужна твоя помощь.": "杰洛特：又是你。这次又怎么了？ 希里：我需要你的帮助。",
  "Сейчас нельзя": "暂不可用",
  "Вставьте текст в поле": "将文本粘贴到输入框",
  "Загружаем проекты": "正在加载项目",
  "Проекты не загрузились": "项目加载失败",
  "Не хватает Circle: пополните баланс": "Circle 不足：请充值",
  "Цена: {0} C. Нажмите ещё раз, чтобы озвучить": "价格：{0} C。再点一次开始配音",
  "Не удалось посчитать цену. Попробуйте ещё раз": "无法计算价格，请重试",
  "Сценарий не прошёл проверку. Измените текст и попробуйте ещё раз.": "剧本未通过审核。请修改文本后重试。",
  "Не получилось собрать дорожку. Если Circle списались, они вернутся на баланс.": "音轨合成失败。如已扣除 Circle，将退回余额。",
  "Запуск не подтверждён": "启动未确认",
  "Не получилось собрать дорожку.": "音轨合成失败。",
  "Повторная проверка не спишет Circle дважды.": "重新检查不会重复扣除 Circle。",
  "Отправили в чат": "已发送到聊天",
  "Отправка принята: бот пришлёт дорожку в чат": "请求已受理：机器人会把音轨发送到聊天",
  "Прослушивание реплики пока недоступно": "台词试听暂不可用",
  "Прослушать реплику: {0} C. Нажмите ещё раз": "试听台词：{0} C。再点一次",
  "Переозвучка реплики пока недоступна": "台词重新配音暂不可用",
  "Переозвучить реплику: {0} C. Нажмите ещё раз": "重新配音台词：{0} C。再点一次",
  "Сохранение проектов сейчас недоступно. Обновите данные.": "暂时无法保存项目，请刷新数据。",
  "Изменение проектов сейчас недоступно. Обновите данные.": "暂时无法修改项目，请刷新数据。",
  "Проект ещё сохраняется. Попробуйте через секунду.": "项目仍在保存，请稍后再试。",
  "Результат больше недоступен.": "结果已不可用。",
  "Не удалось проверить владельца проекта.": "无法验证项目所有者。",
  "Операция не найдена. Проверьте историю.": "未找到该操作，请查看历史。",
  "Проект ещё не сохранён.": "项目尚未保存。",
  "Озвучка проектов сейчас недоступна. Обновите данные.": "项目配音暂时不可用，请刷新数据。",
  "Прослушивание реплики сейчас недоступно. Обновите данные.": "台词试听暂时不可用，请刷新数据。",
  "Переозвучка реплики сейчас недоступна. Обновите данные.": "台词重新配音暂时不可用，请刷新数据。",
  "Дорожка ещё не готова.": "音轨尚未就绪。",
  "Аккаунт сменился. Обновите страницу.": "账号已切换，请刷新页面。",
  "Отправка пока не подтверждена. Нажмите ещё раз, чтобы проверить прежний запрос.": "发送尚未确认。再点一次以检查上一次请求。",
  "Результат проекта пока недоступен. Проверьте статус ещё раз.": "项目结果暂不可用，请再次检查状态。",
  "Не удалось открыть аудио проекта.": "无法打开项目音频。",
  "месяц|месяца|месяцев": "个月",
  "покупателя|покупателей|покупателей": "位买家",
  "рабочий день|рабочих дня|рабочих дней": "个工作日",
  "друг купит|друга купят|друзей купят": "位好友购买",
  "покупателем|покупателями|покупателями": "位买家",
  "Баннеры": "横幅",
  "Постер": "海报",
  "Голос героя": "角色的声音",
  "Персонаж говорит": "角色说话",
  "Было и стало": "前后对比",
  "Подарок другу": "送给好友的礼物",
  "Кружок, который говорит": "会说话的圆形视频",
  "Персонаж читает ваш текст": "角色朗读你的文字",
  "Рилс с вами одной кнопкой": "一键生成有你的 Reels",
  "Сюжет, монтаж и музыка в шаблоне": "模板包含剧情、剪辑和音乐",
  "Герой говорит": "主角说话",
  "Герой говорит вашим текстом": "主角说出你的文字",
  "Голос и губы в такт": "声音与口型同步",
  "Старое фото как новое": "老照片焕然一新",
  "Цвет и резкость за минуту": "一分钟修复色彩和清晰度",
  "Кавер любым голосом": "任意声音翻唱",
  "Рок, джаз или lo-fi": "摇滚、爵士或 lo-fi",
  "Фотосессия в любом образе": "任意造型的写真",
  "По паре своих фото": "只需几张自己的照片",
  "Друзьям": "好友",
  "Личное сообщение": "私信",
  "Подписчикам": "订阅者",
  "Пост в канал": "频道帖子",
  "Семье": "家人",
  "Сообщение родным": "发给家人的消息",
  "Геймерам": "游戏玩家",
  "Чат по интересам": "兴趣群聊",
  "Для работы": "工作用",
  "Коллегам и в рабочий чат": "发给同事和工作群",
  "Авторам": "创作者",
  "Блогерам и создателям роликов": "博主和视频创作者",
  "Подарок по моему промокоду": "使用我的优惠码领取礼物",
  "Кружки, фото и голос с ИИ прямо в Telegram": "在 Telegram 中直接用 AI 制作圆形视频、照片和声音",
  "Кружки с персонажами": "角色圆形视频",
  "Пишете текст, персонаж его говорит": "你写文字，角色来说",
  "Озвучка любым голосом": "任意声音配音",
  "Из библиотеки или своим клоном": "来自声音库或你自己的克隆",
  "Фотосессия без студии": "无需摄影棚的写真",
  "Пара своих фото, любой образ": "几张照片，任意造型",
  "{0} с регистрации по вашей ссылке или с первой покупки по промокоду. Всё это время процент идёт со всех оплат друга. Промокод работает только до первой покупки друга, а если друг пришёл по ссылке, промокод привязку уже не меняет.": "从好友通过你的链接注册或使用你的优惠码首次购买起 {0}。在此期间，好友的所有付款都会给你分成。优惠码仅在好友首次购买前有效；如果好友是通过链接来的，优惠码不会改变绑定关系。",
  "Что получает друг?": "好友能得到什么？",
  "+{0} C сразу: они не выводятся и сгорают через {1}.": "立即获得 +{0} C：不可提现，{1}后过期。",
  "Скидка {0}% на первый пакет Circle действует {1} после оформления подписки, потому что пакеты Circle продаются только с подпиской. Подарок один на аккаунт: по ссылке или по промокоду.": "首个 Circle 套装 {0}% 折扣，在开通订阅后 {1}内有效，因为 Circle 套装仅随订阅出售。每个账号仅限一份礼物：通过链接或优惠码。",
  "Что считается оплатой?": "什么算作付款？",
  "Подписка и пакеты Circle, оплаченные звёздами или картой. Процент считается от суммы, которую друг заплатил, со скидкой. Бонусные монеты, награды за задания и возвраты не учитываются.": "用 Stars 或银行卡支付的订阅和 Circle 套装。分成按好友折后实际支付的金额计算。奖励币、任务奖励和退款不计入。",
  "Какие бывают промокоды?": "优惠码有哪些？",
  "Ваш промокод партнёра даёт другу подарок и привязывает его к вам, работает только до его первой покупки. Промокоды STEOS публикует команда в канале и сообществе STEOS: они дают Circle со своим сроком и работают у всех, один раз на аккаунт.": "你的合作伙伴优惠码会给好友一份礼物并将其绑定到你，仅在其首次购买前有效。STEOS 优惠码由团队在 STEOS 频道和社区发布：赠送有各自有效期的 Circle，所有人可用，每个账号限用一次。",
  "Когда приходят Circle?": "Circle 什么时候到账？",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} их можно вывести.": "好友付款后立即到账余额。{0}等级可以提现。",
  "Сразу после оплаты друга, прямо на баланс. На уровнях {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "好友付款后立即到账余额。{0}等级可在 STEOS 内使用，{1}等级可以提现。",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "好友付款后立即到账余额。{0}等级可在 STEOS 内使用，{1}等级可以提现。",
  "Считаются ли друзья с истёкшей привязкой?": "绑定已过期的好友还算数吗？",
  "Да. Процент с их оплат больше не идёт, но в счёте уровня они остаются: уровень считается по всем покупателям за всё время.": "算。他们的付款不再给你分成，但仍计入等级：等级按你历来所有买家计算。",
  "Кто может выводить?": "谁可以提现？",
  "Партнёры уровня {0} (от {1}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {2}.": "{0}等级（{1}起）的合作伙伴，具有个体工商户、自雇人士或国外同类身份，并通过 STEOS ID 登录后。只能以现金提现到账户：在这里或在 {2}。",
  "Амбассадоры (от {0}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {1}.": "大使（{0}起），具有个体工商户、自雇人士或国外同类身份，并通过 STEOS ID 登录后。只能以现金提现到账户：在这里或在 {1}。",
  "Можно ли вывести монеты, заработанные до входа?": "登录前赚取的币可以提现吗？",
  "Да. Монеты Circle, заработанные на уровне {0} до входа через STEOS ID, ждут на балансе и станут доступны для вывода после входа.": "可以。在通过 STEOS ID 登录前于{0}等级赚取的 Circle 会保留在余额中，登录后即可提现。",
  "Какие монеты тратятся первыми?": "哪些币会先被消耗？",
  "Можно пригласить самого себя?": "可以邀请自己吗？",
  "Нет. Покупки с вашего аккаунта и с повторных аккаунтов не учитываются.": "不可以。你自己的账号和重复账号的消费不计入。",
  "Международный": "国际",
  "Self-employed, sole trader или компания вне РФ": "俄罗斯境外的自雇人士、个体工商户或公司",
  "Самозанятый в РФ": "俄罗斯自雇人士",
  "Налог на профессиональный доход": "职业收入税",
  "ИП в РФ": "俄罗斯个体工商户",
  "Индивидуальный предприниматель": "个体工商户",
  "Имя или компания": "姓名或公司",
  "Как в документах": "与证件一致",
  "TIN или номер в вашей стране": "TIN 或你所在国家的税号",
  "ФИО": "全名",
  "Как в паспорте": "与护照一致",
  "ИНН": "INN",
  "12 цифр": "12 位数字",
  "Название ИП": "个体工商户名称",
  "Как в выписке": "与登记摘录一致",
  "ИНН или ОГРНИП": "INN 或 OGRNIP",
  "От 10 до 15 цифр": "10 到 15 位数字",
  "НДС": "增值税",
  "Плательщик НДС": "增值税纳税人",
  "Адрес": "地址",
  "КПП": "KPP",
  "ОГРН": "OGRN",
  "Основной офис STEOS": "STEOS 总部",
  "Платёжный агент STEOS в России": "STEOS 俄罗斯支付代理",
  "Тут откроется выбор чата Telegram с этим текстом, ссылкой и промокодом": "这里将打开 Telegram 聊天选择，附带此文本、链接和优惠码",
  "Тут откроется выбор чата Telegram: баннер уйдёт с подписью и кнопкой «Открыть STEOS»": "这里将打开 Telegram 聊天选择：横幅会附带说明和「打开 STEOS」按钮发送",
  "Ещё <b>{0} {1}</b> до уровня {2}": "距离{2}还差 <b>{0} {1}</b>",
  "Максимальный уровень": "最高等级",
  "До следующего уровня": "距离下一等级",
  "Получайте до&nbsp;{0}% <span>с&nbsp;покупок друзей</span>": "最高可得&nbsp;{0}% <span>好友消费分成</span>",
  "Период": "时间段",
  "Кого показать": "显示对象",
  "Перешли": "点击",
  "Зарегистрировались": "注册",
  "Купили": "购买",
  "Пока нет данных": "暂无数据",
  "{0} к прошлому периоду": "较上一时段 {0}",
  "за {0} {1}": "{0} {1}内",
  "Пока не считаем": "暂未统计",
  "нет начислений": "无收益",
  "Пик <b>{0} C</b>": "峰值 <b>{0} C</b>",
  "Начисления по месяцам": "按月收益",
  "Начисления по дням": "按日收益",
  "Здесь появятся начисления": "收益会显示在这里",
  "Подписка Про": "Pro 订阅",
  "Купила Circle": "购买了 Circle",
  "Купил Circle": "购买了 Circle",
  "Покупатель": "买家",
  "по промокоду": "通过优惠码",
  "привязка истекла": "绑定已过期",
  "Это весь список · {0}": "已显示全部 · {0}",
  "Друг привязан к вам {0}: с регистрации по ссылке или с первой покупки по промокоду. Промокод работает только до первой покупки друга.": "好友与你绑定 {0}：从通过链接注册或使用优惠码首次购买起算。优惠码仅在好友首次购买前有效。",
  "Покупатели с истёкшей привязкой остаются в счёте уровня.": "绑定已过期的买家仍计入等级。",
  "Пока никого": "还没有人",
  "Поделитесь ссылкой или промокодом, первые друзья появятся здесь": "分享你的链接或优惠码，第一批好友会出现在这里",
  "Картинка": "图片",
  "Ссылка и промокод уже на картинке. Нажмите на шаблон, чтобы поправить подпись и опубликовать.": "链接和优惠码已在图片上。点击模板即可修改说明并发布。",
  "{0}, открыть и опубликовать": "{0}，打开并发布",
  "Для Reels, Shorts, TikTok и VK Клипов. Промокод и ссылка уже в кадре, бот пришлёт ролик в чат.": "适用于 Reels、Shorts、TikTok 和 VK Clips。优惠码和链接已在画面中，机器人会把视频发到聊天。",
  "{0}, открыть": "{0}，打开",
  "Ссылка и промокод уже в тексте. Скопируйте его или отправьте в чат.": "链接和优惠码已在文本中。复制它或发送到聊天。",
  "Картинка уйдёт в чат с подписью и кнопкой «Открыть STEOS». Подойдёт для групп, каналов и личных сообщений.": "图片会附带说明和「打开 STEOS」按钮发送到聊天。适用于群组、频道和私信。",
  "Баннер «{0}» с вашим промокодом": "带你优惠码的横幅「{0}」",
  "QR-постер: код ведёт на вашу ссылку, промокод {0}": "二维码海报：扫码打开你的链接，优惠码 {0}",
  "Кружки, фото и голос с ИИ": "AI 圆形视频、照片和声音",
  "+{0}&nbsp;C на старт по промокоду": "使用优惠码起步 +{0}&nbsp;C",
  "Начните по ссылке или промокоду": "通过链接或优惠码开始",
  "Наведите камеру телефона": "用手机摄像头扫描",
  "A4 для печати: стойки, витрины, визитки. Код ведёт на вашу ссылку, а промокод под ним можно ввести и без камеры.": "A4 打印用：展架、橱窗、名片。二维码指向你的链接，下方的优惠码无需摄像头也能输入。",
  "Цвет постера": "海报颜色",
  "Прислать PDF в чат": "将 PDF 发送到聊天",
  "Вывести": "提现",
  "Заявка на {0} C не подтверждена": "{0} C 的提现申请未确认",
  "Вывод сейчас недоступен": "暂时无法提现",
  "Вывод недоступен": "无法提现",
  "Деньгами на ваш счёт за {0}": "{0}内以现金打入你的账户",
  "Вывод от {0} C": "{0} C 起可提现",
  "Вывод заработает после входа через STEOS ID": "通过 STEOS ID 登录后即可提现",
  "Войдите через STEOS ID": "通过 STEOS ID 登录",
  "Вывод доступен на уровне {0}, от {1}": "{0}等级可提现，{1}起",
  "Нужен уровень {0}": "需要{0}等级",
  "Вывод откроется на уровне {0}, от {1}. Пока Circle работают внутри STEOS": "{0}等级（{1}起）开放提现。在此之前，Circle 可在 STEOS 内使用",
  "Не подключён": "未连接",
  "Вход свяжет аккаунт бота с общим аккаунтом STEOS: баланс станет общим, а вывод заработает здесь и на сайте STEOS ID.": "登录后，机器人账号将与 STEOS 通用账号关联：余额将合并，并可在这里和 STEOS ID 网站提现。",
  "Выплачено": "已支付",
  "В обработке": "处理中",
  "Отклонено": "已拒绝",
  "Не удалось загрузить историю выводов": "提现记录加载失败",
  "Выводов пока не было": "还没有提现记录",
  "за всё время": "全部时间",
  "Можно вывести": "可提现",
  "Тестовая программа: настоящих выплат нет": "测试计划：不会真实付款",
  "Баланс и выводы есть и на {0}.": "余额和提现也可在 {0} 查看。",
  "Вопрос о выводе?": "有关于提现的问题？",
  "Напишите в поддержку": "联系支持",
  "Поделитесь ссылкой или промокодом": "分享你的链接或优惠码",
  "Друг привязывается к вам на {0}": "好友与你绑定 {0}",
  "Друг получает подарок": "好友获得礼物",
  "+{0} C сразу и −{1}% на первый пакет Circle после подписки": "立即 +{0} C，订阅后首个 Circle 套装 −{1}%",
  "Друг платит в STEOS": "好友在 STEOS 中付款",
  "Подписка и пакеты Circle звёздами или картой": "用 Stars 或银行卡购买订阅和 Circle 套装",
  "Вам приходит процент": "你获得分成",
  "{0}% с каждой оплаты, сразу на баланс": "每笔付款的 {0}%，直接到账余额",
  "Шаг {0}": "第 {0} 步",
  "От {0}": "{0}起",
  "С первого дня": "从第一天起",
  "Если {0} {1} {2}": "如果 {0} {1} {2}",
  "{0} C за {1}": "{1}内 {0} C",
  "Хватит на {0} в месяц": "每月足够制作 {0}",
  "Кружок стоит {0} C": "一个圆形视频 {0} C",
  "Считаем по подписке {0}: {1} в месяц, это {2}&nbsp;C. Процент идёт с каждой оплаты друга {3} привязки.": "按 {0} 订阅计算：每月 {1}，即 {2}&nbsp;C。在 {3}绑定期内，好友的每笔付款都会给你分成。",
  "Уровень считается вместе с вашими {0}.": "你当前的买家也计入等级：{0}。",
  "Калькулятор дохода": "收益计算器",
  "Тариф друзей": "好友的套餐",
  "Сколько друзей купят подписку": "多少好友会购买订阅",
  "Вы получите": "你将获得",
  "C в месяц": "C/月",
  "Проценты, сроки и ограничения": "分成比例、期限和限制",
  "Circle можно вывести": "Circle 可提现",
  "Circle работают внутри STEOS": "Circle 可在 STEOS 内使用",
  "Привязка на {0}": "绑定 {0}",
  "Процент идёт со всех оплат друга: с регистрации по ссылке или с первой покупки по промокоду": "好友的所有付款都会给你分成：从通过链接注册或使用优惠码首次购买起算",
  "Ссылка главнее промокода": "链接优先于优惠码",
  "Если друг пришёл по ссылке, промокод привязку уже не меняет": "如果好友是通过链接来的，优惠码不会再改变绑定关系",
  "Промокод только до первой покупки": "优惠码仅在首次购买前有效",
  "После первой оплаты друга ваш промокод партнёра у него не работает": "好友首次付款后，你的合作伙伴优惠码对其失效",
  "{0} C сразу, сгорят через {1}. {2} на первый пакет Circle {3} после подписки": "立即获得 {0} C，{1}后过期。订阅后 {3}内首个 Circle 套装 {2}",
  "Только уровень {0}": "仅限{0}等级",
  "От {0} {1}, после входа через STEOS ID. Для ИП, самозанятых и их аналогов в других странах": "{0} {1}起，需通过 STEOS ID 登录。适用于个体工商户、自雇人士及其他国家的同类身份",
  "Счёт на компанию STEOS": "向 STEOS 公司开具发票",
  "Плательщик появится, когда вывод откроется": "开放提现后会显示付款方",
  "В РФ: {0}, в рублях. Международный статус: {1}, в евро": "俄罗斯：{0}，以卢布结算。国际身份：{1}，以欧元结算",
  "Выплата за {0}": "{0}内付款",
  "После проверки счёта, от {0} C": "发票审核后，{0} C 起",
  "Коротко о главном": "要点速览",
  "Здесь краткое изложение. Полный текст условий на {0}": "这里是简要说明。完整条款见 {0}",
  "Понятно": "知道了",
  "У вас {0}.": "你有 {0}。",
  "Покупателей пока нет.": "还没有买家。",
  "Уровень считается по всем покупателям за всё время, с истёкшей привязкой тоже.": "等级按你历来所有买家计算，包括绑定已过期的买家。",
  "Введите сумму": "输入金额",
  "Можно вывести не больше {0} C": "最多可提现 {0} C",
  "Заполните реквизиты": "填写收款信息",
  "Загрузите счёт на оплату": "上传付款发票",
  "Счёт ещё проверяется": "发票仍在审核中",
  "Выплата в {0} · 1 C = {1} {0}": "以 {0} 支付 · 1 C = {1} {0}",
  "Вывести {0} C": "提现 {0} C",
  "Счёт выставьте в {0}. Проверим его, и деньги придут за {1}.": "请以 {0} 开具发票。审核通过后，款项将在 {1}内到账。",
  "Счёт выставьте в евро. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "请以欧元开具发票。审核通过后，款项将在 {0}内到账。收款信息将保存在 STEOS ID 中。",
  "Счёт выставьте в рублях. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "请以卢布开具发票。审核通过后，款项将在 {0}内到账。收款信息将保存在 STEOS ID 中。",
  "Скопировать {0}": "复制{0}",
  "юридический адрес": "注册地址",
  "Скопировать название компании": "复制公司名称",
  "Скопировать все реквизиты": "复制全部信息",
  "Реквизиты для счёта": "开票信息",
  "Проверяем счёт…": "正在审核发票…",
  "PDF, JPG или PNG, до 10 МБ": "PDF、JPG 或 PNG，最大 10 MB",
  "Можно вывести {0} C": "可提现 {0} C",
  "Сумма, C": "金额，C",
  "Сумма вывода, C": "提现金额，C",
  "Всё": "全部",
  "Придёт на счёт": "到账金额",
  "Реквизиты": "收款信息",
  "Счёт на оплату": "付款发票",
  "Заявка на вывод принята": "提现申请已受理",
  "{0} придут за {1} после проверки счёта": "发票审核后，{0} 将在 {1}内到账",
  "Ролик принят в обработку": "视频正在处理",
  "Ролик в чате с ботом": "视频已发送到机器人聊天",
  "Бот пришлёт его после подготовки. Доставка пока не подтверждена.": "准备好后机器人会发送给你。送达尚未确认。",
  "Сохраните его и выложите в Reels, Shorts, TikTok или VK Клипы": "保存后发布到 Reels、Shorts、TikTok 或 VK Clips",
  "Промокод и ссылка уже в кадре. Бот пришлёт ролик в чат, оттуда его можно сохранить и выложить.": "优惠码和链接已在画面中。机器人会把视频发到聊天，你可以在那里保存并发布。",
  "Прислать в чат": "发送到聊天",
  "Текст выделен: скопируйте его вручную": "文本已选中：请手动复制",
  "Баннер готов: отправить его в чат можно из Telegram": "横幅已就绪：可以从 Telegram 发送到聊天",
  "PDF принят в очередь": "PDF 已加入队列",
  "PDF в чате": "PDF 已发送到聊天",
  "Не удалось загрузить период. Попробуйте ещё раз": "时间段加载失败，请重试",
  "Без начислений": "无收益",
  "Значение выделено: скопируйте его вручную": "内容已选中：请手动复制",
  "Реквизиты выделены: скопируйте их вручную": "收款信息已选中：请手动复制",
  "Нужен файл PDF, JPG или PNG": "需要 PDF、JPG 或 PNG 文件",
  "Файл {0}, можно до 10 МБ": "文件大小 {0}，最大 10 MB",
  "Партнёрство не загрузилось": "合作伙伴计划加载失败",
  "Загружаем партнёрскую программу": "正在加载合作伙伴计划",
  "за неделю": "近一周",
  "за месяц": "近一月",
  "Для вывода войдите через STEOS ID": "请通过 STEOS ID 登录后提现",
  "Вывод недоступен на текущем уровне": "当前等级无法提现",
  "Сумма больше доступной": "金额超过可提现额度",
  "Сумма меньше минимальной": "金额低于最低限额",
  "Проверьте реквизиты и счёт": "请检查收款信息和发票",
  "Счёт ещё не проверен. Загрузите его заново": "发票尚未审核，请重新上传",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены": "未收到回复。请检查同一申请：其数据和密钥已保存",
  "Не удалось загрузить список друзей": "好友列表加载失败",
  "Не удалось восстановить прежнюю заявку. Напишите в поддержку перед новой": "无法恢复上一次申请。提交新申请前请联系支持",
  "Партнёрская программа временно недоступна": "合作伙伴计划暂时不可用",
  "Не удалось загрузить следующую страницу": "下一页加载失败",
  "Не удалось подготовить баннер. Попробуйте ещё раз": "横幅准备失败，请重试",
  "Бот не может подготовить материал: откройте чат с ботом и попробуйте ещё раз": "机器人无法准备素材：请打开与机器人的聊天后重试",
  "Материал сейчас недоступен": "素材暂不可用",
  "Отправка не подтверждена. Нажмите ещё раз: повтор проверит прежний запрос": "发送未确认。再点一次：重试会检查上一次请求",
  "Прежняя отправка не восстановлена. Напишите в поддержку": "上一次发送未能恢复，请联系支持",
  "Прежняя отправка подтверждена. Нажмите ещё раз": "上一次发送已确认，请再点一次",
  "Отправка не подтверждена": "发送未确认",
  "Счёт не прошёл проверку. Выберите PDF, JPG или PNG до 10 МБ": "发票未通过检查。请选择 10 MB 以内的 PDF、JPG 或 PNG",
  "Не удалось безопасно сохранить заявку. Отправка не выполнена": "无法安全保存申请，未发送",
  "Тут откроется инструмент «{0}»": "这里将打开「{0}」工具",
  "Геральт, Цири и ещё 2 400 голосов скажут всё, что напишете": "杰洛特、希里等 2400 多个声音，说出你写的任何内容",
  "Снимите себя, и персонаж повторит ваши движения": "拍下自己，角色就会模仿你的动作",
  "Выберите образ, и через минуту готовы 3 кадра из одного селфи": "选择造型，一分钟内用一张自拍生成 3 张照片",
  "Сделать": "制作",
  "2 400 голосов, 19 языков": "2400 个声音，19 种语言",
  "Текст в речь голосом персонажа или своим клоном": "用角色的声音或你自己的克隆将文字转为语音",
  "Ваш голос за две минуты": "两分钟拥有你的声音",
  "Запишите образец, и клон появится во всех инструментах с озвучкой": "录制样本后，克隆声音会出现在所有配音工具中",
  "Движения": "动作",
  "бесплатно": "免费",
  "/сек": "/秒",
  "готов": "已就绪",
  "Клон · готов": "克隆 · 已就绪",
  "студия: Мой голос": "我的声音",
  "Сейчас в тренде": "当前热门",
  "Популярное за неделю": "本周热门",
  "Геральт скажет ваш текст": "杰洛特说出你的文字",
  "Вы в знаменитых сценах": "你出现在经典场景中",
  "3 кадра в любом образе": "任意造型 3 张照片",
  "Готовый сюжет с вами": "有你的现成剧情",
  "Вы повторите любой танец": "你也能跳任何舞",
  "Ваш снимок в движении": "让你的照片动起来",
  "Фото скажет ваш текст": "照片说出你的文字",
  "Легенды замка": "城堡传说",
  "Город инков": "印加之城",
  "Неоновый дождь": "霓虹雨",
  "Утренний бег": "晨跑",
  "Танец теней": "影之舞",
  "Дорога домой": "回家的路",
  "Ночной рейв": "夜间锐舞",
  "Снежный пик": "雪峰",
  "Тайны Хейвена": "避风港之谜",
  "Магия рун": "符文魔法",
  "Странные дела": "怪奇事件",
  "Ночной рынок": "夜市",
  "Ретро-кадр": "复古镜头",
  "Утро в горах": "山中清晨",
  "Золотой час": "黄金时刻",
  "Студийный свет": "影棚灯光",
  "Полароид": "宝丽来",
  "Киберпанк": "赛博朋克",
  "Старый маяк": "古老灯塔",
  "Шторм в заливе": "海湾风暴",
  "Кинотрейлер": "电影预告片",
  "Город в движении": "流动的城市",
  "Интервью": "采访",
  "Пустыня на закате": "日落沙漠",
  "Подводный мир": "海底世界",
  "Кружок «Привет»": "「你好」圆形视频",
  "Спокойной ночи": "晚安",
  "Поздравляю": "恭喜",
  "Скучаю": "想你",
  "Новости дня": "今日新闻",
  "Нос корабля": "船头",
  "Двое на носу корабля, руки раскинуты навстречу ветру": "两人站在船头，张开双臂迎风",
  "Героиня": "女主角",
  "роль: Герой": "主角",
  "Уклонение от пуль": "躲子弹",
  "Время замирает, вы прогибаетесь назад, и пули проходят мимо": "时间凝固，你向后仰身，子弹从身边飞过",
  "Танец в закусочной": "餐厅之舞",
  "Пара танцует твист у стойки придорожной закусочной": "一对情侣在路边餐厅柜台前跳扭摆舞",
  "Танцор": "舞者",
  "Танцовщица": "女舞者",
  "Свидание под дождём": "雨中约会",
  "Ливень, старый дом и встреча, которую оба ждали годами": "倾盆大雨、老房子，还有两人等待多年的重逢",
  "Он": "他",
  "Она": "她",
  "Речь перед битвой": "战前演说",
  "Вождь проезжает вдоль строя, и войско отвечает рёвом": "首领沿着队列策马而过，大军以怒吼回应",
  "Вождь": "首领",
  "Знаменосец": "旗手",
  "Погоня по крышам": "屋顶追逐",
  "Прыжки между крышами ночного города, погоня не отстаёт": "在夜晚城市的屋顶间跳跃，追兵紧随其后",
  "Беглец": "逃亡者",
  "Преследователь": "追捕者",
  "Ограбление казино": "赌场劫案",
  "Команда в смокингах проходит через зал, сейф уже открыт": "身穿燕尾服的团队穿过大厅，保险箱已经打开",
  "Главарь": "头目",
  "Напарник": "搭档",
  "Напарница": "女搭档",
  "Прощание на вокзале": "车站告别",
  "Поезд трогается, двое держатся за руки до последнего": "火车启动，两人紧握双手直到最后一刻",
  "Пассажир": "乘客",
  "Провожающий": "送行者",
  "Дуэль на закате": "日落决斗",
  "Пустая улица, два стрелка и последние секунды тишины": "空荡的街道、两名枪手和最后几秒的寂静",
  "Шериф": "警长",
  "Злодей": "反派",
  "Танец на лестнице": "阶梯之舞",
  "Злодей в ярком костюме танцует на длинной уличной лестнице": "身穿鲜艳西装的反派在长长的街头阶梯上起舞",
  "Выход в открытый космос": "太空行走",
  "Астронавт парит над Землёй, трос уходит к станции": "宇航员漂浮在地球上方，系绳连向空间站",
  "Астронавт": "宇航员",
  "Рассвет над саванной": "草原黎明",
  "Питомца поднимают над скалой, и вся саванна смотрит на него": "宠物被高高举过岩石，整个草原都注视着它",
  "Главная роль": "主角",
  "Хранитель": "守护者",
  "Полёт под луной": "月下飞行",
  "Велосипед отрывается от земли и летит на фоне луны": "自行车离地而起，从月亮前飞过",
  "Финальная поддержка": "最后的托举",
  "Разбег, прыжок и поддержка над головой под аплодисменты зала": "助跑、跳跃，在全场掌声中被高高托起",
  "Партнёрша": "女舞伴",
  "Партнёр": "舞伴",
  "Песня на холме": "山丘之歌",
  "Альпийский луг и ветер: вы кружитесь с песней, а дети бегут к вам навстречу": "阿尔卑斯草地和微风：你边唱边旋转，孩子们向你奔来",
  "Бледная кожа": "苍白肌肤",
  "Хвойный лес": "针叶林",
  "Первый взгляд": "初次对视",
  "Туман над рекой": "河上薄雾",
  "Полночь в школе": "午夜校园",
  "Двое на поляне": "林间空地上的两人",
  "Луч пробивается сквозь хвою, и двое замирают посреди лесной поляны": "一束阳光穿过松针，两人在林间空地中央定住",
  "Глаза цвета янтаря": "琥珀色的眼睛",
  "Бал выпускников": "毕业舞会",
  "Клятва": "誓言",
  "Игра в грозу": "雷雨中的比赛",
  "Гром над лесной поляной, и каждый удар битой звучит как раскат": "林间空地上雷声隆隆，每一次挥棒都像一声惊雷",
  "Отбивающий": "击球手",
  "Подающая": "女投手",
  "Ловец": "接球手",
  "К вершине сосны": "登上松树顶",
  "Он уносит её на спине к вершине сосны, внизу туман и весь лес": "他背着她攀上松树顶端，下方是薄雾和整片森林",
  "Примерка брони": "穿上战甲",
  "Броня защёлкивается на вас деталь за деталью, и шлем закрывает лицо": "战甲一块块扣到你身上，头盔合上遮住面庞",
  "Полёт над городом": "飞越城市",
  "Разгон над ночным городом, вираж между башнями и посадка на крышу": "在夜晚城市上空加速，在高楼间急转，降落在屋顶",
  "Пилот брони": "战甲驾驶员",
  "Ночь в мастерской": "工坊之夜",
  "Искры сварки, чертежи прямо в воздухе и первый удачный запуск": "焊接火花、悬浮在空中的图纸，以及第一次成功启动",
  "Изобретатель": "发明家",
  "Последний заряд": "最后的能量",
  "Заряд брони на исходе, команда встаёт спина к спине, и всё решает последний залп": "战甲能量即将耗尽，团队背靠背站立，最后一击决定一切",
  "Герой в броне": "战甲英雄",
  "Качели на паутине": "蛛丝摆荡",
  "Прыжок с карниза, паутина натягивается, и улица проносится под ногами": "从屋檐一跃而下，蛛丝绷紧，街道在脚下飞驰而过",
  "Герой в маске": "蒙面英雄",
  "Поцелуй под дождём": "雨中之吻",
  "Ночной переулок и ливень: он висит вниз головой, она приподнимает край маски": "深夜小巷和倾盆大雨：他倒挂着，她掀起面具一角",
  "Крыша на закате": "日落屋顶",
  "Двое сидят на краю крыши, внизу шумит город, солнце уходит за башни": "两人坐在屋顶边缘，下方城市喧嚣，太阳落到高楼后面",
  "Бой в поезде": "火车上的战斗",
  "Схватка на крыше несущегося поезда, а потом герой останавливает вагон руками": "在飞驰的火车车顶上搏斗，随后英雄用双手拦停车厢",
  "Пассажирка": "女乘客",
  "Для маркетплейса": "电商平台",
  "Праздники": "节日",
  "Поздравления, кружки и посты к праздникам: 1 апреля, Пасха, 8 марта": "节日祝福、圆形视频和帖子：愚人节、复活节、三八妇女节",
  "1 апреля": "愚人节",
  "Пасха": "复活节",
  "8 марта": "三八妇女节",
  "Мода": "时尚",
  "Аватарки": "头像",
  "Фильмы": "电影",
  "Игры": "游戏",
  "Путешествия": "旅行",
  "Сумерки": "暮光之城",
  "Железный человек": "钢铁侠",
  "Человек-паук": "蜘蛛侠",
  "Романтика": "浪漫",
  "Погони": "追逐",
  "Всей семьёй": "全家一起",
  "Особая подборка": "特别合集",
  "Особая подборка {0}, {1}": "特别合集 {0}，{1}",
  "Подборка {0}, {1}": "合集 {0}，{1}",
  "{0} в подборке": "合集中有 {0}",
  "шаблон|шаблона|шаблонов": "个模板",
  "шаблона|шаблонов|шаблонов": "个模板",
  "сцена|сцены|сцен": "个场景",
  "инструмент|инструмента|инструментов": "个工具",
  "инструмента|инструментов|инструментов": "个工具",
  "стиль|стиля|стилей": "种风格",
  "кадра|кадров|кадров": "张照片",
  "ребёнок|ребёнка|детей": "个孩子",
  "питомец|питомца|питомцев": "只宠物",
  "кружки": "圆形视频",
  "голос": "声音",
  "текст": "文本",
  "для бизнеса": "商用",
  "Кружок из видео": "用视频做圆形视频",
  "Фото в новом стиле": "照片换风格",
  "Фото по описанию": "按描述生成照片",
  "Семейный портрет": "全家福",
  "Видео в новом стиле": "视频换风格",
  "Видео по описанию": "按描述生成视频",
  "Видео другим голосом": "换声音的视频",
  "Объёмное фото": "3D 照片",
  "Анимация из серии": "连拍动画",
  "Видео из поездки": "旅行视频",
  "Фильм из фотографий": "照片电影",
  "Изменить видео": "修改视频",
  "текст или запись": "文本或录音",
  "видео до 1 минуты": "1 分钟以内的视频",
  "1 фото и текст": "1 张照片和文本",
  "запись или аудиофайл": "录音或音频文件",
  "5 фото лица": "5 张脸部照片",
  "1 селфи": "1 张自拍",
  "описание словами": "文字描述",
  "фото или описание": "照片或描述",
  "старое фото": "老照片",
  "чёрно-белое фото": "黑白照片",
  "фото близких": "亲友照片",
  "от 2 до 9 фото": "2 到 9 张照片",
  "тема поста": "帖子主题",
  "1 фото или видео": "1 张照片或 1 个视频",
  "ваше фото": "你的照片",
  "фото тех, кто сыграет": "出演者的照片",
  "1 видео": "1 个视频",
  "видео и новый текст": "视频和新文本",
  "видео с речью": "带说话的视频",
  "текст поздравления": "祝福语",
  "от 3 фото": "3 张以上照片",
  "фото из поездки": "旅行照片",
  "семейные фото": "家庭照片",
  "сценарий": "剧本",
  "запись голоса": "声音录音",
  "песня": "歌曲",
  "файл или ссылка": "文件或链接",
  "название товара": "商品名称",
  "от 1 до 5 фото товара": "1 到 5 张商品照片",
  "фото товара": "商品照片",
  "1 видео с вами": "1 个有你的视频",
  "ваше видео": "你的视频",
  "картинка": "图片",
  "идея словами": "用文字描述想法",
  "ваш промпт": "你的提示词",
  "нужно: 1 фото": "1 张照片",
  "нужно: Текст": "文本",
  "нужно: Тема": "主题",
  "нужно: Запись": "录音",
  "формат: Reels": "Reels",
  "формат: фото": "照片",
  "формат: видео": "视频",
  "формат: кружков": "圆形视频",
  "формат: шаблонов": "模板",
  "любое, где хорошо видно лицо": "任何能清楚看到脸的照片",
  "лицо крупно и при хорошем свете": "脸部特写，光线充足",
  "селфи, лицо крупно": "自拍，脸部特写",
  "снимок оживёт в ролике": "照片会在视频中动起来",
  "что скажет герой": "角色要说的话",
  "или фото, из которых сделаем слайды": "或用于制作幻灯片的照片",
  "Сколько стоит одна генерация": "生成一次需要多少费用",
  "Фото стоит {0} C, фотосессия {1} C за 3 кадра, видео {2} C за 5 секунд. Помощники для текста, например описание товара, стоят {3} C. Цена всегда видна на кнопке «Создать» до списания.": "照片 {0} C，写真 {1} C 可得 3 张，视频 {2} C 5 秒。文字助手（如商品描述）{3} C。扣费前，价格始终显示在「创建」按钮上。",
  "Что такое C и как пополнить баланс": "C 是什么，如何充值",
  "C это монеты Circle, ими платят за создание. Пакеты и подписка покупаются на вкладке «Баланс», там же виден остаток.": "C 即 Circle 币，用于支付创作费用。套装和订阅在「余额」标签页购买，也可在那里查看剩余数量。",
  "Какие файлы можно загружать": "可以上传哪些文件",
  "Видео до 1 минуты и 15 МБ, фото в JPG или PNG, аудио в MP3, WAV или M4A. Ограничения показываются в самом инструменте.": "视频最长 1 分钟、最大 15 MB，照片为 JPG 或 PNG，音频为 MP3、WAV 或 M4A。具体限制会在各工具中显示。",
  "Как сделать дешевле": "如何更便宜",
  "Если Circle на работу не хватает, кнопка внизу экрана откроет лист «Не хватает Circle»: в нём есть «Сделать дешевле». Скидка {0}%, на результате появится водяной знак.": "如果 Circle 不够，屏幕底部的按钮会打开「Circle 不足」页面，其中有「更便宜地制作」选项。可享 {0}% 折扣，结果会带水印。",
  "Где найти готовые результаты": "在哪里找到生成的结果",
  "В разделе «История» в меню «Ещё». Там же можно скачать файл повторно или отправить в чат.": "在「更多」菜单的「历史」中。也可以在那里重新下载文件或发送到聊天。",
  "Можно ли использовать свой голос": "可以使用自己的声音吗",
  "Да. Клонируйте голос на вкладке «Клон», и он появится в списке голосов во всех инструментах с озвучкой.": "可以。在「声音克隆」标签页克隆你的声音，它就会出现在所有配音工具的声音列表中。",
  "Фотосессия из {0} в стиле шаблона": "{0} 的模板风格写真",
  "По желанию: {0}": "可选：{0}",
  "Тут откроется шаблон «{0}»": "这里将打开模板「{0}」",
  "Только до": "仅前",
  "Только после": "仅后",
  "До: {0} %": "前：{0} %",
  "подборка": "合集",
  "Все форматы": "全部格式",
  "Состав": "阵容",
  "Вкладки каталога": "目录标签页",
  "Найти подборку": "查找合集",
  "Найти шаблон": "查找模板",
  "Поиск среди {0}": "在 {0} 中搜索",
  "По запросу «{0}» подборок нет. Поищите среди всех шаблонов": "没有与「{0}」相关的合集。试试在全部模板中搜索",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех шаблонах": "合集「{1}」中没有与「{0}」相关的内容。试试在全部模板中搜索",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех шаблонах": "「推荐」中没有与「{0}」相关的内容。试试在全部模板中搜索",
  "В подборке «{0}» нет сцен «{1}»": "合集「{0}」中没有「{1}」场景",
  "Посмотрите все сцены подборки": "查看合集中的全部场景",
  "В подборке «{0}» нет {1}": "合集「{0}」中没有{1}",
  "Посмотрите во всех форматах": "在全部格式中查看",
  "В «Рекомендуем» нет {0}": "「推荐」中没有{0}",
  "Пока ничего нет": "这里还没有内容",
  "Шаблоны этого формата появятся совсем скоро": "此格式的模板即将上线",
  "По запросу «{0}» среди {1} ничего нет. Поищите во всех форматах": "在{1}中没有找到与「{0}」相关的内容。试试在全部格式中搜索",
  "Искать во всех форматах": "在全部格式中搜索",
  "По запросу «{0}» среди шаблонов ничего нет. Попробуйте другое слово": "没有与「{0}」相关的模板。换个词试试",
  "Загружаем ещё": "正在加载更多",
  "Это все шаблоны": "已显示全部模板",
  "Тренды": "趋势",
  "Вкладки страницы": "页面标签页",
  "Найти сцену": "查找场景",
  "Найти в подборке": "在合集中搜索",
  "Искать во всех сценах": "在全部场景中搜索",
  "По запросу «{0}» подборок нет. Поищите среди всех сцен": "没有与「{0}」相关的合集。试试在全部场景中搜索",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех сценах": "合集「{1}」中没有与「{0}」相关的内容。试试在全部场景中搜索",
  "По запросу «{0}» в «Трендах» ничего нет. Поищите во всех сценах": "「趋势」中没有与「{0}」相关的内容。试试在全部场景中搜索",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех сценах": "「推荐」中没有与「{0}」相关的内容。试试在全部场景中搜索",
  "В «Трендах» нет сцен «{0}»": "「趋势」中没有「{0}」场景",
  "В «Рекомендуем» нет сцен «{0}»": "「推荐」中没有「{0}」场景",
  "Посмотрите все сцены этой вкладки": "查看此标签页的全部场景",
  "В подборке «{0}» ничего по запросу «{1}». Поищите во всех шаблонах": "合集「{0}」中没有与「{1}」相关的内容。试试在全部模板中搜索",
  "В этой подборке пока нет таких шаблонов. Посмотрите её целиком или выберите другую вкладку": "此合集中暂时没有这类模板。查看整个合集或选择其他标签页",
  "Поиск в подборке «{0}»: {1}": "在合集「{0}」中搜索：{1}",
  "Вкладки подборки": "合集标签页",
  "Нужно: {0}": "需要：{0}",
  "Нужно": "需要",
  "По запросу «{0}» нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "没有与「{0}」相关的工具或模板。换个词试试，或查看全部工具",
  "По запросу «{0}» в разделе «{1}» ничего нет. Поищите во всех инструментах": "「{1}」中没有与「{0}」相关的内容。试试在全部工具中搜索",
  "Искать во всех": "全部搜索",
  "По запросу «{0}» инструментов нет. Попробуйте другое слово": "没有与「{0}」相关的工具。换个词试试",
  "Найти инструмент": "查找工具",
  "Не удалось открыть инструмент. Обновите каталог и попробуйте снова.": "无法打开工具。请刷新目录后重试。",
  "Не удалось открыть инструмент за 30 секунд. Обновите запрос или вернитесь назад.": "工具 30 秒内未能打开。请重试或返回。",
  "Карточка товара": "商品卡片",
  "Рилс готов": "Reels 已完成",
  "Кавер не создан": "翻唱未生成",
  "Фотосессия не создана": "写真未生成",
  "Рилс не создан": "Reels 未生成",
  "Карточка не создана": "卡片未生成",
  "Слайды не созданы": "幻灯片未生成",
  "Запись не обработана": "录音未处理",
  "Коллаж не создан": "拼贴未生成",
  "· остаток {0} C": "· 剩余 {0} C",
  "Вернули {0} C": "已退回 {0} C",
  "Списано {0} C со скидкой, {1} водяной знак": "已扣除折后 {0} C，{1}水印",
  "Списано {0} C": "已扣除 {0} C",
  "Рисованному стилю камера не нужна": "手绘风格不需要相机",
  "У этой камеры объектив встроенный": "这台相机自带镜头",
  "У этой камеры резкость не настраивается": "这台相机无法调节对焦",
  "У этого объектива диафрагма постоянная": "这款镜头为固定光圈",
  "Встроенный": "内置",
  "Как у камеры": "与相机相同",
  "до {0} МБ": "最大 {0} MB",
  "По запросу {0} нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "没有与 {0} 相关的工具或模板。换个词试试，或查看全部工具",
  "По запросу {0} в разделе {1} ничего нет. Поищите во всех инструментах": "{1}中没有与 {0} 相关的内容。试试在全部工具中搜索",
  "По запросу {0} инструментов нет. Попробуйте другое слово": "没有与 {0} 相关的工具。换个词试试",
  "в «Трендах»": "在「趋势」中",
  "в «Рекомендуем»": "在「推荐」中",
  "в подборке {0}": "在合集 {0} 中",
  "По запросу {0} {1} ничего нет. Поищите во всех сценах": "{1}没有与 {0} 相关的内容。试试在全部场景中搜索",
  "В подборке {0} ничего по запросу {1}. Поищите во всех шаблонах": "合集 {0} 中没有与 {1} 相关的内容。试试在全部模板中搜索",
  "сцен {0}": "{0} 场景",
  "В подборке {0} нет {1}": "合集 {0} 中没有{1}",
  "В подборке {0} нет таких шаблонов": "合集 {0} 中没有这类模板",
  "Посмотрите её целиком или выберите другую вкладку": "查看整个合集或选择其他标签页",
  "По запросу {0} в этом формате ничего нет. Поищите во всех форматах": "此格式中没有与 {0} 相关的内容。试试在全部格式中搜索",
  "По запросу {0} среди шаблонов ничего нет. Попробуйте другое слово": "没有与 {0} 相关的模板。换个词试试",
  "Здесь нет шаблонов": "这里没有模板",
  "Заказ принят": "订单已受理",
  "Бот пришлёт результат в чат, в отдельную тему.": "机器人会把结果发送到聊天中的单独话题。",
  "Измените запрос и попробуйте снова. Circle за проверенный заказ не возвращаются.": "请修改请求后重试。已审核订单的 Circle 不予退还。",
  "Сбой на нашей стороне. Circle вернулись на баланс.": "我们这边出了问题。Circle 已退回余额。",
  "Инструмент ещё подключается: заказ стоит в очереди и начнётся сам, бот пришлёт результат в чат.": "工具仍在连接中：订单已排队，会自动开始，机器人会把结果发到聊天中。",
  "Сначала отметьте согласие ниже": "请先勾选下方的同意项",
  "Главное фото: {0}": "主照片：{0}",
  "Загружаем превью…": "正在加载预览…",
  "Фото не подошло": "照片不合适",
  "Проверить загрузку": "检查上传",
  "Опишите, что хотите увидеть": "描述你想看到的内容",
  "Не помещается: до {0} знаков": "太长了：最多 {0} 个字符",
  "{0} во весь экран": "全屏查看{0}",
  "Загрузить картинку": "上传图片",
  "Ваша": "你的",
  "Убрать картинку": "移除图片",
  "Этот инструмент пока недоступен": "该工具暂不可用",
  "Выберите другой инструмент или вернитесь к шаблонам.": "请选择其他工具，或返回模板。",
  "Вернуться": "返回",
  "Образ": "造型",
  "Ваши селфи": "你的自拍",
  "Три разных кадра: лицо крупно, при хорошем свете": "三张不同的照片：脸部特写，光线充足",
  "Подтверждаю согласие людей на фото": "我确认照片中的人已同意",
  "От одного до пяти ракурсов, первый — главный": "一到五个角度，第一张为主照片",
  "Категория": "类别",
  "Набор сцен": "场景组",
  "Загрузите фото: нужно {0}": "上传照片：需要 {0} 张",
  "Выберите: {0}": "选择：{0}",
  "Не удалось загрузить экран.": "页面加载失败。",
  "Сцен: {0}": "场景：{0}",
  "Заказ создан, следите за ним в «Истории».": "订单已创建，可在「历史」中查看进度。",
  "Старые": "最早",
  "Длинные": "最长",
  "Стиль уже задаёт свет и цвет. Выберите другой, если хотите поменять": "风格已决定光线和色彩。想更改的话请选择其他风格",
  "{0} открывается только до f/{1}": "{0} 最大光圈仅为 f/{1}",
  "Объектив не задаёт светосилу": "该镜头不设定光圈",
  "Этот объектив открывается только до f/{0}": "该镜头最大光圈仅为 f/{0}",
  "Назад к настройкам": "返回设置",
  "Группа": "分组",
  "Нашли {0}": "找到 {0}",
  "Ничего не нашлось. Попробуйте другое слово или сбросьте группу.": "什么也没找到。试试其他关键词或重置分组。",
  "Выбор сразу вернёт к настройкам. Цена не меняется": "选择后会直接返回设置，价格不变",
  "Сравнить: было и стало": "对比：前后效果",
  "Берём стиль: цвет, свет, обработку. Саму картинку и лица с неё не переносим": "我们借用风格：色彩、光线和后期处理。不会复制图片本身和其中的人脸",
  "Берём сцену: фон, свет и подачу. Саму картинку и лица с неё не переносим": "我们借用场景：背景、光线和构图。不会复制图片本身和其中的人脸",
  "Берём образ: одежду, позу, фон и свет. В кадре будете вы, лица с картинки не переносим": "我们借用造型：服装、姿势、背景和光线。画面中是你，不会复制图片中的人脸",
  "Картинка не подошла: не открывается, попробуйте JPG или PNG": "图片不合适：无法打开，请尝试 JPG 或 PNG",
  "Картинка не подошла: больше {0} МБ": "图片不合适：超过 {0} MB",
  "Картинка не подошла: слишком маленькая, нужна от {0} px": "图片不合适：太小，至少需要 {0} px",
  "Картинка не подошла: на ней защищённое или запрещённое содержимое": "图片不合适：包含受保护或被禁止的内容",
  "Загрузить картинку-референс": "上传参考图片",
  "Озвучка текста": "文本配音",
  "Запишите от 2 секунд речи, и бот заговорит вашим голосом": "录制 2 秒语音，机器人就能用你的声音说话",
  "Готовые голоса стоят на вкладке «Мои» в разделе «Озвучка»": "做好的声音在「配音」的「我的」标签页中",
  "Под этим именем голос стоит в вашем списке. Описание видите только вы": "声音会以这个名称出现在你的列表中。描述只有你能看到",
  "Голос появится на вкладке «Мои»": "声音会出现在「我的」标签页中",
  "Имя в списке голосов": "声音列表中的名称",
  "Уже в «Озвучке»": "已在「配音」中",
  "Голос стоит на вкладке «Мои» с меткой «Мой голос»": "声音在「我的」标签页中，带有「我的声音」标记",
  "Карточка голоса": "声音卡片",
  "Нажмите на голос в списке, чтобы переименовать или удалить": "点击列表中的声音即可重命名或删除",
  "Так голос выглядит в списке": "声音在列表中的样子",
  "Голос уже стоит на вкладке «Мои». Послушайте, как он звучит": "声音已在「我的」标签页中。听听效果吧",
  "Идёт проверка и обучение, обычно 1–3 минуты. Голос появится на вкладке «Мои» сам": "正在检查和训练，通常需要 1–3 分钟。声音会自动出现在「我的」标签页中",
  "Голос пропадёт с вкладки «Мои». Вернуть его не получится.": "声音将从「我的」标签页中消失，且无法恢复。",
  "Обычно 1–3 минуты. Можно закрыть приложение, голос появится в списке": "通常需要 1–3 分钟。可以关闭应用，声音会出现在列表中",
  "Можно закрыть приложение": "可以关闭应用",
  "Запишите речь или загрузите файлы: от 0:02 до 1:30. Подойдут MP3, WAV, M4A, OGG и WEBM, до 10 файлов по 20 МБ": "录制语音或上传文件：总时长 0:02 至 1:30。支持 MP3、WAV、M4A、OGG 和 WEBM，最多 10 个文件，每个不超过 20 MB",
  "Создано {n} клонов из {n}. Удалите один, чтобы добавить новый": "已创建 {n} 个克隆，上限 {n} 个。删除一个才能新建",
  "Без подписки можно создать {n} клона. С подпиской их будет {0}": "无订阅可创建 {n} 个克隆，订阅后最多 {0} 个",
  "До {0} клонов": "最多 {0} 个克隆",
  "Три клона бесплатно": "免费三个克隆",
  "Запишите ещё один, другим тоном или настроением": "再录一段，换个语气或情绪",
  "С подпиской можно создать до {0}": "订阅后最多可创建 {0} 个",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Чем естественнее получится сейчас, тем точнее будет звучать клон.": "你好！这是为我的声音录制的样本。我说话平静，语速正常，就像和朋友聊天一样。现在越自然，克隆出来的声音就越像。",
  "Знаете, что самое странное в готовке по видео? Смотришь, как человек за минуту режет лук, и думаешь: это же просто. А потом лук почему-то везде, кроме сковородки.": "你知道跟着视频做饭最奇怪的是什么吗？看别人一分钟切好一个洋葱，心想：这很简单嘛。结果洋葱不知怎么撒得到处都是，就是没进锅里。",
  "Вчера наконец разобрал коробки после переезда. Нашёл старый плеер, три зарядки от телефонов, которых уже нет, и тетрадь с планами на лето. Плеер до сих пор работает.": "昨天终于把搬家的箱子拆完了。翻出一个旧播放器、三根早已没有的手机的充电线，还有一本写着暑假计划的笔记本。播放器到现在还能用。",
  "Погода сегодня странная: утром светило солнце, к обеду пошёл дождь, а к вечеру обещают снег. Самое время заварить что-нибудь горячее и никуда не торопиться.": "今天的天气很奇怪：早上出太阳，中午下雨，晚上据说还要下雪。正适合泡点热饮，哪儿也不急着去。",
  "Раз, два, три, проверка. Меня хорошо слышно? Сейчас я прочитаю несколько фраз разным тоном: сначала спокойно, потом чуть громче, а в конце совсем тихо, почти шёпотом.": "一、二、三，试音。听得清楚吗？现在我会用不同的语气读几句话：先平静地读，再大声一点，最后很轻，几乎是耳语。",
  "Мой кот считает, что клавиатура создана для сна, а монитор нужен, чтобы закрывать его хвостом. Поэтому если в записи что-то зашуршит, знайте: это была командная работа.": "我家猫觉得键盘是用来睡觉的，显示器是用来拿尾巴挡住的。所以如果录音里有沙沙声，要知道：那是团队合作。",
  "Есть простое правило: если что-то не получается с третьей попытки, надо встать, налить чаю и вернуться через пять минут. Обычно после этого всё получается само.": "有个简单的规则：如果试了三次还不行，就站起来，倒杯茶，五分钟后再回来。通常之后一切都会顺利起来。",
  "Тихо, слышите? Где-то рядом шаги. Сейчас аккуратно выглянем за угол, и если там никого нет, перебежим к двери. Только не шумите, пожалуйста, я серьёзно.": "嘘，听到了吗？附近有脚步声。我们小心地从拐角探头看看，如果没人，就跑到门口。拜托别出声，我是认真的。",
  "Проверено": "已验证",
  "Создание новых голосов пока недоступно": "暂时无法创建新声音",
  "От 2 секунд речи: запись в браузере или готовые файлы": "2 秒语音：在浏览器中录制或上传文件",
  "Внутренняя ошибка, попробуйте позже": "内部错误，请稍后再试",
  "образцов: {n}": "样本：{n}",
  "Образец короче 2 секунд": "样本短于 2 秒",
  "Образец длиннее 1,5 минуты": "样本长于 1.5 分钟",
  "Слишком шумная запись — попробуйте в тихом месте": "录音噪音太大，请在安静的地方重试",
  "В записи слышно несколько голосов": "录音中能听到多个声音",
  "Проверка не пройдена: голос не совпадает с образцами": "检查未通过：声音与样本不一致",
  "Голос не прошёл правила площадки": "声音不符合平台规则",
  "Проверка не пройдена: запишите образец без музыки и других людей": "检查未通过：请录制没有音乐和其他人声的样本",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме": "语音总时长需在 2 秒到 1.5 分钟之间",
  "Результат обработки уточняется, загляните чуть позже": "处理结果正在确认中，请稍后再来看看",
  "Удалить голос «{n}»?": "删除声音「{n}」？",
  "Навсегда, вместе с образцами": "永久删除，样本一并删除",
  "Например, спокойный, низкий": "例如：平静、低沉",
  "Образец": "样本",
  "Запись или файлы, от 2 секунд": "录音或文件，至少 2 秒",
  "Имя, описание и согласие": "名称、描述和同意",
  "Проверка и обучение": "检查与训练",
  "Модель STEOS · 1–3 минуты": "STEOS 模型 · 1–3 分钟",
  "Тихое место без эха": "没有回声的安静地方",
  "Фоновый шум и музыка попадут в голос": "背景噪音和音乐会混进声音里",
  "Хороший микрофон": "好的麦克风",
  "Гарнитура или настольный микрофон лучше встроенного": "耳麦或桌面麦克风比内置麦克风更好",
  "То же оборудование": "相同的设备",
  "Не меняйте микрофон между записями": "录制之间不要更换麦克风",
  "Под ним голос стоит в списке выбора": "声音会以此名称出现在选择列表中",
  "Шумоподавление": "降噪",
  "Включайте, только если в записи слышен шум": "仅在录音有明显噪音时开启",
  "Согласие обязательно": "必须获得同意",
  "Клонировать можно свой голос или с согласия владельца": "只能克隆自己的声音，或经声音主人同意的声音",
  "Проверка образца": "样本检查",
  "Один говорящий, без музыки и шума": "单人说话，无音乐和噪音",
  "Обучение": "训练",
  "Модель STEOS, обычно 1–3 минуты": "STEOS 模型，通常 1–3 分钟",
  "Голос появится в списке сам": "声音会自动出现在列表中",
  "Проверьте запись": "检查录音",
  "Один голос, без музыки и шума на фоне": "单一人声，无音乐和背景噪音",
  "Длина образца": "样本时长",
  "Нужно не меньше 2 секунд чистой речи": "至少需要 2 秒清晰语音",
  "Образцы сохранены": "样本已保存",
  "Можно попробовать снова с теми же файлами": "可以用相同的文件重试",
  "Не получилось — попробуйте снова": "没有成功，请重试",
  "Шаг {a} из {b}": "第 {a} 步，共 {b} 步",
  "Персональный": "个人",
  "Дальше": "下一步",
  "Продолжить": "继续",
  "К списку голосов": "返回声音列表",
  "Результат уточняется": "结果确认中",
  "Попробовать снова": "重试",
  "Голос готов": "声音已就绪",
  "Опишите голос": "描述声音",
  "Например, Мой голос": "例如：我的声音",
  "Это мой голос или у меня есть согласие его владельца. Я не буду использовать клон для обмана, оскорблений и запрещённого контента": "这是我的声音，或我已获得声音主人的同意。我不会将克隆用于欺骗、辱骂或违禁内容",
  "Загружаем {a} из {b}": "正在上传第 {a} 个，共 {b} 个",
  "Обрабатываем голос": "正在处理声音",
  "Не получилось создать голос": "声音创建失败",
  "Результат обработки ещё уточняется. Повтор пока недоступен.": "处理结果仍在确认中，暂时无法重试。",
  "Образцы сохранены — можно попробовать снова с теми же файлами": "样本已保存，可以用相同的文件重试",
  "Загруженные файлы": "已上传的文件",
  "Читаем аудио…": "正在读取音频…",
  "Записать ещё": "再录一段",
  "Ждём разрешение…": "等待授权…",
  "Разрешите доступ в настройках браузера или загрузите файл": "请在浏览器设置中允许访问，或上传文件",
  "Другой текст": "换一段文字",
  "Прочитайте вслух": "请大声朗读",
  "Микрофон по умолчанию": "默认麦克风",
  "Минимум": "最低",
  "Хорошо": "良好",
  "Отлично": "优秀",
  "Набрано {a} из {b}": "已录制 {a} / {b}",
  "из {t}": "共 {t}",
  "всё готово": "全部就绪",
  "Файлов с ошибкой: {n}": "出错的文件：{n}",
  "до «{n}» ещё {t}": "距「{n}」还差 {t}",
  "Ещё {t} до минимума": "距最低要求还差 {t}",
  "Нужно не меньше 2 секунд": "至少需要 2 秒",
  "Загрузка образцов": "正在上传样本",
  "Образцы приняты сервером": "服务器已收到样本",
  "Проверка голоса": "声音检查",
  "Пройдена": "已通过",
  "Не запрашивалась": "未请求",
  "Результат проверки пока недоступен": "检查结果暂不可用",
  "Обработка голоса": "声音处理",
  "Не удалось обработать": "处理失败",
  "Выполняется на сервере": "正在服务器上运行",
  "Очистка шума": "降噪处理",
  "Пропущено": "已跳过",
  "Модель STEOS · один говорящий, без музыки": "STEOS 模型 · 单人说话，无音乐",
  "Обучение голоса": "声音训练",
  "Файл больше 20 МБ": "文件超过 20 MB",
  "Запись {n}": "录音 {n}",
  "Не удалось прочитать аудио": "无法读取音频",
  "Неподдерживаемый формат": "不支持的格式",
  "Результат прошлого создания ещё уточняется. Вернитесь к прежнему запросу, чтобы не создать второй клон.": "上一次创建的结果仍在确认中。请返回之前的请求，以免创建第二个克隆。",
  "Проверить прошлое создание": "查看上一次创建",
  "Остановить": "停止",
  "Ждём доступ": "等待授权",
  "Ещё раз": "再试一次",
  "Начать запись": "开始录音",
  "Нажмите на голос в списке, чтобы открыть его карточку: прослушать, переименовать или удалить.": "点击列表中的声音即可打开它的卡片：试听、重命名或删除。",
  "Озвучек": "配音次数",
  "Знаков": "字符数",
  "Образцов": "样本数",
  "Доступна": "可用",
  "Недоступна": "不可用",
  "После обучения": "训练后",
  "Голос обучен на ваших записях: образцов {n}, всего {d}": "该声音基于你的录音训练：{n} 个样本，共 {d}",
  "Происхождение: ваши записи. Подробнее": "来源：你的录音。了解更多",
  "Происхождение": "来源",
  "Ваши записи": "你的录音",
  "Проверка": "检查",
  "Не пройдена": "未通过",
  "Идёт": "进行中",
  "Переозвучка аудио": "音频重新配音",
  "Создан": "创建时间",
  "Доступ": "访问权限",
  "Только вы": "仅自己",
  "Голос пока недоступен для выбора. Обновите список.": "该声音暂时无法选择。请刷新列表。",
  "Голос ещё учится, обычно 1–3 минуты": "声音仍在训练中，通常需要 1–3 分钟",
  "Коротко о голосе": "声音简介",
  "О голосе": "关于声音",
  "Голос не создан": "声音未创建",
  "Обработка дольше обычного": "处理时间比平时长",
  "Сервер ещё обрабатывает голос. Можно закрыть приложение и вернуться позже.": "服务器仍在处理声音。可以关闭应用，稍后再回来。",
  "Аватар {n} останется без голоса, в кружках зазвучит голос по умолчанию.": "头像 {n} 将失去声音，其圆形视频将使用默认声音。",
  "Аватары {n} останутся без голоса, в кружках зазвучит голос по умолчанию.": "头像 {n} 将失去声音，其圆形视频将使用默认声音。",
  "Записать первый голос": "录制第一个声音",
  "клон|клона|клонов": "个克隆",
  "в месяц": "每月",
  "{n} C в месяц": "每月 {n} C",
  "{n} своих голосов": "{n} 个自定义声音",
  "Оформить": "订阅",
  "Подписка активна": "订阅已生效",
  "Подписка «{n}»": "订阅「{n}」",
  "{n} голосов ваши": "{n} 个声音归你",
  "Доступно — своих голосов": "可用的自定义声音",
  "{n} голосов мало?": "{n} 个声音不够用？",
  "Возьмите {n}": "选择 {n}",
  "Нужно больше голосов?": "需要更多声音？",
  "До {n} с подпиской": "订阅后最多 {n} 个",
  "Посмотрите доступные подписки": "查看可用的订阅",
  "Занято {a} из {b}. Записывайте голоса под разные задачи и настроения": "已用 {a} / {b}。为不同的任务和情绪录制声音吧",
  "Без подписки можно создать {a} {w}. С любой подпиской их будет {b}": "无订阅可创建 {a} {w}。任意订阅后最多 {b} 个",
  "Без подписки: {n}. Лимит зависит от выбранной подписки.": "无订阅：{n}。上限取决于所选订阅。",
  "Занято {a} из {b}": "已用 {a} / {b}",
  "Без подписки · {n}": "免费 · {n}",
  "С подпиской · {n}": "订阅 · {n}",
  "Смотреть все подписки": "查看全部订阅",
  "Повторить сохранение": "重新保存",
  "Сохраняем изменения…": "正在保存更改…",
  "Управление голосами временно недоступно": "声音管理暂时不可用",
  "клон: Мой голос": "我的声音",
  "Свои голоса временно недоступны. Попробуйте обновить список позже.": "自定义声音暂时不可用。请稍后刷新列表。",
  "Сервис голосов временно недоступен. Попробуйте ещё раз позже.": "声音服务暂时不可用。请稍后再试。",
  "Не удалось подтвердить лимит голосов. Обновите список позже.": "无法确认声音数量上限。请稍后刷新列表。",
  "Не удалось подтвердить аккаунт. Попробуйте ещё раз позже.": "无法验证账号。请稍后再试。",
  "Имя голоса должно содержать от 2 до 32 символов.": "声音名称须为 2 到 32 个字符。",
  "Описание должно содержать не больше 120 символов.": "描述不能超过 120 个字符。",
  "Добавьте от 1 до 10 подходящих образцов.": "请添加 1 到 10 个合适的样本。",
  "Превью этого голоса пока недоступно.": "该声音的预览暂不可用。",
  "Не удалось загрузить превью. Попробуйте позже.": "预览加载失败。请稍后再试。",
  "Слишком шумная запись. Попробуйте записать голос в тихом месте.": "录音噪音太大。请在安静的地方录制。",
  "В записи слышно несколько голосов. Добавьте речь одного человека.": "录音中能听到多个声音。请只添加一个人的语音。",
  "Голос не прошёл правила площадки.": "声音不符合平台规则。",
  "Сервис не смог обработать голос. Проверьте статус перед повтором.": "服务无法处理该声音。重试前请先查看状态。",
  "Согласие изменилось или недоступно. Обновите список и подтвердите актуальную версию перед повтором.": "同意条款已变更或不可用。请刷新列表并确认最新版本后再重试。",
  "Загрузка отклонена. Нажмите кнопку ещё раз, чтобы загрузить образец заново.": "上传被拒绝。再次点击按钮重新上传样本。",
  "Загрузка ещё не подтверждена. Нажмите кнопку ещё раз: сначала проверим прежнюю загрузку.": "上传尚未确认。再次点击按钮：我们会先检查之前的上传。",
  "Выберите аудиофайл MP3, WAV, M4A, OGG или WebM.": "请选择 MP3、WAV、M4A、OGG 或 WebM 音频文件。",
  "Не удалось прочитать аудио. Попробуйте ещё раз или загрузите файл.": "无法读取音频。请重试或上传文件。",
  "Пример звучания": "示例音频",
  "Пример звучания пока недоступен": "示例音频暂不可用",
  "Превью голоса": "声音预览",
  "Прослушать пример": "播放示例",
  "Скидка {0}% на первый пакет Circle действует {1} {2} после оформления подписки": "订阅后 {1} {2}内，首个 Circle 充值包享 {0}% 折扣",
  "Вы уже пришли по ссылке партнёра": "你已通过合作伙伴链接加入",
  "Промокод партнёра уже применён": "已使用合作伙伴推广码",
  "Тут откроется тема чата, куда бот прислал {0}": "这里会打开机器人发送{0}的聊天话题",
  "можно вывести": "可提现",
  "только в STEOS": "仅限 STEOS",
  "Не короче {0} знаков": "至少 {0} 个字符",
  "Введите почту и пароль": "请输入邮箱和密码",
  "от {0} знаков": "至少 {0} 个字符",
  "После входа Circle станут общими для бота и аккаунта STEOS. Баланс и вывод есть и на {0}.": "登录后，Circle 将在机器人和 STEOS 账号之间共享。在 {0} 上也可以查看余额和提现。",
  "Вход или новый аккаунт": "登录或创建新账号",
  "Придумайте пароль": "设置密码",
  "Ваш пароль": "你的密码",
  "Принимаю {0} и {1} STEOS": "我接受 STEOS {0}和{1}",
  "согласие: условия": "服务条款",
  "согласие: политику конфиденциальности": "隐私政策",
  "Пришлём ссылку на почту": "我们会把链接发到你的邮箱",
  "Откройте ссылку из письма и задайте новый пароль на {0}. Потом войдите здесь с новым паролем.": "打开邮件中的链接，在 {0} 上设置新密码。然后用新密码在这里登录。",
  "Ссылка для нового пароля ушла на {0}": "重置密码链接已发送至 {0}",
  "Письма нет? Проверьте папку «Спам».": "没收到邮件？请检查「垃圾邮件」文件夹。",
  "Аккаунт создан и подключён": "账号已创建并关联",
  "Баланс бота теперь общий с аккаунтом STEOS.": "机器人余额现已与 STEOS 账号共享。",
  "Подтвердите почту по ссылке из письма.": "请通过邮件中的链接验证邮箱。",
  "Вывод работает здесь и на {0}.": "在这里和 {0} 上都可以提现。",
  "Открыть {0}": "打开 {0}",
  "Ссылка ушла на {0}. Откройте её, затем проверьте подключение здесь.": "链接已发送至 {0}。打开链接后，在这里检查关联状态。",
  "Проверить подключение": "检查关联",
  "Почти готово": "快完成了",
  "Почта ещё не подтверждена": "邮箱尚未验证",
  "Не удалось проверить. Попробуйте позже": "检查失败，请稍后再试",
  "Озвучиваю тексты голосом героя": "用角色的声音为文本配音",
  "Любой голос из библиотеки или свой": "声音库中的任意声音或你自己的声音",
  "Озвучиваю тексты голосами героев в STEOS. Попробуйте по моей ссылке, промокод {0}": "我在 STEOS 用角色的声音为文本配音。通过我的链接试试吧，推广码 {0}",
  "Пишу текст, персонаж говорит": "我打字，角色说话",
  "Делаю кружки с персонажами в STEOS: пишу текст, а персонаж его говорит. Промокод {0}": "我在 STEOS 制作角色圆形视频：我写文字，角色说出来。推广码 {0}",
  "Свои фото в любом образе": "你的照片，任意造型",
  "Фотосессия в любом образе по паре моих фото, без студии. STEOS, промокод {0}": "只需几张我的照片，就能拍出任意造型的写真，无需影棚。STEOS，推广码 {0}",
  "Вы в кадре, монтаж и музыка сами": "你出镜，剪辑和音乐自动完成",
  "Снимаюсь в рилсах одной кнопкой в STEOS: сюжет, монтаж и музыка уже в шаблоне. Промокод {0}": "在 STEOS 一键出演 Reels：剧情、剪辑和音乐都已在模板中。推广码 {0}",
  "Персонаж оживает": "角色活起来了",
  "Говорит вашим текстом": "说出你的文字",
  "Персонаж говорит моим текстом и своим голосом. Попробуйте STEOS, промокод {0}": "角色用自己的声音说出我的文字。试试 STEOS，推广码 {0}",
  "Клон голоса за минуту": "一分钟克隆声音",
  "Запишите от 2 секунд, дальше говорит клон": "录制 2 秒，之后由克隆替你说话",
  "Клон моего голоса за минуту в STEOS: теперь он озвучивает всё сам. Промокод {0}": "在 STEOS 一分钟克隆了我的声音：现在它替我配所有的音。推广码 {0}",
  "Старому фото цвет и резкость": "让老照片恢复色彩和清晰度",
  "Восстановление за минуту": "一分钟修复",
  "Возвращаю старым фото цвет и резкость в STEOS. Промокод {0}": "我在 STEOS 让老照片恢复色彩和清晰度。推广码 {0}",
  "По ссылке или промокоду": "通过链接或推广码",
  "Дарю +{0} C и скидку {1}% на первый пакет в STEOS по моему промокоду {2}": "用我的推广码 {2}，在 STEOS 获得 +{0} C 和首个充值包 {1}% 折扣",
  "Кавер на любую песню": "任意歌曲翻唱",
  "Рок, джаз, lo-fi любым голосом": "摇滚、爵士、lo-fi，任意声音",
  "Кавер на любую песню любым голосом в STEOS. Промокод {0}": "在 STEOS 用任意声音翻唱任意歌曲。推广码 {0}",
  "Мой аватар в любом образе": "我的头像，任意造型",
  "Свой аватар из 10 фото": "用 10 张照片生成你的头像",
  "Мой аватар в любом образе: собран из 10 фото в STEOS. Промокод {0}": "我的头像，任意造型：在 STEOS 用 10 张照片生成。推广码 {0}",
  "Это я, только говорю вашим текстом": "这就是我，只是说着你的文字",
  "сторис: Мой голос": "我的声音",
  "на баланс сразу": "立即到账",
  "на первый пакет Circle": "首个 Circle 充值包",
  "Сторис открыта в Telegram": "快拍已在 Telegram 中打开",
  "Сторис готова": "快拍已就绪",
  "Осталось нажать «Опубликовать» в редакторе Telegram": "只需在 Telegram 编辑器中点击「发布」",
  "Тут откроется редактор сторис Telegram с этой картинкой и подписью": "这里会打开 Telegram 快拍编辑器，带有这张图片和文字",
  "Подпись к сторис": "快拍文字",
  "Кнопка-ссылка на сторис в Telegram есть только с Premium. Промокод на картинке видят все.": "只有 Telegram Premium 才能在快拍中显示链接按钮。图片上的推广码所有人都能看到。",
  "Опубликовать в сторис": "发布到快拍",
  "Попробовать STEOS": "试试 STEOS",
  "Не удалось подготовить сторис. Попробуйте ещё раз": "快拍准备失败。请重试",
  "Сторис отправляет Telegram: откройте мини-приложение в Telegram": "快拍由 Telegram 发布：请在 Telegram 中打开小程序",
  "Ссылка и промокод уже на картинке": "链接和推广码已在图片上",
  "Попробуйте STEOS по моей ссылке. Промокод {0}": "通过我的链接试试 STEOS。推广码 {0}",
  "Попробуйте STEOS по моей ссылке: +{0} C и скидка {1}% на первый пакет. Промокод {2}": "通过我的链接试试 STEOS：+{0} C，首个充值包 {1}% 折扣。推广码 {2}",
  "Ссылка": "链接",
  "Скопировать ссылку": "复制链接",
  "Друзьям {0} и {1} на первый пакет": "好友获得 {0}，首个充值包享 {1}",
  "Промокод выделен: скопируйте вручную": "推广码已选中：请手动复制",
  "Ссылка выделена: скопируйте вручную": "链接已选中：请手动复制",
  "Ссылка скопирована": "链接已复制",
  "Ссылка выделена: скопируйте её вручную": "链接已选中：请手动复制",
  "Ссылка выделена": "链接已选中",
  "Вы пришли по приглашению": "你是受邀加入的",
  "{0} C на баланс": "{0} C 到余额",
  "Сгорят через {0} {1}": "{0} {1}后过期",
  "{0} на первый пакет Circle": "首个 Circle 充值包 {0}",
  "{0} {1} после оформления подписки": "订阅后 {0} {1}内",
  "Пакеты Circle можно купить с любой подпиской. Скидка начнёт действовать, как только вы её оформите.": "任意订阅均可购买 Circle 充值包。订阅后折扣立即生效。",
  "Выбрать тариф": "选择套餐",
  "QR-код ссылки приглашения, промокод {0}": "邀请链接二维码，推广码 {0}",
  "Друг наведёт камеру и откроет бота": "好友用相机扫码即可打开机器人",
  "Цвет карточки": "卡片颜色",
  "Скачать картинку": "下载图片",
  "Аврора": "极光",
  "Закат": "日落",
  "Океан": "海洋",
  "Графит": "石墨",
  "Партнёры": "合作伙伴",
  "Нашёл бота, где любой персонаж скажет в кружке твой текст. Там же фото, видео и озвучка любым голосом, всё прямо в Telegram.": "发现了一个机器人，任何角色都能在圆形视频里说出你的文字。还能做照片、视频和任意声音的配音，全都在 Telegram 里。",
  "Делюсь находкой: STEOS, бот в Telegram, где я делаю кружки с персонажами, озвучку и фото. Пишете текст, выбираете голос, и через минуту готово.": "分享个好东西：STEOS，一个 Telegram 机器人，我用它制作角色圆形视频、配音和照片。写好文字，选个声音，一分钟就好。",
  "Восстанавливаю наши старые семейные фото в STEOS: за минуту возвращает цвет и резкость. Пришлите мне снимки, которые хотите обновить, или попробуйте сами.": "我在用 STEOS 修复家里的老照片：一分钟就能恢复色彩和清晰度。把想修复的照片发给我，或者自己试试。",
  "Кто хотел кружок голосом любимого героя? В STEOS пишешь текст, и персонаж из игры или сериала его произносит. Это бот в Telegram.": "谁想要用最喜欢的角色声音发圆形视频？在 STEOS 里写好文字，游戏或剧集里的角色就会说出来。这是一个 Telegram 机器人。",
  "Фото товара, карточки с преимуществами и описания для маркетплейсов делаю в STEOS за пару минут, без студии и дизайнера. Может, и вам пригодится.": "我用 STEOS 几分钟就能做好商品照片、卖点卡片和电商平台描述，不用影棚也不用设计师。也许你也用得上。",
  "Озвучиваю ролики своим клоном голоса, снимаюсь в рилсах по готовым шаблонам и записываю каверы. Всё в одном боте STEOS в Telegram.": "我用自己的声音克隆给视频配音，用现成模板出演 Reels，还录翻唱。全都在 Telegram 的 STEOS 机器人里。",
  "По моей ссылке +{0} C на старт.": "通过我的链接，开局送 +{0} C。",
  "По моей ссылке +{0} C и −{1}% на первый пакет.": "通过我的链接：+{0} C，首个充值包 −{1}%。",
  "Попробуй сам.": "自己试试吧。",
  "Попробуйте сами.": "自己试试吧。",
  "Актёры": "演员",
  "Персонажи и актёры": "角色和演员",
  "По запросу «{q}» голосов нет. Попробуйте другое слово или загляните в подборки": "没有与「{q}」匹配的声音。试试其他关键词或浏览合集",
  "Здесь пока нет голосов. Загляните в другие вкладки или подборки": "这里还没有声音。看看其他标签页或合集吧",
  "Голос вернётся на экран создания": "声音会返回到创建页面",
  "После выбора пишите текст для озвучки в чат бота": "选择后，在机器人聊天中发送要配音的文字",
  "От Я до А": "从 Z 到 A",
  "Сортировка и фильтры": "排序和筛选",
  "Сбросить": "重置",
  "Чаще всего выбирают": "最多人选",
  "Сначала свежие": "最新优先",
  "Сначала давние": "最早优先",
  "Сначала недорогие": "价格从低到高",
  "Сначала короткие ролики": "短视频优先",
  "По названию": "按名称",
  "По названию, с конца алфавита": "按名称倒序",
  "Вертикальные ролики": "竖屏视频",
  "Картинки и посты": "图片和帖子",
  "Горизонтальные ролики": "横屏视频",
  "Видеосообщения Telegram": "Telegram 视频消息",
  "Один человек в кадре": "画面中一个人",
  "Трое и больше": "三人及以上",
  "С ребёнком": "带孩子",
  "С питомцем": "带宠物",
  "Двое человек в кадре": "画面中两个人",
  "О разделе": "关于",
  "Превращает текст в речь: голос из каталога или ваш клон, настройки интонации и скорости.": "把文字转成语音：使用目录中的声音或你的克隆，可调节语调和语速。",
  "Копия вашего голоса по записи: ею можно озвучивать любые тексты.": "根据录音复制你的声音：可以用它为任何文字配音。",
  "AI-студия: ролики, фото, кружки и другие шаблоны с вами, близкими и персонажами.": "AI 工作室：与你、亲友和角色一起制作视频、照片、圆形视频等模板。",
  "Кредиты (C) на счёте и пополнение. Кредиты списываются за озвучку и заказы студии.": "账户中的点数（C）与充值。点数用于配音和工作室订单。",
  "Задания и награды: выполняйте задания и получайте кредиты.": "任务与奖励：完成任务，赚取点数。",
  "Все ваши озвучки и заказы студии: послушать, скачать или повторить.": "你所有的配音和工作室订单：试听、下载或再做一次。",
  "Ваш профиль и данные аккаунта.": "你的个人资料和账号信息。",
  "Настройки приложения: язык, валюта и уведомления.": "应用设置：语言、货币和通知。",
  "Ответы на частые вопросы и связь с поддержкой.": "常见问题解答和联系支持。",
  "Партнёрская программа: приглашайте друзей и получайте процент с их пополнений.": "合作伙伴计划：邀请好友，从他们的充值中获得分成。",
  "Озвучка больших текстов и сценариев по ролям.": "为长文本和剧本按角色配音。",
  "Вы или один близкий": "你或一位亲友",
  "Вы и близкий": "你和亲友",
  "Товары и места": "商品和地点",
  "Фото товара, блюда или места": "商品、菜品或地点的照片",
  "В избранном": "已收藏",
  "Голоса и персонажи, которые вы отметили сердцем": "你用爱心标记的声音和角色",
  "Нажмите — выбрать голос": "点按选择声音",
  "Удерживайте — карточка голоса": "长按查看声音卡片",
  "Карточка голоса или персонажа": "声音或角色卡片",
  "Нажмите на голос, чтобы выбрать его": "点按声音即可选择",
  "Удерживайте, чтобы открыть карточку голоса": "长按打开声音卡片",
  "Удаление голоса": "删除声音",
  "Подсказка": "提示",
  "Пример звучания пока недоступен. Попробуйте позже.": "示例暂不可用，请稍后再试。",
  "Языков: {0}": "语言：{0}",
  "Ещё языков: {0}": "更多语言：{0}",
  "Ход примера": "示例进度",
  "Голос говорит на {0} языках": "该声音支持 {0} 种语言",
  "Все голоса мультиязычные и озвучат текст на любом языке системы.": "所有声音均支持多语言，可用系统支持的任何语言朗读文本。",
  "Голоса подборки": "合集中的声音",
  "Удерживайте голос, чтобы открыть его": "长按声音即可打开",
  "Назад к голосу": "返回声音",
  "Оригинал голоса говорил на {0} языке": "原声使用的语言：{0}",
  "Происхождение: {0}. Подробнее": "来源：{0}。详情",
  "Новый": "新",
  "Официальный": "官方",
  "Актёр": "演员",
  "Удерживайте, чтобы послушать": "长按试听",
  "Удерживайте строку голоса или нажмите её правой кнопкой мыши, чтобы открыть карточку голоса. Персонаж открывается обычным нажатием.": "长按声音行或右键点击即可打开声音卡片。角色只需轻点即可打开。",
  "Подборка · Голосов: {0}": "合集 · 声音：{0}",
  "Доступные голоса появятся в каталоге. Здесь можно будет прослушать пример и выбрать голос для бота.": "可用的声音将出现在目录中。在这里可以试听示例并为机器人选择声音。",
  "Зажмите голос": "长按声音",
  "Удерживайте строку голоса, чтобы открыть его карточку: прослушать и посмотреть подборки. Короткое нажатие выбирает голос.": "长按声音行即可打开其卡片：试听并查看所属合集。轻点则选择该声音。",
  "Нажмите на аватарку": "点按头像",
  "Круглая аватарка в строке проигрывает пример голоса. Нажмите ещё раз, чтобы остановить. Нажатие на саму строку выбирает голос.": "行中的圆形头像会播放声音示例。再次点按即可停止。点按该行本身则选择声音。",
  "Сохраняйте в избранное": "收藏起来",
  "Нажмите сердце в карточке голоса или персонажа — они соберутся в подборке «Избранное», первой в «Подборках» и на «Рекомендуем». Нажмите ещё раз, чтобы убрать.": "点按声音或角色卡片上的爱心——它们会汇集到“收藏”合集中，该合集位于“合集”和“推荐”的首位。再次点按即可移除。",
  "Запишите свой голос": "录制你的声音",
  "30 секунд речи или пара файлов, и через две минуты ваш голос появится во всех инструментах с озвучкой. Нажмите «Записать» и читайте текст с экрана.": "30 秒语音或几个文件，两分钟后你的声音就会出现在所有配音工具中。点按“录制”并朗读屏幕上的文字。",
  "Читать полностью": "阅读全文",
  "Голос STEOS": "STEOS 声音",
  "Назад к персонажу": "返回角色",
  "Назад к списку": "返回列表",
  "Актёр STEOS": "STEOS 演员",
  "Персонаж STEOS": "STEOS 角色",
  "Об актёре": "关于演员",
  "О персонаже": "关于角色",
  "Голоса актёра": "演员的声音",
  "Голоса персонажа": "角色的声音",
  "шапка: Мой голос": "我的声音",
  "Пример голоса «{0}»": "“{0}”声音示例",
  "Ещё языки": "更多语言",
  "Юзеры": "用户",
  "Лайки": "点赞",
  "Пол": "性别",
  "В каталоге с": "上架时间",
  "Автор": "作者",
  "Откуда": "出自",
  "Характер": "性格",
  "Голосов": "声音数",
  "Мужской": "男声",
  "Женский": "女声",
  "Детский": "儿童",
  "Не указан": "未指定",
  "Голос персонажа": "角色声音",
  "Выберите поддерживаемый аудиофайл до {0} МБ.": "请选择不超过 {0} MB 的受支持音频文件。",
  "пол: Детский": "童声",
  "Состав подборки": "合集内容",
  "Закрыть выбор голоса": "关闭声音选择",
  "Не удалось открыть запись для прослушивания.": "无法打开录音进行播放。",
  "Использовать готовую запись": "使用现成的录音",
  "Подтвердите права на материалы, чтобы взять запись.": "请确认你拥有素材的权利后再使用该录音。",
  "Работа из доната": "来自打赏的作品",
  "Модель синтеза": "合成模型",
  "Новая модель": "新模型",
  "Прежняя модель": "旧模型",
  "Удерживайте — карточка голоса и модель синтеза": "长按：声音卡片和合成模型",
  "Модель для озвучки в чате": "聊天配音模型",
  "Новая модель: эмоции и живая интонация, вопросы, много языков, клоны голоса": "新模型：情感与自然语调、疑问句、多种语言、声音克隆",
  "Прежняя модель: только пять языков, без эмоций и вопросительной интонации, без клонов": "旧模型：仅五种语言，无情感和疑问语调，不支持克隆",
  "Активная модель: STEOS Voice": "当前模型：STEOS Voice",
  "Активная модель:": "当前模型：",
  "Новая модель: 19 языков, естественное звучание с живыми интонациями — без металла и роботизированности, качественное клонирование голоса": "新模型：19 种语言，语调生动、声音自然，没有金属感和机械感，高质量声音克隆",
  "Прежняя модель: только 5 языков, без эмоций и вопросительной интонации, без клонов голоса": "旧模型：仅 5 种语言，无情感和疑问语调，不支持声音克隆",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из этих языков.": "在 STEOS Voice {0} 模型上，所有声音都支持多语言，可用其中任意一种语言配音。",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из {1}.": "在 STEOS Voice {0} 模型上，所有声音都支持多语言，可用{1}中的任意一种配音。",
  "этих языков": "这些语言",
  "Языки озвучки": "配音语言",
  "Любой голос на модели STEOS Voice {0} озвучит текст на каждом из этих языков": "STEOS Voice {0} 模型上的任意声音都能用以下每种语言配音",
  "Все голоса": "全部声音",
  "Озвучка текста и переозвучка": "文字配音和变声",
  "Переозвучка записи": "录音变声",
  "Меняют голос в вашей записи": "替换你录音中的声音",
  "Выберите голос для переозвучки записи": "选择用于录音变声的声音",
  "Голос выбран — вернитесь в чат и нажмите «Продолжить переозвучку»": "已选择声音——返回聊天并点击“继续变声”"
}
